import LocalizedStrings from 'react-localization'

export const strings = new LocalizedStrings({
  en: {
    ACTIVE_ROLES: 'Active roles',
    ACTUAL_LOCATION: 'Actual location',
    ADD_CURRENT_PAGE_TO_FAVOURITES: 'Add current page to favourites',
    ADD_DOCUMENT: 'Add document',
    ADD_EVENT: 'Add event',
    ADD_ITEM: 'Add item',
    ADD_LINK: 'Add link',
    ADD_ROLE: 'Add role',
    ADD_TO_FAVOURITES: 'Add to favourites',
    ADDITIONAL_INFO_HIDE: 'Hide additional information',
    ADDITIONAL_INFO_SHOW: 'Show additional information',
    ADDITIONAL_VACATION_DAYS_FOR_HOLIDAYS:
      'Additional vacation days for holidays (previous year)',
    ADDITIONAL_VACATION_DAYS_IN_PREVIOUS_YEAR:
      'Additional (social) vacation days in previous year',
    ADDING_A_WORKLOG_NOT_ALLOWED:
      'Adding a worklog for this day is not allowed because the logs have already been confirmed.',
    AFFECTED_EMPLOYEES: 'Affected employees:',
    AFTER: 'After',
    ALL_CATEGORIES_WERE_MAPPED_SUCCESSFULLY:
      'All categories were mapped successfully.',
    ALLOCATION_TYPE_WILL_BE_ARCHIVED_AT: 'allocation type will be archived at',
    ALLOCATION_WITHOUT_ASSIGNED_EMPLOYEES:
      'Allocations without assigned employees',
    APPLY: 'Apply',
    APPROVE: 'Approve',
    ASK_QUESTION: 'Ask a question',
    ARCHIVE_DATE: 'Archive date',
    ARCHIVE_DOCS: 'Archived documents',
    ARCHIVED_PLURAL: 'Archived',
    ARE_YOU_SURE: 'Are you sure?',
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_LINK:
      'Are you sure you want to delete this link?',
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_WORKLOG:
      'Are you sure you want to delete this worklog?',
    AUTHOR: 'Author',
    AUTO_TRACKING: 'Auto tracking',
    AUTO_TRACKING_TEXT: 'Auto tracking text',
    AUTO_TRACKING_TIME: 'Auto tracking time',
    BACK: 'Back',
    GO_TO_MAIN_PAGE: 'Go to main page',
    BEFORE: 'Before',
    BROKEN_TASK: {
      HEADING: 'The task is malfunctioning',
      CONTENT: 'Sorry for the inconvenience.',
    },
    BUDGET_1: 'Budget',
    BUDGET_INFORMATION: 'Budget information',
    CANCEL: 'Cancel',
    CALENDAR_WEEK: 'Calendar week',
    CHANGES: 'Changes',
    CHANGE_ROLE: 'Change member roles',
    CHOOSE: 'Choose',
    CHOSEN_PERIOD_LATER:
      'The chosen period is later than the archive date of the selected allocation type.',
    CLEAR_ALL: 'Clear all',
    CLICK_TO_ADD_WORKLOGS_FROM_GOOGLE_CALENDAR:
      'Click to add worklogs from Google Calendar',
    CLIENT_PROJECT_UTILIZATION:
      'Client Project Utilization % (Over the past year)',
    COLOR: 'Color',
    COLUMN_VISIBILITY: 'Column visibility',
    COMMENT: 'Comment',
    COMMENT_ADD: 'Add a comment',
    COMMENT_VALIDATION_MESSAGE: 'Comment must be at least 3 symbols',
    COMPANY_REGULATIONS: 'Company policy',
    COMPENSATED_VACATION_DAYS: 'Compensated vacation days (last year)',
    COMPLETE: 'Complete',
    COMPLETED: 'Completed',
    CONFIRM: 'Confirm',
    CONTINUE_WITH_SSO: 'Continue with SSO',
    CONTRACT_CANT_BE_DELETED:
      "Contract can't be deleted, as it has at least one linked position",
    CONTRACT_IS_EXPIRED: 'Contract is expired',
    CONTRACT_PERIOD_DOES_NOT_COVER:
      'Contract period does not cover this allocation',
    CONTRACTS_WITH_OVERLAPPING_PERIODS_CANT_BE_ADDED:
      'Contracts with overlapping periods can’t be added',
    COPY: 'Copy',
    COPY_LINK_TO_ERP: 'Copy link to the task in ERP',
    COPY_LINK_TO_PYRUS: 'Copy link to Pyrus task',
    CREATE_ANOTHER: 'Create another',
    CREATE_REQUEST: 'Create request',
    CREATE_TASK: 'Create task',
    CREATE_OUT_OF_ORDER_TASK: 'Create an out-of-order task',
    CREATED_AT: 'Created at',
    CREATED_BY_ME: 'Created by me',
    CREATED_BY_OTHERS: 'Created by others',
    CREATED_DATE: 'Created date',
    CREATION_DAY: 'Creation day',
    CREATION_TIME: 'Creation time',
    CUSTOM: 'Custom',
    CURRENT_STEP: 'Current step',
    DATA_FROM_PREVIOUS_STEPS: 'Данные из предыдущих шагов',
    DAY: 'Day',
    DELETE: 'Delete',
    DEPARTMENT: 'Department',
    DEPARTMENT_1: 'Department',
    DESCRIPTION_SHOULD_BE_NO_LONGER_THAN:
      'Description should not be longer than 500 characters',
    DESCRIPTION_IS_MANDATORY: 'Field description is mandatory',
    DESIGN: 'Design',
    DEVELOPMENT_CONTRACT: 'Development contract',
    DOES_NOT_EXIST: 'Does not exist',
    DO_NOT_FORGET_TO_GRANT_ACCESS_AND_EDITING_RIGHTS:
      'Do not forget to grant access and editing rights to the document in advance for',
    DOCUMENT_TYPE: 'Document type',
    DOCUMENT_TYPE_IS_MANDATORY: 'Field Document type is mandatory',
    DOCUMENTATION: 'Documentation',
    DONE: 'Done',
    DURATION: 'Duration',
    DURATION_H: 'Duration (h)',
    EDIT: 'Edit',
    EDIT_PERIOD: 'Edit period',
    EDIT_AVATAR: 'Edit profile photo',
    EDIT_WORKLOG: 'Edit worklog',
    EDITABLE_UNTIL: 'Editable until',
    EDITING_CLOSED: 'Editing closed at',
    EDUCATION: 'Education',
    EMPLOYEE_TYPE_1: 'Employee type',
    EMPLOYEES_HEATMAP: 'Employees Heatmap',
    ENGINEERING_MANAGER: 'Engineering manager',
    ENGINEERING_MANAGERS: 'Engineering managers',
    ENTER: 'Enter',
    EMPLOYEE_BECOMES_INACTIVE_WHEN_ALLOCATION_PERIOD_ENDS:
      "Employee becomes 'inactive' when allocation period ends",
    EMPLOYEE_STAY_ACTIVE_WITH_AN_ACTIVE_ALLOCATION:
      'Employee stays active with an active allocation or linked branch membership.',
    ENTER_DATE: 'Enter date',
    ENTER_VALID_EMAIL_ADDRESS: 'Enter valid email address',
    ENTER_VALID_URL: 'Enter valid URL',
    ERP_SUPPORT: 'ERP Support',
    ERROR_INCORRECT_TIME_VALUE: 'Incorrect time value',
    ERROR_TASK_NAME_LENGTH: 'Task name should be no longer than 100 symbols',
    ERROR_TASK_NAME_REQUIRED: 'Field task name is mandatory',
    ERROR_TIME_GREATER_THAN:
      'Auto tracking time should not be longer than 8 hours',
    ERROR_TIME_REQUIRED: 'Auto tracking time should be greater than 0 h 0 min',
    ERROR_TIMELOG_TEXT_LENGTH:
      'Auto tracking text should be no longer than 100 symbols',
    ERROR_TIMELOG_TEXT_REQUIRED:
      'Auto tracking text is mandatory for Auto tracking task',
    ERROR_TITLE_LENGTH: 'Title should be no longer than 100 symbols',
    ERROR_TRANSFER:
      'Transfer is only possible within a single month. Please select valid dates.',
    ERROR_TRANSFER_DAY:
      'Day rescheduling is only possible within a single month. Please select valid dates.',
    ERROR_TRANSFER_TIME:
      'Time rescheduling is only possible within a single month. Please select valid dates.',
    EVENTS: 'Events',
    EVENTS_ON: 'Events on',
    EXIST: 'Exist',
    EXPORT: 'Export',
    EXPORT_ALLOCATION_PLAN: 'Export allocation plan',
    EXPORT_TYPE: 'Export type',
    FOR: 'for',
    FAILED_TO_ADD_WORKLOG:
      'Failed to add worklog to Jira. Please check your internet connection and try again.',
    FAILED_TO_DELETE_WORKLOG:
      'Failed to delete worklog. Please try again later.',
    FIELD_DATE_IS_MANDATORY_FOR_DEVELOPMENT_CONTRACTS:
      'Field Date is mandatory for development contracts',
    FILTER_BY: 'Filter by',
    FILTER_BY_AUTHOR: 'Filter by author',
    FILTER_BY_STATUS: 'Filter by status',
    FILTER_BY_TYPE: 'Filter by type',
    FINANCE_SUPPORT: 'Finance Support',
    FISCAL_WEEK: 'Fiscal week',
    FLEXIBLE_HOLIDAYS: 'Flexible holidays',
    FROM: 'from',
    GOOGLE_CALENDAR_EVENTS: 'Google Calendar Events',
    GOOGLE_CALENDAR_SYNC: 'Sync with Google Calendar',
    GROUP_BY: 'Group by',
    HEALTH: 'Health',
    HELP_BLOCK: 'Help block',
    HIDE_THIS_ALLOCATION_FROM_CALENDAR_VIEW:
      'Hide this allocation from the calendar view',
    IN_WORK: 'In work',
    INTEGRATION: 'Integration',
    INVALID_HIERARCHY: 'Invalid hierarchy:',
    JIRA_RELATED_TASK_CANT_BE_UPDATED_OR_DELETED:
      "Jira related task can't be updated or deleted",
    GENERAL_1: 'General',
    GENERAL: 'General',
    GENERAL_BLOCK: 'General block',
    GENERAL_INFORMATION: 'General information',
    GENERAL_SUPPORT: 'General Support',
    GO_TO: 'Go to',
    GOOGLE_MEETS_CATEGORIES_LINKING: 'Google meets categories linking',
    HANG_TIGHT: "Hang tight, we'll be back before you know it!",
    HOLIDAYS: 'Holidays',
    HOUR: 'h',
    HOURS: 'Hours',
    INTERNAL: 'Internal',
    LAST_MONTH: 'Last month',
    LAST_THREE_MONTHS: 'Last three months',
    LAST_SIX_MONTHS: 'Last six months',
    LAST_WORKING_DAY: 'Last working day',
    LEAVE: 'Leave',
    LEGAL: 'Legal',
    LEGEND_PROJECT_TYPE_WITH_TENTATIVE: 'Project type, Tentative: No',
    LEGEND_TOTAL: '8 hours',
    LEGEND_TOTAL_LESS: 'Less than 8h',
    LEGEND_TOTAL_MORE: 'More than 8h',
    LIMIT_CHANGES: 'Limit changes',
    LINK: 'Link',
    LINK_CATEGORIES: 'Link categories',
    LINK_IS_MANDATORY: 'Field Link is mandatory',
    LINK_SHOULD_START: 'Link should start with "/"',
    LINK_SUCCESSFULLY_ADDED: 'Link successfully added.',
    LINK_SUCCESSFULLY_UPDATED: 'Link successfully updated.',
    LIST_IS_EMPTY: 'The list is empty',
    JIRA_SYNC: 'Sync period w/ JIRA',
    LOGGED_ON: 'Logged on ',
    MANAGEMENT: 'Management',
    MONTH_1: 'Month',
    MEETING_INDICATORS: {
      EMPLOYEE_PERFORMANCE: 'Employee performance',
      HAPPINESS_INDEX: 'Happiness index',
      IMPACT_OF_LEAVING: 'Impact of leaving',
      RISK_OF_LEAVING: 'Risk of leaving',
    },
    MEETING_INDICATOR_VALUES: {
      EXCEED_EXPECTATIONS: 'Exceed expectations',
      EXCITED: 'Excited',
      FRUSTRATED: 'Frustrated',
      GOOD: 'Good',
      GREAT: 'Great',
      HIGH: 'High',
      LOW: 'Low',
      MEDIUM: 'Medium',
      MEET_EXPECTATIONS: 'Meet expectations',
      NEED_IMPROVEMENT: 'Need improvement',
      NEUTRAL: 'Neutral',
      OUTSTANDING: 'Outstanding',
      UNACCEPTABLE: 'Unacceptable',
    },
    NAME: 'Name',
    NEW: 'New',
    STATISTICS: 'Statistics',
    NEXT: 'Next',
    NEXT_FISCAL_WEEK: 'Next fiscal week',
    NO: 'No',
    NO_ACTIVE_ALLOCATIONS: `There aren't any active allocations\nwith this position`,
    NO_AVAILABLE_FORMS: 'No available forms found',
    NO_DESCRIPTION: 'No description',
    NO_LINKS_YET: 'No links yet',
    NO_RESULTS_FOUND: 'No results found',
    NO_TASKS: 'No tasks',
    NO_WORKLOGS_FOUND: 'There are no worklogs for the period',
    NOT_COMPLETED: 'Not completed',
    NOT_FOUND: 'Not found',
    NOT_READ: 'Not read:',
    NO_ROLES: 'No roles available',
    NOTHING_FOUND: 'Nothing found',
    NOT_FOUND_PROFILE: 'Profile not found, contact your administrator',
    OF: 'Of',
    OK: 'Ok',
    ONLY_LATIN: ' Only Latin, numbers and "-" symbol are allowed',
    ONLY_ACTIVE_ALLOCATIONS: 'Only active allocations',
    ONLY_TENTATIVE_ALLOCATIONS: 'Only tentative allocations',
    ONLY_PLACEHOLDER: 'Only placeholder',
    OPEN: 'Open',
    OPEN_IN_PYRUS: 'Open form in Pyrus',
    OPEN_TASKS_IN_PYRUS: 'Open tasks in Pyrus',
    PAGE_NOT_EXIST: 'The page you are requesting does not exist.',
    PAGE_REMOVED_OR_OUT_OF_DATE: 'It may have been removed or out of date.',
    PART_TIME: 'Part-time',
    PARTIAL_CONTRACT_COVERAGE: 'Partial contract coverage',
    PASTE_LINK: 'Paste link',
    PERIOD: 'Period',
    YOU_DONT_HAVE_PERMISSION: "You don't have permission to access this page.",
    PLEASE_CONTACT_US_SUPPORT:
      'Please, contact us via the support form if you have any questions.',
    PICK_A_DATE: 'Pick a date',
    PICK_A_PERIOD: 'Pick a period',
    PLANNED_TIME: 'Planned',
    PLACEHOLDER: 'Placeholder',
    PLEASE_CONTACT_US: {
      PART_ONE: 'Please, contact us via the ',
      PART_TWO: ' if you have any questions.',
    },
    POSITION: 'Position',
    POSITION_CARD_CANT_BE_DELETED_ACTIVE_ALLOCATION:
      "Position card can't be deleted as it has at least one linked active allocation.",
    POSITION_CARD_CANT_BE_DELETED_INACTIVE_ALLOCATION:
      "Position card can't be deleted as it has at least one linked inactive allocation.",
    POSITION_NAME: 'Position name',
    POSITIONS: 'Positions',
    PROJECT_INFORMATION: 'Project information',
    PROJECT_STATUSES_ARE_ABSENT: 'Project statuses are absent',
    PUBLICATIONS: 'Publications',
    PYRUS_ID: 'ID',
    REASON: 'Reason',
    REASON_FOR_CREATING_EVENT: 'Reason for creating event',
    REASON_FOR_CANCELING_EVENT: 'Reason for canceling event',
    REASON_FOR_RESTORING_EVENT: 'Reason for restoring event',
    RESOURCE_MANAGEMENT: 'Resource Management',
    RESOURCE_PLANNING: 'Resource Planning',
    QUIT_FROM_FORM: 'Are you sure you want to quit this form?',
    RECURRENT: 'Recurrent',
    RECURRING_TASKS: 'Recurring tasks',
    REFERRAL: 'Referral',
    REGISTY: 'Registry',
    REJECT: 'Reject',
    REMOTE: 'Remote',
    REMOVE: 'Remove',
    REQUIRE_ACTION: 'Require action',
    RESOLVED_BY: 'Resolved by',
    REVOKE: 'Revoke',
    ISSUE_IS_NOT_RESOLVED: 'Issue is not resolved',
    IN_THIS_MONTH: 'in this month',
    RESET: 'Reset',
    REST_VACATION_DAY: 'AVAILABLE of the vacation days on',
    REVIEW_DATE: 'Review date',
    ROLES: 'Roles',
    RUN_MANUALLY: 'Run manually',
    SAVE: 'Save',
    SAVING: 'Saving...',
    SEARCH: 'Search',
    SEARCH_FORM: 'Search form',
    SEARCH_BY_HR: 'Search by HR',
    SEARCH_BY_MENTOR: 'Search by Mentor',
    SELECT: 'Please select',
    SELECT_ALL: 'Select all',
    SELECT_DOCUMENT_TYPE: 'Select document type',
    SELECT_FLOAT_PROJECT: 'Select float project',
    SELECT_FROM: 'Select from',
    SELECT_PROJECT_TYPE: 'Select project type',
    SELECT_ROLE: 'Select role',
    SELECT_TO: 'Select to',
    SELECT_TASK: 'Select task',
    SELECT_TASK_FOR_THIS_COLOR: 'Select task for this color',
    SEND: 'Send',
    SENDING: 'Sending',
    SHARE_LINK: 'Share link',
    SHARE_WITH: 'Share with',
    SHARED_WITH: 'Shared with',
    SHOW_DETAILS: 'Show details',
    SHOW_LEGEND: 'Show legend',
    SHOW_LESS: 'Show less',
    SHOW_MORE: 'Show more',
    SHOW_MY_PROJECTS: 'Show my projects',
    SICK_LEAVE_REQUEST: 'Sick leave Request',
    SINCE: 'since',
    SKIP: 'Skip',
    SPECIALITY: 'Speciality',
    SPECIALITY_1: 'Speciality',
    STATUS: 'Status',
    STATUSES: 'Statuses',
    SYNCHRONIZATION_COMPLETED_SUCCESSFULLY:
      'Synchronization completed successfully.',
    SYNCHRONIZATION_COULD_NOT_BE_COMPLETED:
      'Synchronization could not be completed. Please contact support.',
    SUBMIT: 'Submit',
    SUBSCRIBE: 'Subscribe',
    FAKE_THE: 'The',
    SUM_OF_HOURS: 'sum of hours',
    IN_ALLOCATION_TYPES_IS_HIGHER_THAN_THE:
      'in allocation types is higher than the',
    NUMBER_OF_HOURS: 'number of hours',
    NO_EVENTS_FOUND_FOR_TODAY: 'No events found for today',
    IF_NO_TASK_IS_SPECIFIED:
      'If no task is specified, the mapping for this row will not be applied.',
    IN: 'in',
    SUPERVISOR: 'Supervisor',
    SUPPORT_FORM: 'support form',
    TASK_FINISHED: 'Finished the task',
    TASK_NAME: 'Task name',
    TASK_REOPENED: 'Reopened the task',
    TASK: 'Task',
    TASKS: 'Tasks',
    TEMPORARY_UNAVALIABLE: 'The page is temporarily unavailable.',
    TENTATIVE: 'Tentative',
    TENTATIVE_ALLOCATION: 'Project type, Tentative: Yes',
    TENTATIVE_TAG: 'Tentative',
    TEXT_SHOULD_NOT_BE_LONGER_THAN: 'Text should not be longer than 16 symbols',
    THE_EVENT_WON_T_BE_ADDED_UNLESS_YOU_SELECT:
      'The event won’t be added unless you select both a project and a task.\nYou can assign it later if needed.',
    THE_REASON_CANNOT_EXCEED: 'The reason cannot exceed 1000 characters.',
    THIS_FIELD_IS_MANDATORY: 'This field is mandatory',
    THIS_IS_NOT_VALID_LINK: 'This is not a valid link',
    THIS_MONTH: 'This month',
    THIS_PARAMETER_CANT_BE_CHANGED_FOR_INACTIVE_ALLOCATION:
      "This parameter can't be changed for inactive allocation",
    THREE_MONTH: 'Three months',
    TILL: 'till',
    TIME: 'Time',
    TIME_IS_TRACKED_DAILY:
      'Once linked, time is tracked daily. Press the date button to force a sync.',
    TIME_SHOLUD_BE_NO_GREATER_THAN: 'Time should be greater than 0h 0m',
    TIME_RANGE:
      'The number of hours entered must be greater than 0 and not exceed 8',
    TITLE_IS_MANDATORY: 'Field Title is mandatory',
    TO: 'To',
    TO_EDIT_A_PERIOD:
      'To edit a period, choose one project and at least one allocation.',
    TO_SAVE_WORKLOG: 'to save worklog',
    TODAY: 'Today',
    TOTAL_AVAILABLE_VACATION_DAYS_CURRENT_YEAR:
      'Total available vacation days (current year)',
    TOTAL_AVAILABLE_VACATION_DAYS_PREVIOUS_YEAR:
      'Total available vacation days (previous year)',
    TOTAL_LOGGED_TIME: 'Total logged time',
    TOTAL_PROJECT: 'Total (project)',
    TRY_AGAIN: 'Try again',
    TYPE: 'Type',
    TYPE_DOCUMENT_TITLE: 'Type document title',
    TYPE_HOURS: 'Type hours',
    TYPE_REASON: 'Type reason',
    TYPE_TASK_NAME: 'Type task name',
    TYPE_OF_PARTNERSHIP: 'Type of partnership',
    TWO_HRS_CANT_BE_EACH_OTHER_SUPERVISORS:
      'two HRs cannot be each other’s supervisors.',
    TWO_MENTORS_CANT_BE_EACH_OTHER_SUPERVISORS:
      'two mentors cannot be each other’s supervisors.',
    UNABLE_TO_SEND_WORKLOG_TO_JIRA:
      'Unable to send worklog to Jira due to a system error. Please try again later or contact support if the issue persists.',
    UNSELECT_ALL: 'Unselect all',
    UNSUBSCRIBE: 'Unsubscribe',
    UPDATE: 'Update',
    UPLOAD_FILE: 'Upload new file',
    USED_VACATION_DAYS: 'Used Vacation Days (Last Year)',
    USER_AVATAR: 'User avatar',
    VACATION_POLICY: 'Vacation policy',
    VACATION_REQUEST: 'Vacation Request',
    VIEW_PROFILE: 'View profile',
    VIEW_RESOURCE_PLANNING: 'View in Resource planning',
    YES: 'Yes',
    WEEK_1: 'Week',
    WIKI: 'Wiki',
    WORKED_DAYS_IN_PREVIOUS_YEAR: 'Worked days in previous year',
    WORKLOG_DELETED_SUCCESSFULLY: 'Worklog was deleted successfully!',
    WORKLOG_SAVED_SUCCESSFULLY: 'Worklog saved successfully!',
    WORKLOG_SUCCESSFULLY_ADDED_TO_JIRA: 'Worklog added to Jira successfully!',
    WORKLOG_UPDATED_SUCCESSFULLY: 'Worklog updated successfully!',
    WORKLOGS: 'Worklogs',
    WORKLOGS_IMPORTED_FROM_JIRA:
      "Worklogs imported from Jira.\nData in this row can't be edited or deleted.",
    WORKLOGS_WAS_SUCCESSFULLY_ADDED: 'Worklog(s) was successfully added',
    WORKLOGS_WASN_T_ADDED: "Worklog(s) wasn't added",
    WORKPLACE: 'Workplace',
    WRONG_FORM_FIELD: `Can't send form. There is wrong value '{value}' in '{field}' field`,
    SPECIALIZED_FORMS: 'Specialized forms',

    BUDGET: {
      AVAILABLE: 'Available budget',
      BALANCE: 'Balance',
      EDIT: 'Edit budget',
      EXPECTED_BALANCE: 'Expected balance',
      EXPECTED_ESTIMATE: 'Expected estimate',
      HOURS_PER_MONTH: 'hours per month',
      HOURS_SPENT: 'Hours spent',
      MONTH: 'Month',
      MONTHLY_BUDGET: 'Monthly budget',
      ORIGINAL_BALANCE: 'Original balance',
      SELECT_ALL_DATA: 'Select All Data',
      SELECT_SOW: 'Select a SOW',
      TASK: 'Task',
      TOTAL_COSTS: 'Total project costs:',
      WORKED_HOURS: 'Worked out hours',
    },
    FILES: {
      ATTACHMENTS: 'Project attachments',
      LINKS: 'Project links',
      PLACEHOLDER_LINK: 'Attach from external link',
      PLACEHOLDER_LINK_NAME: 'Grant this link a humanized name',
      UPLOAD_DOCUMENT: 'Upload document',
    },

    INFO: {
      CONTACTS: 'Contacts',
    },

    PROJECT_CARD: {
      NOT_ASSIGNED: 'Not assigned',
      NUMBER_OF_PARTICIPANTS: 'Number of participants',
      PM: 'Project Manager',
      TL: 'Team Lead',
      TOOLTIPS: {
        PM: 'PM must be present for the project',
        TL: 'TL must be present for the project and must be at least of middle level',
      },
      UNKNOWN: 'Unknown',
    },

    SOW: {
      CREATE: 'Create new SOW',
      JIRA_SYNCH: 'Sync with Jira',
      LAST_SYNC: 'Last synchronization was:',
      RELEASED: 'Released',
      UNRELEASED: 'Unreleased',
    },

    NOTIFICATION: {
      ADDED_SKILL: 'New skill with rating has been successfully added',
      ALLOCATION_CREATE_SUCCESS: 'Allocation has been successfully created.',
      ALLOCATION_UPDATE_SUCCESS: 'Allocation has been successfully updated.',
      ALLOCATION_DELETE_SUCCESS: 'Allocation has been successfully deleted.',
      ATTACH_SUCCESS: 'The file from the link has been successfully attached!',
      BIG_SIZE_FILE_ERROR:
        'The file you are trying to upload exceeds allowed size of 100MB',
      BRANCH_UPDATE:
        "The branch field is changed successfully. The list of team members will be updated. It's going to take some time, please go back later.",
      BUDGET_CREATE: 'This month budget was created!',
      BUDGET_UPDATE: 'This month budget was successfully updated!',
      CHANGES_SAVE: 'Changes are saved',
      CLIENT_DETAIL_UPDATE: 'Client detail has been successfully updated!',
      CODE_FROM_BACKEND: 'From the backend was received status of code',
      CREATE_ACTION_ITEM: 'You have successfully created an Action item.',
      CREATE_OTO_MEETING:
        '1-1 has been created successfully! You may edit or delete this 1-1 until',
      DATA_EXPORT_FAILED: 'Data export failed',
      DATA_UPLOAD: 'Please wait, the file formation will take some time.',
      DATA_WAS_SUCCESSFULLY_EXPORTED: 'Data was successfully exported',
      DELETED_ACTION_ITEM: 'Action item was successfully deleted',
      DELETED_FEEDBACK_REQUEST: 'Feedback request was successfully deleted',
      DELETED_HEATMAP_VIEW: 'The view has been successfully deleted!',
      DELETED_OTO_MEETING:
        'The one-to-one meeting has been successfully deleted!',
      DOCUMENT_UPLOAD: 'Document has been successfully uploaded!',
      DOC_UPLOAD: 'Document has been successfully uploaded!',
      EMPTY_ACTION_NAME: 'Action name can not be empty',
      EMPTY_FEEDBACK: 'Feedback message can not be empty',
      EMPTY_MESSAGE: 'Your message is empty',
      EMPTY_REPLY_FIELD: 'Reply field cannot be empty',
      ENTER_SKILL_NAME: 'Please, enter the skill name',
      ENTER_VALID_DATE: 'Please, enter a valid date',
      ENTER_VALID_TIME: 'Please, enter a valid time',
      ERROR_UPLOAD_AVATAR: 'There is an error occured while uploading avatar!',
      ERROR_SET_COOPERATION_FINISHED:
        "You can't set 'cooperation finished' date until project will be in status 'Closed'!",
      ESTIMATE_UPDATE: 'Estimate has been updated!',
      FAILED_JIRA_SYNCH: "Synchronization with Jira wasn't successful",
      FAILED_GET_TASKS: 'Failed to get the task list. Please try again later.',
      FILE_RENAMED: 'File has been successfully renamed!',
      FILL_CORRECT_DATE_AND_TIME:
        "Please, fill correct 'Date' and 'Time' fields",
      FILL_DATE_AND_BUDGET:
        "Please, provide a title and fill 'Date' and 'Budget' fields",
      FILL_DATE_AND_TIME:
        "Please, provide a user and fill 'Date' and 'Time' fields",
      FILL_FIELDS: 'Some fields are not filled in',
      FILL_SICK_LEAVE_REQUEST_FORM: 'Fill the sick leave request form',
      FILL_VACATION_REQUEST_FORM: 'Fill the vacation request form',
      FILL_REMOTE_WORK_REQUEST_FORM: 'Fill the remote work request form',
      FINISH_OTO_CARD: 'You successfully finished one to one card!',
      JIRA_SYNC: {
        SUCCESSFULLY:
          'JIRA synchronization has been successfully started. It will take some time. You will get a notification to 🔔 when it is complete',
        FAILED_MESSAGE_BEGIN: 'Something went wrong.',
        FAILED_MESSAGE_END: "can't be synced. Please, try again later.",
        ALREADY_IN_PROGRESS:
          'JIRA synchronization is in progress already. Please wait until it is complete before starting it again. You will get a notification to 🔔 when it is complete',
      },
      HTTP_STATUS_CODES: {
        500: 'Server error occurred',
      },
      LINK_IS_COPIED: 'Link is copied',
      LINK_UNABLE: 'Unable to copy link',
      NOT_CHANGED_ACTION:
        'Action item state has not been changed, the server returned an error',
      NOT_COMPLETED_REQUEST: 'Please, wait until is request will be completed',
      NOT_CREATED_ACTION:
        'New action item has not been created, the server returned an error',
      NOT_CREATED_COMMENT:
        'New comment has not been created, the server returned an error',
      NOT_CREATED_OTO_MEETING:
        'New one-to-one meeting has not been created, the server returned an error',
      NOT_DELETED_ACTION:
        'Action item has not been deleted, the server returned an error',
      NOT_FINISHED_MEETING: 'Meeting can not be finished',
      NOT_LOADED_FEEDBACKS:
        'Employee feedbacks has not been loaded, the server returned an error',
      NOT_LOADED_OTO_LIST:
        'One-to-ones list has not been loaded, the server returned an error',
      NOT_LOAD_EMPLOYEES_LIST:
        'Employees list has not been loaded, the server returned an error',
      NOT_POSTED_FEEDBACK:
        'Your reply has not been sent, the server returned an error',
      NOT_SENT_REQUEST:
        'Your request has not been created, the server returned an error',
      NOT_SHARED_OTO:
        'One-to-one has not been shared, the server returned an error',
      NOT_UPDATED_ACTION_ITEM:
        'Action item has not been updated, the server returned an error',
      NOT_UPLOAD_MULTIPLE_FILES: "You can't upload multiple files",
      NO_FILENAME: 'Filename must be present',
      NO_LINK_PDP:
        "Career manager responsible for this employee hasn't attached a PDP link yet!",
      NO_PERMISSIONS: "You don't have permissions",
      NO_PRIVILEGES: 'You have not enough privileges',
      NO_TASKS: 'You do not have any tasks',
      ONE_ROLE_IN_TEAM:
        'This role could be assigned only to one user per team!',
      OPTIMISTIC_BUDGET_GREATER_EXPEXTED_ERROR:
        'Optimistic budget cannot be greater than expected budget. Please enter a valid data.',
      PAGE_NOT_FOUND: 'Page not found',
      POSTED_FEEDBACK: 'You have successfully replied to the feedback request',
      PROJECT_CREATE: 'Project has been successfully created!',
      PROJECT_UPDATE: 'The project has been successfully updated!',
      PROVIDE_FIELDS_COMPLETED: 'Please, provide all fields completed',
      PROVIDE_REVIEW_DATE: 'Please, provide review date',
      PROVIDE_VALID_PDP_LINK: 'You need to provide a valid PDP link',
      RELEASE_BEFORE_START_ERROR:
        'Release date can not be before start date. Please enter a valid date',
      SCHEDULE_SAVED: 'Schedule successfully saved',
      SHARED_FEEDBACK: 'Feedback has been successfully shared!',
      SHARED_ONE_TO_ONE: 'One-to-one has been successfully shared!',
      SERVER_ERROR: 'A server error occured!',
      SENT_FORM: 'The form has been sent successfully',
      SENT_REQUEST: 'You have successfully created the feedback request',
      SKILL_ALREADY_ATTACHED: 'This skill is already attached',
      SKILL_EMPTY: 'Skill name can not be empty!',
      SKILL_EXIST: 'This skill name already exist!',
      SOW_CREATE: 'SOW has been successfully created!',
      SOW_UPDATE: 'SOW has been successfully updated!',
      SPECIFIC_PERSON_EMPTY: "The 'Specific Person' field cannot be empty!",
      SUBSCIBED_TO_ALL: 'Successfully subscribed to all!',
      SUCCESS_JIRA_SYNCH: 'Synchronization with Jira was successful!',
      SUCCESSFULLY_SUBSCRIBED: 'Successfully subscribed!',
      SUCCESSFULLY_UNSUBSCRIBED: 'Successfully unsubscribed!',
      TIME_REPORT_UPDATE: 'Time report has been successfully updated!',
      UNCONFIRMABLE_TIMELOGS:
        'Some of the timelogs cannot be changed to the «Confirmed» status. Timelogs must be in «Imported» or «Rejected» status to be converted to «Confirmed».',
      UNIT_CREATE: 'Unit has been successfully created!',
      UNIT_DELETE: 'Unit has been successfully deleted!',
      UNIT_EXIST: 'This unit name already exists!',
      UNIT_UPDATE: 'Unit has been successfully updated!',
      UNSHARED_FEEDBACK: 'Access to the feedback has been revoked!',
      UNSHARED_ONE_TO_ONE: 'Access to the 1-1 has been revoked!',
      UNREVOKABLE_TIMELOGS:
        'Some of the timelogs cannot be changed to the "Imported" status. Timelogs must be in «Rejected» or «Confirmed» status to be converted to «Imported».',
      UNSUBSCRIBED_FROM_ALL: 'Successfully unsubscribed from all!',
      UPDATED_AVATAR: 'Your avatar has been successfully updated!',
      UPDATED_OTO_MEETING:
        'The one-to-one meeting has been successfully updated!',
      UPDATED_PERSONAL_INFO:
        'Current personal information has been successfully updated!',
      UPDATED_REVIEW: "Employee's review was successfully updated",
      WAIT: 'Please wait',
    },

    //action items
    ACTION_ITEM_ACTIVE: 'Active',
    ACTION_ITEM_TITLE: 'Action Items',
    COMING_SOON: 'Coming soon',
    SUBJECT: 'Subject',

    //tables WT
    TABLES_WT: {
      ABSENT: 'A',
      ACTIVE_PROJECTS: 'Active projects',
      ADD_ADJUSTMENT: 'Add adjustment',
      ADD_SALES_FACT: 'Add sales fact',
      ADJUSTMENT: 'Adjustment',
      ADJUSTMENTS: 'Adjustments',
      ADJUSTMENT_SUCCESSFULLY_ADDED: 'Adjustment has been successfully added.',
      ADJUSTMENT_SUCCESSFULLY_DELETED:
        'Adjustment has been successfully deleted.',
      ALL_LOGGED_TIME: 'Logged time on all projects at this day',
      ALL_PROJECTS: 'all projects',
      ANOTHER_DELIVERY_UNIT: 'Another Delivery Unit',
      APPROVE_MODE: 'Approve mode',
      APPROVED: 'Approved',
      APPROVED_HOURS: 'Approved Hours',
      APPROVE_ALL_USERS: 'Approve all users',
      APPROVE_ALL_USERS_WITH_RIGHT_TIME: 'Approve all users with right time',
      APPROVED_STATUS: 'Status is approved',
      ARE_YOU_SURE_TIMELOGS_APPROVED:
        'Are you sure you want to approve worklogs from ',
      ARE_YOU_SURE_TIMELOGS_CONFIRMED:
        'Are you sure you want to confirm worklogs from ',
      ARE_YOU_SURE_TIMELOGS_REJECTED:
        'Are you sure you want to reject worklogs from ',
      ARE_YOU_SURE_TIMELOGS_REVOKED:
        'Are you sure you want to revoke worklogs from ',
      AWAITING_APPROVAL: 'Awaiting approval',
      CAPACITY: 'Capacity',
      CLEAR_ALL_USERS: 'Clear all users',
      CLOSE_PERIOD: 'Close period',
      CLOSED: 'Closed',
      CLOSED_STATUS: 'Status is closed',
      COPY_DESCRIPTION_TO_ALL: 'Copy description to all',
      COMMENTS: 'Comments',
      COMPARE_TABLE: 'Compare table',
      CONFIRMED: 'Confirmed',
      CONFIRMED_STATUS: 'Status is confirmed',
      DELIVERY_DIRECTOR_TOGGLE: 'Delivery Director mode',
      DESCRIPTION_ERROR_LONGER_THAN:
        'The reason should contain at least 3 symbols',
      DIVIDE: 'Divide',
      DURATION: 'Duration',
      EDITED: 'edited',
      EMPLOYEE: 'Employee',
      EMPLOYEE_WILL_NOT_BE: "Employee won't be",
      ERRORS: 'Errors',
      EQUATE_TO_PLAN: 'Equate to the plan',
      EVENT_TYPES: 'Event types',
      EXCLUDE_TIME_OFFS: 'Exclude time-off from calculation',
      FOR: 'For',
      FORM_ERROR_LONGER_THAN: 'Description must be longer than 3 characters',
      FORM_ERROR_MORE_THAN: "Time value can't be equal more than 12",
      FORM_ERROR_NEGATIVE: "Time value can't be negative",
      FORM_ERROR_OVER_LIMIT:
        "The sales fact of one day can't be more than 12 hours. Please, check Sales fact .",
      FORM_ERROR_SALES_FACT_WRONG_PATTERN:
        "Entered value doesn't respond to the required standard. It must be a multiple of 0.25 (Example: 3 or 3.25 or 3,75)",
      FORM_ERROR_SHORTER_THAN: 'Description must be shorter than 25 characters',
      FORM_ERROR_TIME_OFFS:
        "Sales fact can't be divided this period due to time-offs",
      FORM_ERROR_WRONG_PATTERN:
        "Time must match pattern 'number', or 'number.number', or 'number,number', example: 3, or 3.5, or 3,5",
      HIDDEN_LOGGED_TIME_H: 'Hidden Logged Time (h)',
      HIDE_APPROVED: 'Hide approved',
      HIDE_CLOSED: 'Hide closed',
      HOLIDAY_OR_WEEKEND: 'Holiday or weekend',
      INVOICED: 'Invoiced',
      INVOICED_STATUS: 'Status is invoiced',
      LAST_FISCAL_WEEK: 'Last fiscal week',
      LEGEND_LOGGED_HOURS: 'The sum of hours logged in Jira or Time tracking',
      LEGEND_PLANNED_HOURS: 'The sum of hours from Resource planning',
      LEGEND_SALES_FACT: 'The sales fact',
      LEGEND_CAPACITY:
        "The employee's availability in hours (excluding vacation and sick leave)",
      LEGEND_APPROVED_HOURS: 'The sum of logs in Approved status',
      LEDEND_VARIANCE: 'The difference between the Logged Hours and Capacity',
      LOGGED: 'Logged',
      LOGGED_HOURS: 'Logged Hours',
      LOGGED_NOT_EQUAL_PLANNED:
        'The next users logged time, planned time, and sales fact don’t match or are equal to 0.',
      LOGGED_TIME_H: 'Logged Time (h)',
      LOGGED_TIME_ON_OTHER_PROJECT: 'Logged time at this day on project ',
      LOGGED_TIME_ON_THIS_PROJECT: 'Logged time on this project at this day',
      MANUAL_DIVISION: 'Manual division',
      NO_DATA_WTC:
        'There is no delivery unit or department that you would be the manager of.',
      NO_DATA_WTA:
        'There is no project or branch that you would be the manager of.',
      NO_EVENTS: 'No events',
      NO_LOGGED_TIME_ON_OTHER_PROJECTS:
        'No logged time on other projects at this day',
      NO_LOGS_FOUND: 'No logs/adjustments found',
      NO_MEMBERS: 'There are no members in the project yet',
      NO_PLANNED_TIME_ON_OTHER_PROJECTS:
        'No planned time on other projects at this day',
      OPEN_MODAL_MESSAGE: 'Are you sure you want to unlock the period from',
      OPEN_PERIOD: 'Open period',
      PLANNED: 'Planned',
      PLANNED_HOURS: 'Planned hours',
      PLANNED_TIME_H: 'Planned Time (h)',
      PLANNED_TIME_ON_OTHER_PROJECT: 'Planned time at this day on project',
      PLANNED_TIME_ON_THIS_PROJECT: 'Planned time on this project at this day',
      NO_TIMELOGS: 'No timelogs for submit',
      NO_TIMELOGS_FOR_REVOKE: 'No timelogs for revoke',
      REACHED_CHARACTER_LIMIT: "You've reached the character limit",
      REASON_FOR_OPEN_PERIOD: 'Reason',
      REASON: 'Reason',
      REJECTED: 'Rejected',
      REJECT_ALL_USERS: 'Reject all users',
      REJECT_TIMELOGS_MODAL_INPUT_PLACEHOLDER: 'Type description',
      REJECT_TIMELOGS_MODAL_INVALID_INPUT_TEXT:
        'Description must be longer than 3 characters',
      REJECTED_LOGS: 'Rejected logs',
      REMOVE_ADJUSTMENT: 'Remove adjustment',
      REMOVE_ADJUSTMENT_MESSAGE: 'This operation cannot be undone.',
      REMOVE_ADJUSTMENT_TITLE:
        'Are you sure you want to delete the adjustment? ',
      REMOVE_ALL_SALES_FACTS: 'Remove all',
      SALES_FACT: 'Sales fact',
      SALES_FACTS: 'Sales facts',
      SALES_FACT_FOR_PERIOD: 'Total divided sales fact:',
      SALES_FACT_SUCCESSFULLY_ADDED: 'Sales fact has been successfully added',
      SALES_FACT_SUCCESSFULLY_DELETED:
        'Sales fact has been successfully deleted',
      SALES_FACTS_SUCCESSFULLY_DELETED:
        'Sales facts has been successfully deleted',
      SELECT_USER_FOR_APPROVE: 'Select a user with logs that can be approved',
      SELECT_USER_FOR_CLOSE_PERIOD: 'Select a user with logs to close period',
      SELECT_USER_FOR_CONFIRM: 'Select a user with logs that can be confirmed',
      SELECT_USER_FOR_OPEN_PERIOD: 'Select a user with logs to open period',
      SELECT_USER_FOR_REJECT: 'Select a user with logs that can be rejected',
      SELECT_USER_FOR_REVOKE: 'Select a user with logs that can be revoked',
      SHOW_APPROVED: 'Show approved',
      SHOW_LEGEND: 'Show legend',
      SICK_LEAVE: 'SL',
      START: 'Start',
      STATUSES: 'Statuses',
      JIRA_OR_TIMETRACKING: '(Jira or Time tracking)',
      THIS_FISCAL_WEEK: 'This fiscal week',
      THIS_MONTH: 'This month',
      THIS_PROJECT: 'This project:',
      TIME_DESCRIPTION: 'Time description',
      TIME_MISMATCH: 'Time mismatch',
      TIMELOG: 'Timelog',
      TIMELOGS: 'Timelogs',
      TIMELOGS_MISSING: 'Timelogs missing.',
      TIMELOGS_SUCCESSFULLY_APPROVED:
        'Timelogs have been successfully approved.',
      TIMELOGS_SUCCESSFULLY_CLOSED: 'Timelogs have been successfully closed.',
      TIMELOGS_SUCCESSFULLY_EQUATED: 'Timelogs have been successfully equated.',
      TIMELOGS_SUCCESSFULLY_OPENED: 'Timelogs have been successfully opened.',
      TIMELOGS_SUCCESSFULLY_REJECTED:
        'Timelogs have been successfully rejected.',
      TIMELOGS_SUCCESSFULLY_REVOKED: 'Timelogs have been successfully revoked.',
      TIMELOGS_SUCCESSFULLY_SUBMITTED:
        'Timelogs have been successfully submitted.',
      TO: 'to',
      TOTAL_PROJECT_TIME: 'Total project time',
      TOTAL_TIME: 'Total time',
      TYPE_SALES_FACT_H: 'Type Sales fact (h)',
      UNAVAILABLE_PROJECT: 'Unavailable project',
      UNCONFIRMED: 'Unconfirmed',
      UNCONFIRMED_HOURS_FOR_PERIOD: 'The unconfirmed hours for this period is:',
      VACATION: 'V',
      WARNING: 'Be aware! There are new Jira worklogs in the timesheets.',
      WEEKENDS: 'Weekends',
      WHY_REJECT_TIMELOGS: 'Why reject timelogs?',
      WILL_WORK: 'Will work',
      WORKING_HOURS: 'Working hours',
      YOU_HAVE_NO_TIMELOGS: 'No PM confirmed any timelogs',
      VARIANCE: 'Variance',
    },

    //project statuses
    PROJECT_STATUS: 'Project status',
    CREATED_BY_SYSTEM: 'Created by system',
    LAST_EDIT_BY: 'Last edit by',
    MARK_AS_PREPARED: 'Mark as prepared',
    MODAL_MESSAGE: {
      REJECT: 'Are you sure you want to reject the report?',
      PREPARED: 'After you mark the status as prepared it becomes uneditable.',
      PREPARED_BY_DM: 'Are you sure you want to mark as prepared the report?',
      APPROVED: 'After you confirm the status it becomes uneditable.',
    },
    TO_THE_FIRST_PAGE: 'To the first page',
    TO_THE_LAST_PAGE: 'To the last page',
    TO_THE_NEXT_PAGE: 'To the next page',
    TO_THE_PREVIOUS_PAGE: 'To the previous page',

    // HTTP errors
    ERROR_IMAGE: 'Failed to upload image',
    FILE_LIMIT: 'File limit:',
    FORBIDDEN_ERROR: 'You have not enough privileges',
    UNPROCESSABLE_ENTITY: 'Please fix the errors:',

    //header
    CONTACT_US: 'Contact us',
    ENTER_SUBJECT: 'Enter subject',
    ENTER_DESCRIPTION: 'Enter description',
    SELECT_LANGUAGE: 'Select language',
    TELEPORT_TO_HUB: 'Teleport to Hub!',
    USER_DOCUMENTATION: 'User documentation',
    YOU_ARE_HERE: 'You are here!',
    YOU_ARE_CURRENTLY_IN_A: 'You are currently in a',
    ENVIRONMENT: 'environment',

    //sidebar-tabs
    COMPANY_DIRECTORY: 'Company',
    PROJECT_MANAGEMENT: 'Project Management',
    TIMELOG_MANAGEMENT: 'Timelog Management',
    STAFF_MANAGEMENT: 'Staff Management',
    ADMINISTRATION: 'Administration',
    MY: 'My',
    SYSTEM: 'System',
    TABLE: 'Table',

    //navigation
    MANAGERIAL_ACCOUNTING: 'Managerial accounting',
    ACTION_ITEM: 'Action item',
    ACTION_ITEMS: 'Action items',
    AUDIT_LOGS: 'Audit Log',
    CREATE_ONE_TO_ONE: 'Create new 1-1',
    DELIVERY_MANAGER: 'Delivery manager',
    DELIVERY_MANAGERS: 'Delivery managers',
    EDIT_ONE_TO_ONE: 'Edit 1-1',
    EMPLOYEES: 'Employees',
    FEEDBACKS: 'Feedbacks',
    FEEDBACK_REQUEST: 'Feedback request',
    FORM: 'Form',
    FORMS: 'Forms',
    GUIDELINES: 'Guidelines',
    LOGOUT: 'Logout',
    OFFICE_MANAGER: 'Office manager',
    PAYROLL_TIMESHEET: 'Payroll timesheet',
    PAYSLIPS: 'Payslips',
    PEOPLE_MANAGEMENT_ACCESSES: 'People management accesses',
    PERSONNEL_ACCOUNTING: 'Personnel Accounting',
    PROFILE: 'Profile',
    PROJECTS: 'Projects',
    PROJECT_MANAGER: 'Project manager',
    GO_TO_POSITION_CARD: 'Go to position card',
    ROLE_OVERVIEW: 'Role overview',
    SALES_PLAN: 'CFO',
    SETTINGS: 'Settings',
    VACATIONS: 'Vacations',
    WORKING_TIME_ACCOUNTING: 'Working time accounting',
    WORKING_TIME_CONTROL: 'Working time control',
    WORKING_TIME_UPLOADING: 'Working time uploading',

    //TABLE OM
    ACTIVE: 'Active',
    ALL: 'All',
    ARE_YOU_SURE_DELETE: 'Are you sure delete event?',
    CLOSE_ADDING_EVENT: 'Close adding event',
    CREATE_EVENT: 'Create event',
    CUSTOM_EVENTS: 'Custom events',
    DATE_OF_CREATE: 'Date of create',
    DISMISSED: 'Dismissed',
    EDIT_HISTORY: 'Edit history',
    EDIT_LIMITS_IN: 'Edit limits in ',
    EMPLOYMENT_HISTORY: 'Contract History',
    EMPLOYMENT_TYPES: {
      AN_AGREEMENT_WITH_AN_INDIVIDUAL: 'An agreement with an individual',
      APPRENTICESHIP_AGREEMENT: 'Apprenticeship agreement ',
      CIVIL_LAW_CONTRACTS: 'Civil law contracts',
      CONTRACT_WITH_DFG: 'Contract with DFG (Payoneer)',
      ENTREPRENEUR: 'Entrepreneur',
      INDIVIDUAL_ENTREPRENEUR: 'Individual entrepreneur',
      LABOR_CODE: 'Labor code',
    },
    ENTER_REASON: 'Please, enter the reason',
    EVENT: {
      CANCEL_ALL_EVENT: 'Cancel all event days',
      CANCEL_CURRENT_EVENT: 'Cancel the current day of the event',
      CANCEL_SUBSEQUENT_EVENT: 'Cancel the event and all subsequent ones',
      CHANGE_OR_CANCEL_EVENT: 'Change or cancel vacation by form',
      START_EVENT: 'Restore a single day',
      START_WHOLE_EVENT: 'Restore the whole event',
    },
    EVENT_ADD_FAILED: 'Event add rejected',
    EVENT_ADD_SUCCESS: 'Event added successfully',
    EVENT_DELETED_FAILED: 'Event delete failed',
    EVENT_DELETED_SUCCESSFUL: 'Event deleted successful',
    EVENT_FIELDS: {
      CREATOR: 'Creator',
      FORM: 'Form',
      FROM: 'From',
      HOURS: 'Hours',
      REASON: 'Reason',
      STATE: 'State',
      TICKET_LINK: 'Ticket link',
      TO: 'To',
      TYPE: 'Type',
    },
    EVENT_FORM_TYPES: {
      COMMENT: {
        ERROR: 'Please enter the comment',
        PLACEHOLDER: 'Comment',
      },
      DATE_FROM: {
        ERROR: 'Please select a date',
        PLACEHOLDER: 'From',
      },
      DATE_FROM_TRANSFER: {
        ERROR: 'Please select a date',
        PLACEHOLDER: 'Transfer date from',
      },
      DATE_TO: {
        ERROR: 'Please select a date',
        PLACEHOLDER: 'To',
      },
      DATE_TO_TRANSFER: {
        ERROR: 'Please select a date',
        PLACEHOLDER: 'Transfer date to',
      },
      DEPARTMENT: {
        ERROR: 'Please select a department',
        PLACEHOLDER: 'Department',
      },
      EXPECTED_TIME: {
        ERROR: 'Please enter the expected time',
        PLACEHOLDER: 'Expected time (hours)',
      },
      FINISHED_AT_HOURS_TO: {
        ERROR: 'Please enter the time',
        PLACEHOLDER: 'Transfer to (finish)',
      },
      MANAGER_OF_PROJECT: {
        ERROR: 'Please select the manager of project',
        PLACEHOLDER: 'Manager of project',
      },
      OFFICE: {
        ERROR: 'Please select an office',
        PLACEHOLDER: 'Office',
      },
      PROJECTS_NAME: {
        ERROR: 'Please select project for transfer',
        PLACEHOLDER: 'Select project for transfer',
      },
      REASON: {
        ERROR: 'Please enter the reason',
        PLACEHOLDER: 'Reason',
      },
      SELECT_EVENT_TYPE: {
        LABEL: 'Select event type',
      },
      STARTED_AT_HOURS_TO: {
        ERROR: 'Please enter the time',
        PLACEHOLDER: 'Transfer to (start)',
      },
      TASK_LINK: {
        ERROR: 'Please enter the task link',
        PLACEHOLDER: 'Task link',
      },
      TIME_START_DATE_FROM: {
        ERROR: 'Please enter the time',
        PLACEHOLDER: 'Transfer time from',
      },
      TIME_START_DATE_TO: {
        ERROR: 'Please enter the time',
        PLACEHOLDER: 'Transfer time to',
      },
      TOTAL_HOURS: {
        ERROR: 'Please enter the expected time',
        PLACEHOLDER: 'Type number of hours',
      },
    },
    EVENT_NAMES: {
      ABSENT: 'Absent',
      ALL_LABOR_COST_APPROVED: 'All labor costs are confirmed',
      APPROVED_TIME: 'Approved',
      CANCELLED: 'Cancelled',
      COMPENSATED_LEAVE: 'Compensated Leave',
      EXTRA_LEAVE: 'Extra Leave',
      LEFT_COMPANY: 'Left company',
      LOGGED: 'Logged',
      NO_WORKLOGS: 'No worklogs',
      NOT_WORKING_YET: 'Not working yet',
      PAID_LEAVE: 'Paid leave',
      PAID_VACATION: 'Paid vacation',
      PLAN_AND_FACT_DO_NOT_MATCH: 'Plan and fact dont`t match',
      PROJECT_OUT_OF_CONTROLLED_DU: 'Project out of controlled DU',
      REMOTE: 'Remote',
      SICK_LEAVE: 'Sick leave',
      SOCIAL_LEAVE: 'Social leave',
      TIME_SHIFT: 'Time shift',
      THE_NUMBER_OF_VD: 'The number of VD',
      TRANSFER_DAY: 'Transfer date',
      TRANSFER_TIME: 'Transfer time',
      UNPAID_LEAVE: 'Unpaid leave',
      UNPAID_SICK_LEAVE: 'Unpaid sick leave',
      UNPAID_VACATION: 'Unpaid vacation',
      VACATION: 'Vacation',
      HOLIDAY: 'Holiday',
    },
    EVENT_STATES: {
      CANCELLED: 'Cancelled',
      CANCELLED_EVENTS: 'Cancelled events',
      APPROVED: 'Approved',
      IN_PROGRESS: 'In progress',
      NEW: 'New',
      SEVERAL: 'Several',
      USED: 'Used',
    },
    EVENT_COLOR: 'Event color',
    EVENT_CONFLICTS_WARNING:
      'Please be aware, that there <NamesFiller> for the following dates',
    EMPLOYEE_STATUS: 'Employee status',
    FILTER: 'Filter',
    FILTERS: 'Filters',
    HIDE_FILTERS: 'Hide filters',
    INFORMATION_ABOUT: 'Information about',
    LIMITS_UPDATE_SUCCESS: 'Limits has been successfully updated',
    MONTH: 'month',
    MONTHS: 'months',
    OM_TO: 'to',
    OM_TOTAL: 'Total',
    OTHER_EVENTS: 'Other events',
    REASON_REQUIRED: 'Reason must contain at least 3 symbols',
    SEARCH_BY_CONTENT: 'Search by content',
    SEARCH_BY_EMPLOYEE: 'Search by employee',
    SEARCH_BY_NAME: 'Search by name',
    SEARCH_BY_PROJECT: 'Search by project',
    SEARCH_BY_TASK: 'Search by task',
    SEARCH_BY_USERS: 'Search by user',
    SELECT_OFFICE: 'Select office',
    SELECT_PROJECT: 'Select project',
    SET_CUSTOM_RANGE: 'Set custom range',
    SHOW_FILTERS: 'Show filters',
    SHOW_TIMELOGS: 'Show timelogs',
    SHOW_TRANSFER_TO: 'Show when the transfer is',
    SHOW_WEEKENDS: 'Show weekends',
    STATE_OF_EVENTS: 'State of events:',
    OLD_STATISTICS: 'Statistics (Old)',
    TYPE_OF_EVENTS: 'Type of events',
    TYPE_DESCRIPTION: 'Type description',
    USERS_NOT_FOUND: 'Users not found',
    VIEW_INFORMATION: 'View information',
    WEEK: 'week',
    WEEKS: 'weeks',

    //OM statistic view
    PARTNERS: 'Partners',
    COUNT_OF_AVAILABLE_VACATION_DAYS_WITHOUT_PLANNED:
      'The number of AVAILABLE VD at the moment (excluding planned)',
    COUNT_OF_AVAILABLE_VACATION_DAYS_WITHOUT_PLANNED_1:
      'The number of available VD at the moment (excluding planned)',
    COUNT_OF_AVAILABLE_VACATION_DAYS_WITH_PLANNED:
      'The number of AVAILABLE VD at the moment (including planned)',
    COUNT_OF_AVAILABLE_VACATION_DAYS_WITH_PLANNED_1:
      'The number of available VD at the moment (including planned)',
    COUNT_OF_EARNED_VACTION_DAYS:
      'Count of earned vacation days in previous year',
    COUNT_OF_SCHEDULED_PAID_VACATION_DAYS: 'Count of scheduled VD',
    COUNT_OF_SCHEDULED_PAID_VACATION_DAYS_1: 'Count of Scheduled VD',
    COUNT_OF_USED_SICK_LEAVE: 'Count of used sick leave',
    COUNT_OF_USED_UNPAID_LEAVE: 'Count of used unpaid leave',
    COUNT_OF_USED_VACATION_DAYS:
      'Count of used vacation days at the current moment',
    COUNT_OF_WORKED_DAYS: 'Count of worked days',
    COUNT_OF_WORKED_DAYS_IN_CURRENT_YEAR:
      'Count of worked days in current year',
    COUNT_OF_WORKED_YEARS: 'Count of worked years',
    CURRENT_DUE_PAID_VACATIONS: 'The number of VD DUE in the current year',
    CURRENT_DUE_PAID_VACATIONS_1: 'The number of VD DUE in the current year',
    DATE_OF_START_WORK: 'Date of start work',
    EARNED_VACATION_PAID_VACATIONS:
      'The number of EARNED VD at the current moment',
    OVERALL_EARNED_VACATION_DAYS:
      'Total earned VD at the current moment(Advanced VD are not included',
    EARNED_VACATION_PAID_VACATIONS_1:
      'The number of EARNED VD at the current moment',
    EMAIL: 'Corporation E-mail',
    EMPLOYMENT: 'Contract types',
    INTERNSHIP: 'Internship',
    LAST_DUE_PAID_VACATIONS: 'The number of VD DUE since last year',
    LAST_DUE_PAID_VACATIONS_1: 'The number of VD DUE since last year',
    PIECEWORKER: 'Pieceworker',
    PIECEWORKERS: 'Pieceworkers',
    REMAINING_VACATIONS_FOR_31_DEC_EXCLUDING_PLANNED:
      'Remaining vacation days for December 31 of the current year (excluding planned)',
    REMAINING_VACATIONS_FOR_31_DEC_INCLUDING_PLANNED:
      'Remaining vacation days for December 31 of the current year (including planned)',
    TOTAL_VACATION_DAYS_DUE: 'TOTAL number of VD DUE',
    TRAINEE: 'Trainee',
    UNDEREMPLOYMENT: 'Underemployment',
    USERNAME: 'User',

    //validation
    ENTER_CORRECT_EMAIL: 'Please enter a correct email',
    ENTER_ONLY_NUMBERS: 'Please enter only numbers',
    IS_REQUIRED: 'This field is required',
    TABLE_IS_REQUIRED: 'Table is required',
    TABLE_ONLY_NUMBERS: 'Only numbers',

    //cfo table
    ACTIVE_PROJECTS: 'Active Projects',
    CAPACITY: 'Capacity',
    COM: 'COM %',
    CONTRACT_HOURS: 'Contract hours',
    CONTRACT_TYPE: 'Contract type',
    NO_CONTENT: 'No comments',
    PLAN_VS_SALES: 'Plan vs Sales',
    RECALCULTATE_SALES_PLAN:
      'Would you like to recalculate all weekly Sales Plan?',
    SALES_FACT: 'Sales fact',
    SALES_TOTAL: 'Sales total',
    TABLE_SALES_PLAN: 'Sales plan',
    VARIANCE: 'Variance',

    //audit logs
    CONTENT: 'Content',
    KIND: 'Kind',

    //role overview
    GLOBAl_ROLE: 'Global role',
    RESOURCE_ROLE: 'Resource role',

    //people management accesses
    BY_DM_ROLE: 'By DM role',
    BY_HOD_ROLE: 'By HoD role',
    BY_PM_ROLE: 'By PM role',
    BY_RMO_TREE_POSITION: 'By RMO tree position',
    DIRECT: 'Direct',
    INDIRECT: 'Indirect',

    //working time uploading
    ADD_URL: 'Please add URL',
    GOOGLE_SHEET_URL: 'Google Sheet URL',
    LINK_ERROR: 'This link is invalid',
    COMMENTING_NOT_ALLOWED:
      'The comment can`t be sent. You don`t have enough permissions in Pyrus',
    CREATED_TASKS_LABEL: 'Created tasks',
    DECISION_ON_TASK:
      'To make a decision on your task, you must fill out this form',
    FORMS_LIST: 'Forms list',
    FIND_TASK: 'Find a task',
    INBOX: 'Inbox',
    INFORMATION: 'Information',
    LINK_TO_PYRUS: 'Link to Pyrus',
    LINK_COPIED: 'Link copied',
    LINK_TO_PYRUS_COPIED: 'Link to Pyrus copied',
    NEW_TASK_LABEL: 'Add',
    SHOW_FINISHED: 'Show only finished tasks',

    //table notifications
    DATE: 'Date',
    MESSAGE: 'Message',

    //notifications modal
    ALL_NOTIFICATIONS: 'View all',
    MARK_ALL_NOTIFICATIONS_AS_READ: 'Mark all as read',
    MARK_ALL_NOTIFICATIONS_AS_UNREAD: 'Mark all as unread',
    MISSED_MEETING:
      'It has been more than 30 days since {employeeName} last 1-1 meeting',
    NOTIFICATIONS: 'Notifications',
    NO_NOTIFICATIONS: 'No new notifications',
    MARK_ALL_AS_READ: 'Mark all as read',
    TABLE_WTC: 'Table of WTC',
    TABLE_OM: 'Table of OM',
    TABLE_WTA: 'Table of WTA',

    //vacations
    APPROVED: 'Approved',
    AVAILABLE: 'Avail.',
    CANCELLED: 'Cancelled',
    CREATED: 'Not Approved',
    IN_PROGRESS: 'In Progress',
    PLANNED: 'Planned',
    TAKE_VACATION: 'Take a vacation',
    USED: 'Used',
    VACATION_FROM: 'From',
    VACATION_STATE: 'State',
    VACATION_TO: 'To',
    VACATION_TYPE: 'Vacation type',

    //sick leaves
    REST_PAID_SICK_LEAVE: 'Rest paid sick leave',
    USED_SICK_LEAVE: 'Used sick leave',

    //one to ones
    ACTION_LIST: 'Action list',
    ACTION_PLACEHOLDER: 'Enter action here',
    ADD_ACTION: 'Add action',
    ADD_COMMENT: 'Add comment',
    ADD_GOALS: 'Add goals',
    ADD_LOG: 'Add a 1-1 log with {employeeName}',
    ADD_TODO: 'Add todо',
    AT: 'At',
    AWESOME: 'Awesome',
    BUSINESS_IMPACT: 'Business impact',
    BY: 'By',
    CHOOSE_FROM_THE_LIST: 'Choose from the list',
    CHOOSE_THE_DATE: 'Choose the date',
    CHOOSE_THE_EMPLOYEE: 'Choose the employee',
    CHOOSE_TYPE: 'Choose the One to one type',
    CHOOSE_TYPE_TOOLTIP: 'For HR use this type of 1-1 layout',
    CLOSE: 'Close',
    CLOSED_IN_ONE_TO_ONE: 'Closed in 1-1',
    COMMENT_PLACEHOLDER: 'Enter your comment here',
    CONDUCT_ONE_TO_ONE: 'Conduct 1-1',
    CREATE: 'Create',
    CREATE_NEW: 'Create new',
    CREATED_BY: 'Created by',
    CREATED_IN_ONE_TO_ONE: 'Created in 1-1',
    DATE_OF_ONE_TO_ONE: 'Date of 1-1',
    DECREASED: 'Decreased',
    DELETE_BUTTON_TOOLTIP:
      'You can delete 1-1 created\nno later than 1 month ago',
    DELETE_MODAL_CHANGES:
      'Are you sure to delete this 1-1? All content will be lost\nand statuses of feedback and action items\ncompleted in this 1-1 will be reverted.',
    DELETE_MODAL_CONFIRMATION: 'This action cannot be undone',
    DELETE_LAST_ONE_TO_ONE:
      '{employeeName} doesn`t have any one to one meetings',
    DESCRIPTION: 'Description',
    DISCUSSION: 'Discussion',
    EMPLOYEE_PERFORMANCE: 'Employee Performance',
    ERROR_REASON_FIELD: 'The reason cannot be more than 200 characters.',
    EMPTY: 'Empty',
    EMPTY_ACTION_LIST: 'Actions list is empty',
    EXIT_MODAL_CHANGES: "Your changes won't be saved",
    EXIT_MODAL_CONFIRMATION: 'Do you really want to leave?',
    EXIT_MODAL_CONFIRMATION_LEAVE: 'Leave',
    EXTRA_MILE: 'Extra mile',
    EXTRA_LEAVE_FOR_HOIDAYS: 'Extra Leave for Holidays',
    EXTRA_LEAVE_FOR_HOIDAYS_INCURRENT_YEAR:
      'Extra Leave for Holidays (Current Year)',
    FIELD_EMPLOYEE_PLACEHOLDER: 'Search employee',
    FIELD_NOTES: 'Notes',
    FIELD_NOTES_PLACEHOLDER: 'Add your comments',
    FILTER_COMPLETED: 'Completed',
    FILTER_MINE: 'Mine',
    FILTER_PLACEHOLDER: 'Filter by user name',
    FILTER_RESOLVED: 'Resolved',
    FILTER_SHARED: 'Shared',
    FILTER_UNRESOLVED: 'Unresolved',
    FILTER_UPCOMING: 'Upcoming',
    FINISH: 'Finish',
    GOALS: 'Goals',
    HAPPINESS_INDEX: 'Happiness Index',
    HIGH: 'High',
    HR: 'HR',
    IMPACT_OF_LEAVING: 'Impact of Leaving',
    IMPACT_OF_LEAVING_REASON: 'Impact of Leaving reason',
    INCREASED: 'Increased',
    ISSUES: 'Issues',
    LOG: 'Log',
    LOOKS_GOOD: 'Looks good',
    LOW: 'Low',
    MANAGER: 'Manager',
    ME: 'Me',
    MEDIUM: 'Medium',
    MONTHLY: 'Monthly',
    NEW_ONE_TO_ONE: 'New 1-1',
    ON: 'On',
    ONE_TO_ONE: 'One to one',
    ONE_TO_ONE_FILTER_CATEGORIES: {
      SUBORDINATES: 'Subordinates',
      TYPE: 'Type',
      SUBSCRIPTION: 'Subscription',
    },
    ONE_TO_ONE_FILTER_ITEMS: {
      ONLY_DIRECT: 'Only direct',
      INDIRECT: 'Indirect',
      MANAGER: 'Manager',
      SHOW_ONLY_SUBSCRIBED: 'Show only subscribed',
    },
    ONE_TO_ONE_SHARE_MODAL: 'Share this 1-1 with',
    ONE_TO_ONE_SHARE_MODAL_HINT:
      'You can share 1-1 with employee with People Management role',
    ONE_TO_ONE_SHARING: '1-1 sharing',
    OTO_WITH: 'One-to-one with',
    OVERALL_STATE: 'Overall state',
    PERFORMANCE: 'Performance',
    POTENTIAL: 'Potential',
    RECURRING: 'Recurring',
    REASON_OF_DELAY: 'Reason of delay',
    REGISTER_ATTRITION_BUTTON: 'Save and register attrition risk',
    RESPONSE_DAY: 'Response day',
    RISK_OF_LEAVING: 'Risk of Leaving',
    RISK_OF_LEAVING_REASON: 'Risk of leaving reason',
    SAVE_BUTTON_TOOLTIP: 'Fill all the mandatory fields',
    SHARE: 'Share',
    SHARE_BUTTON_TOOLTIP: 'Only created 1-1\ncan be shared',
    SHARE_FEEDBACK_REPLY_TOOLTIP: 'Only replied feedback\ncan be shared',
    SHOW_ONLY_DIRECT: 'Show only direct',
    SHOW_ONLY_DIRECT_TOOLTIP_CHECKED:
      'View your direct and indirect subordinates one to ones',
    SHOW_ONLY_DIRECT_TOOLTIP_UNCHECKED:
      'View your direct subordinates one to ones',
    SHOW_ONLY_SUBSCRIBED: 'Show only subscribed',
    SUBSCRIBE_MODAL: {
      SUBSCRIBE_TO_ALL: 'Are you sure you want to Subscribe to all?',
      UNSUBSCRIBE_FROM_ALL: 'Are you sure you want to Unsubscribe from all?',
    },
    SUBSCRIBE_TO_ALL: 'Subscribe to all',
    SELECT_EMPLOYEE: 'Select employee',
    SELECT_DATE: 'Select date',
    SELECT_TIME: 'Select time',
    TYPE_REASON_FOR_DELAY: 'Type reason for delayed 1-1 creation',
    TAB_MY_ONE_TO_ONES: 'My one to one meetings',
    TAB_SHARED_WITH_ME: 'Shared with me',
    TECHNICAL: 'Technical',
    TODOS: 'Todos',
    TOOLTIP: {
      ACTIVE_ROLES: 'Active roles in this project',
      ARCHIVE: 'Archive',
      AWESOME:
        "The employee exceeds expectations, somehow proved himself during the month. In stressful moments, he helped organize the team's work on the project, supported the team's morale and helped with tasks that he should not be engaged in.",
      BAD: "The employee let the team down with his disorganization, cheated or ignored the manager's requests. Interfered with the work of the team",
      DEPENDS_OF_VALUE: 'This value depends on\nthe selected tasks above',
      GOOD: 'The employee performed his work efficiently. He did everything that is expected of him at his level. He actively participated in communication with other team members in order to solve emerging issues.',
      ISSUES:
        'The employee performed his work efficiently, but did not get into the estimates or did not warn about delays in time. The employee has questions that need to be resolved to ensure his further growth. Violated the discipline of the project.',
      PAST_ROLES: 'Past roles in this project',
      RESTORE: 'Restore',
      SWITCH_ACTIVE: 'Switch to active',
      SWITCH_INACTIVE: 'Switch to inactive',
    },
    TYPE_SELECTION_MODAL_DESCRIPTION:
      'Choose the type of the 1-1 according to your role',
    UNSUBSCRIBE_FROM_ALL: 'Unsubscribe from all',
    WEEKLY: 'Weekly',
    WITH: 'With',
    //HR and Mentor Assignment
    ACTIONS: 'Actions',
    ARE_YOU_SHURE_WANT_DELETE_MENTOR:
      'Are you sure you want to delete Mentors for the selected employees?',
    ARE_YOU_SHURE_WANT_DELETE_HR:
      'Are you sure you want to delete HRs for the selected employees?',
    ALL_MENTORS_ASSIGNED: 'All Mentors were assigned successfully',
    ALL_HR_ASSIGNED: 'All HRs were assigned successfully',
    ALL_HRS_MENTORS_ASSIGNED: 'All Mentors and HRs were assigned successfully',
    ALL_MENTORS_DELETED: 'All Mentors were deleted successfully.',
    ALL_HR_DELETED: 'All Hrs were deleted successfully.',
    DELETE_MENTOR: 'Delete mentor',
    DELETE_HR: 'Delete HR',
    DELETION_FAILED_DUE_TO_A_SYSTEM_ERROR:
      'Deletion failed due to a system error. Please try again later.',
    DELETION_WAS_APPLIED:
      'Deletion was applied to all selected employees, except:',
    DUE_SYSTEM_ERROR: 'due to a system error. Please try again later.',
    EDIT_ASSIGNMENT: 'Edit assignment',
    EDIT_ASSIGNMENTS: 'Edit assignment(s)',
    EMPLOYEES_WITHOUT_HR: 'Employees without HR',
    EMPLOYEES_WITHOUT_MENTOR: 'Employees without Mentor',
    EDIT_FAILED_DUE_TO_A_SYSTEM_ERROR:
      'The edit failed due to a system error. Please try again later.',
    EDIT_RELATIONS_MODAL_NOTES:
      'If you specify an HR or Mentor, only the selected value will be applied.',
    EDIT_WAS_APPLIED: 'The edit was applied to all selected employees, except:',
    LIST_OF_ASSIGNED_EMLOYEES: 'List of assigned employees',
    MENTOR: 'Mentor',
    SELECT_AT_LEAST_ONE_EMPLOYEE: 'Select at least 1 employee',
    HR_AND_MENTORSHIP: 'HR and Mentorship',
    //feedbacks
    ALL_REPLYING_EMPLOYEES: 'All replying employees',
    ALL_REQUESTING_MANAGERS: 'All requesting managers',
    ALL_STATUSES: 'All statuses',
    BUTTON_FEEDBACK_REQUEST: 'Feedback request',
    CANCEL_MODAL_CHANGES: "Your changes won't be saved",
    CANCEL_MODAL_CONFIRMATION: 'Do you really want to leave?',
    COL_DATE_OF_CHANGE: 'Date of change',
    COL_DEADLINE: 'Deadline',
    COL_EMPLOYEE: 'Employee',
    COL_EMPLOYEE_PERFOMANCE: 'Employee performance',
    COL_REPLYING_EMPLOYEE: 'Replying employee',
    COL_REQUESTING_MANAGER: 'Requesting manager',
    COL_STATUS: 'Status',
    COPY_REQUEST: 'Copy request',
    COPY_REQUEST_DESCRIPTION:
      'We will make a copy of this feedback request:\nemployee, and the list of questions will be duplicated.\nWould you like to continue?',
    DELETE_LAST_FEEDBACK: '{employeeName} doesn`t have any feedback requests',
    FEEDBACK_COMMENTS: 'Additional comments',
    FEEDBACK_PERIOD: 'Feedback period',
    FEEDBACK_PERFOMANCE: 'Employee performance',
    FEEDBACK_REPLY: 'Feedback reply',
    FEEDBACK_REQUEST_DELETE_MODAL:
      'Are you sure you want to delete this request?',
    FEEDBACK_SHARE_MODAL: 'Share this feedback with',
    FEEDBACK_SHARE_MODAL_HINT:
      'You can share feedback with employee with People Management role',
    FEEDBACK_SHARING: 'Feedback sharing',
    FILTER_CLEAR: 'Clear',
    FILTER_PENDING: 'Pending',
    FILTER_RECEIVED: 'Received',
    FILTER_REPLIED: 'Replied',
    FILTER_SELECT_ALL: 'Select all',
    FILTER_UNANSWERED: 'Unanswered',
    LOAD_MORE: 'Load more',
    NO_ACTION_ITEMS: 'No Action Items',
    NO_FEEDBACK: 'No feedback',
    NOTHING_TO_LOAD: 'There is nothing left to load',
    SHOW_ARCHIVED: 'Show archived',
    SHOW_INQUIRED: 'Show Inquired',
    SHOW_ONLY_DIRECT_FEEDBACK_CHECKED_TOOLTIP:
      'View your direct and indirect subordinates feedback',
    SHOW_ONLY_DIRECT_FEEDBACK_UNCHECKED_TOOLTIP:
      'View your direct subordinates feedback',
    TAB_FEEDBACK_REQUEST: 'My feedback requests',
    TAB_FEEDBACK_REPLY: 'Feedback to reply',
    OPTIONS_COPY: 'Make a copy',
    OPTIONS_SHARE: 'Share',
    RESET_ALL: 'Reset all',
    REQUESTED_MANAGER: 'Requested manager',
    REQUEST_WINDOW: {
      ADD_QUESTION_BUTTON: '+ Add question',
      ADDITIONAL_COMMENTS: 'Additional comments',
      ADDITIONAL_COMMENTS_HINT:
        'will be added automatically to Feedback request',
      AND: 'and',
      DEADLINE: 'Deadline',
      DISCUSSED_IN: 'Discussed in',
      DUE_DATE: 'Due date',
      EMPLOYEE: 'Employee',
      EMPLOYEE_PERFORMANCE: 'Employee performance',
      EMPLOYEE_PERFORMANCE_HINT: 'This block will be also included in request',
      EXIT_MODAL_CHANGES: "Your changes won't be saved",
      EXIT_MODAL_CONFIRMATION: 'Do you really want to leave?',
      FEEDBACK_ON: 'Feedback on',
      FEEDBACK_PERIOD: 'Feedback period',
      FROM: 'From',
      GENERAL_INFORMATION: 'General information',
      NO_ANSWER: 'No answer',
      ONE_TO_ONE_MEETING: '1-1 meeting',
      QUESTION: 'Question',
      QUESTIONS: 'Questions',
      QUESTIONS_HINT: 'You can add up to 10 questions',
      QUESTION_PLACEHOLDER: 'Enter question',
      REPLIED_BY: 'Replied by',
      REPLIED_ON: 'Replied on',
      REPLYING_EMPLOYEE: 'Replying employee',
      SECTIONS: 'Sections',
      TITLE_PLACEHOLDER:
        'Title will be filled in automatically. You can edit it later.',
      TO_REPLY_BY: 'To reply by',
      WHAT_BAD: 'What was bad',
      WHAT_GOOD: 'What was good',
      WHAT_IMPROVE: 'What can we improve',
      YOUR_REQUEST: 'Your request',
    },
    STATUS_ARCHIVED: 'Archived',
    STATUS_COMPLETED: 'Completed',
    STATUS_DRAFT: 'Draft',
    STATUS_INQUIRED: 'Inquired',
    STATUS_READY: 'Ready',
    SUBORDINATE: 'Subordinate',

    //maintenance
    FORM_ON_UPDATE: 'This form is currently down for maintenance',
    EXPLANATION_OF_UPDATE:
      'Your colleagues are working on it right now! We expect to be back in a couple of hours. Thanks for your patience.',

    //action items
    CREATE_ACTION_ITEM_MODAL: 'Create the Action item',
    DEADLINE: 'Deadline',
    DELETE_ACTION_ITEM_MODAL:
      'Are you sure you want to delete this action item?',
    EDIT_ACTION_ITEM_MODAL: 'Edit Action Item',
    STATUS_DONE: 'Done',
    STATUS_TODO: 'To do',

    //heatmap
    APPLY_FILTERS: 'Apply filters',
    CHOOSE_PERIOD: 'Choose the period you need to download.',
    CURRENT_MONTH: 'Current month',
    DELETE_VIEW: 'Delete this view?',
    DELETE_VIEW_EXPLANATION:
      'After you delete this set of filters it becomes unavailable',
    DOWNLOAD_DATA: 'Download data',
    GRADE: 'Grade',
    HEATMAP: 'Heatmap',
    HEATMAP_HINT: 'To open 1-1 click on the table section',
    HEATMAP_REPRESENTATIVE_OFFICE: 'Representative office',
    PLACEHOLDER_CHOOSE_GRADES: 'Choose grades',
    PLACEHOLDER_CHOOSE_OFFICES: 'Choose offices',
    PLACEHOLDER_CHOOSE_PROJECTS: 'Choose projects',
    PLACEHOLDER_CHOOSE_SPECIALITIES: 'Choose specialities',
    PLACEHOLDER_CHOOSE_TEAMS: 'Choose teams',
    PREVIOUS_MONTH: 'Previous month',
    RESET_FILTER: 'Reset filter',
    SAVE_VIEW: 'Save view',
    SAVE_VIEW_BUTTON: 'Save view',
    SAVE_VIEW_EXPLANATION:
      'You can save this set of filters in order to use it further',
    SAVED_VIEWS: 'Saved views',
    SHOW_DISMISSED_EMPLOYEES: 'Show dismissed employees',
    SHOW_LAST_NEGATIVE_VALUE: 'Show last negative value',
    TEAM: 'Team',
    TYPE_ANY_NAME: 'Type any name',
    TYPE_ANY_TEXT: 'Type any text',
    VIEW_DESCRIPTION: 'Short description',
    VIEW_NAME: 'Name of the view',
    UNIT: 'Unit',

    //indicator
    HAPPINESS_EXCITED: 'Excited',
    HAPPINESS_FRUSTRATED: 'Frustrated',
    HAPPINESS_GOOD: 'Good',
    HAPPINESS_GREAT: 'Great',
    HAPPINESS_NEUTRAL: 'Neutral',
    PERFOMANCE_ASWESOME: 'Awesome',
    PERFOMANCE_BAD: 'Bad',
    PERFOMANCE_EXCEED_EXPECTATIONS: 'Exceed expectations',
    PERFOMANCE_GOOD: 'Good',
    PERFOMANCE_ISSUES: 'Issues',
    PERFOMANCE_MEET_EXPECTATIONS: 'Meet expectations',
    PERFOMANCE_NEED_IMPROVEMENT: 'Need improvement',
    PERFOMANCE_OUTSTANDING: 'Outstanding',
    PERFOMANCE_UNACCEPTABLE: 'Unacceptable',
    RISK_HIGH: 'High',
    RISK_LOW: 'Low',
    RISK_MEDIUM: 'Medium',

    //happiness index legend
    HAPPINESS_EXCITED_LEGEND:
      'Overflowing with enthusiasm and energy, embracing every challenge with a positive attitude, and radiating optimism.',
    HAPPINESS_FRUSTRATED_LEGEND:
      'Overwhelmed by dissatisfaction, troubled by team, project, or personal progress, and frequently encountering stress and frustration in various aspects of life.',
    HAPPINESS_GOOD_LEGEND:
      'In a state of equilibrium, feeling at ease, and accepting the current situation and future plans with a calm and composed mind.',
    HAPPINESS_GREAT_LEGEND:
      'Content with life, project, and team, finding joy in the work, and feeling a sense of fulfillment and satisfaction.',
    HAPPINESS_NEUTRAL_LEGEND:
      'Stays apathetic to events, lacks enthusiasm, experiences neither joy nor disappointment, maintains composure.',

    //impact legend
    IMPACT_LOW_LEGEND:
      "An employee hasn't been involved in any types of non project activities. His project expertise can be transferred without an extra effort.",
    IMPACT_MEDIUM_LEGEND:
      'Employee has some important project expertise and /or participate in discipline contribution or general business. However, risks related with his leaving might be mitigated with preventive measures without overcost efforts.',
    IMPACT_HIGH_LEGEND:
      'Employee plays critical role on his/her project or involved in important business relevant processes. So his leaving will significantly affect project delivery or business success.',

    //risk legend
    RISK_LOW_LEGEND:
      'Employee completely satisfied with his current project, perspectives, plans and agreements reached with company. Loyalty is high.',
    RISK_MEDIUM_LEGEND:
      'Employee not satisfied of his current situation. Starts to looking on a labor market for an extra opportunities. Or about to do it.',
    RISK_HIGH_LEGEND:
      'Employee considering Job offer from another company. Leaver.',

    //performance legend
    PERFORMANCE_OUTSTANDING:
      'High Performer. The results of his work consistently exceed expectations and he has many accomplishments and positive feedback. Favorably influences project results or the success of the organization. Colleagues and partners enjoy working with him.',
    PERFORMANCE_EXCEED_EXPECTATIONS:
      'A high or normal performer. The results of his work sometimes exceed expectations and he has some achievements and positive feedback. Favorably influences project results or the success of the organization. Colleagues and partners recommend him as a future coworker.',
    PERFORMANCE_MEET_EXPECTATIONS:
      'Normal performance. The  results of his work are always in line with expectations. He may have some achievements and the feedback is positive or normal. Fulfills growth plans.',
    PERFORMANCE_NEED_IMPROVEMENT:
      'The employee received negative feedback. He is having some difficulty executing plans, and this situation has or is about to start negatively impacting project results or the business as a whole. An action plan needs to be developed immediately.',
    PERFORMANCE_UNACCEPTABLE:
      'Low performer. The results of his work have a negative impact on the project development or the business as a whole. Has received negative feedback more than once. Colleagues and partners do not want to work with him in the same team. Toxic.',

    //extra mile legend
    EXTRA_MILE_LOW:
      "Employee is barely manages his work and can't be loaded with extra tasks.",
    EXTRA_MILE_MEDIUM:
      'Employee is good at doing his job, but is not inclined to make more investigations.',
    EXTRA_MILE_HIGH:
      'Employee is good at doing his job and willing to do extra tasks if needed.',

    //potential legend
    POTENTIAL_LOW:
      "Employee stucks at his level and doesn't show will to develop.",
    POTENTIAL_MEDIUM:
      'Employee has a potential to grow and willing to learn new information, but needs motivation.',
    POTENTIAL_HIGH:
      'Employee is highly motivated to achieve results on his current position and to take more responsibility.',

    // mood statistics
    HIDE_WEEKEND: 'Hide weekend',
    MOOD_STATISTICS: 'Mood statistics',
    SHOW_ONLY_FILLED_MOODS: 'Show only filled mood',

    //employees
    ADDRESS: 'Address',
    AND: 'And',
    APPLY_FILTER: 'Apply filter',
    APPRENTICESHIP_END_DATE: {
      TITLE: 'Apprenticeship end date',
    },
    ARCHIVE_MODE: 'Archive mode',
    BRANCH: 'Branch',
    CONTACT_INFO: 'Contact info',
    CORPORATE_EMAIL: 'Corporate email',
    DATE_OF_DISMISSAL: 'Dismissed',
    DATE_OF_END_COOPERATION: 'Due date',
    EMPLOYEE: 'Employee',
    EMPLOYEE_DATE_OF_START_COOPERATION: 'Started date',
    EMPLOYEE_DATE_OF_START_WORK: 'Hired',
    EMPLOYEE_EMAIL: 'Email',
    EMPLOYEE_NAME: 'Employee name',
    EXACT_MATCH: 'Exact match',
    EXCLUDE: 'Exclude',
    FEEDBACK: 'Feedback',
    FORM_INTERACTION: 'Form of interaction',
    FORM_INTERACTION_WITH_COMPANY: 'Form of interaction with the company',
    FROM_ONE_YEAR: '1-3 years',
    FROM_THREE_MONTHS: '3 months - 1 year',
    FULLNAME: 'Full Name',
    GROUP: 'Group',
    INTERNSHIP_COMPLETION_DATE: 'Internship Completion Date',
    INTERNSHIP_START_DATE: 'Internship Start Date',
    LEAVE_FEEDBACK: 'Leave feedback',
    LESS_THREE_MONTHS: '<3 months',
    LOCATION: 'Location',
    MORE_THREE_YEARS: '>3 years',
    OR: 'Or',
    ORGSTRUCTURE_LEVEL: 'Orgstructure level',
    OFFICE: 'Office',
    PARTNER_COMPANY: 'Partner company',
    PERSONAL_EMAIL: 'Personal email',
    PRIVATE_EMAIL: 'Private email',
    PROFESSIONAL_LEVEL: 'Seniority',
    RATE_PERIOD: 'Rate period',
    REPRESENTATIVE_OFFICE: 'Development office',
    REQUEST: 'Request',
    SEARCH_EMPLOYEE: 'Search employee',
    RESET_FILTERS: 'Reset',
    SHOW_COMPLETED_INTERNSHIP: 'Show completed internship',
    SHOW_DISMISSED: 'Show dismissed',
    SHOW_TERMINATED_PARTNERSHIP: 'Show terminated partnership',
    SPECIALIZATION: 'Specialization',
    TEAM_POSITION: 'Team Position',
    IN_TOTAL: 'Total',
    TRAINEES: 'Trainees',
    TRIAL_EXIST: 'Exist',
    TRIAL_NO_EXIST: 'Does not exist',
    TRIAL_PERIOD: 'Trial period',
    WITHOUT_DATA: 'Without data',
    WORK_EXPERIENCE_IN_COMPANY: 'Work experience in the company (months)',
    WORK_EXPERIENCE_BEFORE_THE_COMPANY:
      'Total work experience before the company (years)',

    //projects
    ACTIVE_POSITIONS: 'Active positions',
    ADD: 'Add',
    ADD_POSITION: 'Add position',
    ALLOCATED_EMPLOYEES: 'Allocated employees',
    ALLOCATED_TIME: 'Allocated time',
    BRANCH_MEMBER_CANNOT_BE_ADDED:
      "Role 'Branch member' cannot be added manually",
    CREATE_NEW_PROJECT: 'Create new project',
    EMPLOYEE_CANNOT_BE_INACTIVE:
      "The employee can't be inactive in the project due the being a member of the linked branch",
    ENTER_PROJECT_DESCRIPTION: 'Enter project description',
    ENTER_PROJECT_NAME: 'Enter project name',
    ERROR_EMPTY_PROJECT: 'Project name can not be empty!',
    FILTER_ACCEPTANCE: 'Acceptance',
    FILTER_ALL: 'All',
    FILTER_CLOSED: 'Closed',
    FILTER_HOLD: 'On Hold',
    FILTER_NA: 'N/A',
    FILTER_NONE: 'None',
    FILTER_OPERATIONAL: 'Hide operational',
    FILTER_PROGRESS: 'In progress',
    FILTER_TROUBLESHOOTING: 'Troubleshooting',
    FIXED_PROJECT_CAPACITY: 'Fixed project capacity (h)',
    GITLAB_PROJECT: 'Gitlab project',
    MAX_POSITION_NAME: 'Maximum number of symbols for position name is ',
    NEW_PROJECT: 'New project',
    NO_ACTIVE_CONTRACT_FOR_CURRENT_DATE:
      'No active contract for the current date',
    NO_ACTIVE_CONTRACTS_AVAILABLE:
      'No active contracts are available for the project',
    NUMBER_OF_EMPLOYEES_COUNT:
      'Number of employees, allocated to this position',
    ONLY_ACTIVE_PROJECTS: 'Only active projects',
    OUTLINE_GROUP: 'Outline group',
    PROJECT_BASED: 'Project Based',
    PROJECT_DESCRIPTION: 'Project description',
    PROJECT_NAME: 'Project name',
    ROLE_CANNNOT_BE_DELETED:
      "The role can't be deleted due the being a member of the linked branch",
    SEARCH_POSITION: 'Search position',
    SELECT_CONTRACT: 'Select contract',
    SELECT_GRADE: 'Select grade',
    SELECT_SPECIALISATION: 'Select specialization',
    SHOW_CARDS: 'Show cards',
    SHOW_LIST: 'Show list',
    SPECIAL_CONTROL: 'Special control',
    SUPPORT_SLA: 'Support SLA',
    TECH_STACK: 'Tech stack',
    TIME_SOURCE: 'Timetracking source',
    TYPE_IN_POSITION_NAME: 'Type in position name',
    TOOLTIPS: {
      PROJECT_IS_NOT_OPERATIONAL: 'Project is not operational',
      PROJECT_TYPE_CANNOT_BE_CHANGED:
        "The project type can't be changed due to the branch field being filled with a value",
    },
    WORK_ORDER: 'Work Order',

    HARD_SKILLS: 'Hard skills',
    INACTIVE_POSITIONS: 'Inactive positions',
    POSITION_SUCCESSFULLY_ADDED: 'Position was successfully added',
    POSITION_SUCCESSFULLY_DELETED: 'Position was successfully deleted',
    POSITION_SUCCESSFULLY_UPDATED: 'Position was successfully updated',
    POSITION_DELETE_CONFIRMATION:
      'Are you sure you want to delete this position? All content will be lost.',
    SKILLS: 'Skills',
    SOFT_SKILLS: 'Soft skills',

    //delivery units
    CREATE_DELIVERY_UNIT: 'Create a delivery unit',
    EDIT_DELIVERY_UNIT: 'Edit delivery unit',
    DELETE_MODAL_CONFIRM:
      'Are you sure you want to delete this Delivery Unit?\nThis action cannot be undone',
    DELETE_MODAL_PROJECTS_EXITS:
      "To delete a Delivery Unit, make sure\nit doesn't contain projects",
    DELETE_UNIT: 'Delete Unit',
    DELIVERY_UNITS: 'Delivery units',
    NEW_UNIT: 'New unit',
    PROJECTS_MANAGERS: 'Projects managers',

    KEY: 'Key',
    PROJECT: 'Project',
    TOTAL: 'Total',

    BALANCE: 'Balance',
    CURRENT_WEEK: 'The current week',
    MONTHLY_BUDGET: 'Monthly budget',
    NEXT_WEEK: 'The next week',
    PREVIOUS_WEEK: 'The previous week',
    SECOND_WEEK: 'The second week',
    TITLE: 'Title',
    VALUE: 'Value',
    WORKED_OUT_HOURS: 'Worked out hours',

    //project
    ACCOUNT: 'Account',
    APPROVE_VACATION: 'Approve vacation with client',
    BASIC_INFO: 'Basic info',
    BUDGET_TRACKING: 'Budget Tracking',
    CONTRACT: 'Contract',
    CONTRACT_CANT_BE_ADDED:
      "Contract can't be added, as this position has at least one active allocation",
    COMMERCIAL: 'Commercial',
    COPY_POSITION: 'Copy position',
    CLIENT_INFO: 'Client info',
    DELIVERY_UNIT: 'Delivery unit',
    DOCUMENTS: 'Documents',
    MAIN_GOAL: 'The main goal of the project',
    NO_BRANCH: 'No branch',
    NON_COMMERCIAL: 'Non-commercial',
    NPS_STATUS: 'NPS status',
    OPERATIONAL: 'Operational',
    OVERALL_STATUS: 'Overall status',
    OVERVIEW: 'Overview',
    PROJECT_BUDGET: 'Budget',
    PROJECT_CASES: 'Project cases',
    PROJECT_HEALTH: 'Project Health',
    PROJECT_NEEDS: 'Project needs',
    PROJECT_TEAM: 'Project team',
    PROJECT_TYPE: 'Project type',
    RISKS: 'Risks',
    SCHEDULE: 'Schedule',
    SOWS: 'Sows',
    TIME_REPORTING: 'Time Reporting',
    WHAT_ABOUT: 'What is the project about',
    VALID_LINK: 'Please, enter a valid link',

    BUDGET_FILE: 'Budget',
    CONTACT_COUNTRY: 'Contact Country',
    FLOAT_PROJECT: 'Float Project',
    GIT: 'GIT',
    GMAIL_GROUP: 'Gmail Group',
    GOOGLE_DRIVE: 'Google Drive',
    JIRA_KEY: 'Jira Key',
    JIRA_URL: 'Jira URL',
    MANAGEMENT_LEVEL: 'Management Level',
    MANAGEMENT_TYPE: 'Management Type',
    NDA: 'NDA',
    NPS: 'NPS',
    PIVOTAL: 'Pivotal',
    PRODUCTION: 'Production',
    PROJECT_BRIEF: 'Project Brief',
    SCHEDULE_URL: 'Schedule',
    SPIRA: 'Spira',
    STAGING: 'Staging',
    WRONG_URL: 'Please enter a valid link',

    FLOAT_REMOVED: 'Project removed from Float.com',
    REFRESH_FLOAT: 'Refresh Float Ids',
    SUBMIT_CHANGES: 'Submit changes',

    ACTIVE_MEMBERS: 'Active members',
    ADDITIONAL_EMAILS: 'Additional emails',
    ADDITIONAL_INFO: 'Additional info',
    ADD_CLIENT: 'Add client',
    ADD_NEW_MEMBER: 'Add new member',
    CLIENT: 'Client',
    COOPERATION_FINISHED: 'Cooperation finished',
    COOPERATION_STARTED: 'Cooperation started',
    COMPANY_NAME: 'Company name',
    ENTER_CLIENT_PLACEHOLDER: 'Enter client ',
    FIRST_NAME: 'First name',
    INACTIVE_MEMBERS: 'Inactive members',
    LAST_NAME: 'Last Name',
    PHONE: 'Phone',
    SPECIFIC_PERSON: 'Specific Person',
    TIME_ZONE: 'Time Zone',
    WEBSITE_URL: 'Website URL',

    DEPLOYMENT_TOOLS: 'Deployment tools',
    TECH_USED: 'Technologies used',

    SELECT_SKILL: 'Select skill',

    DETAILING: 'Detailing',
    GOOGLE_TABLE: 'Google Table',
    INVOICE_SENDER: 'Invoice Sender',
    REPORTER: 'Reporter',
    REPORTER_NOT_SELECTED: 'Reporter is not selected',
    REPORT_FREQ: 'Reporting Frequency',
    REVIEWER: 'Reviewer',
    SEND_PDF: 'Send PDF to the client',
    SAVE_TIME_REPORTING: 'Save time reporting',
    UPDATE_POSITION: 'Update position',
    VIEW_ALLOCATION: 'View allocation',

    //lk settings
    ATTENTION_TITLE:
      'To set up notifications first save your time zone settings',
    CHOOSE_TIME_ZONE: 'Choose your time zone',
    COMMENTS_CHOICE: {
      ACKNOWLEDGED: 'Acknowledged',
      APPROVED: 'Approved',
      REJECTED: 'Rejected',
    },
    CONTROLS: {
      APPROVED: 'Approve',
      INPUT_TEXT: 'Send',
      REJECTED: 'Reject',
    },
    FORM_SETTINGS: 'Form settings',
    INST_LINK: 'Link on your Instagram profile',
    LANGUAGE_SETTINGS: 'Language settings',
    LINKEDIN_LINK: 'Link on your LinkedIn profile',
    LINK_ALERT: 'Please enter correct link',
    LK_SETTINGS: {
      ALWAYS: 'Always',
      ENGLISH: 'English',
      NEITHER: 'Neither',
      NEVER: 'Never',
      NO: 'No',
      ONLY_IN_WORK_TIME: 'Only in work time',
      RUSSIAN: 'Русский',
      VACATION: 'Vacation',
      YES: 'Yes',
    },
    NOTIFICATION_SETTINGS: 'Notification settings',
    PROFILE_SETTINGS: 'Profile settings',
    RECEIVE_NOTIFICATIONS: 'To receive notifications:',
    RECEIVE_SLACK_NOTIFICATIONS: 'Receive Slack notifications:',
    SAVE_SETTINGS: 'Save settings',
    SOCIAL_LEAVE_DAYS: 'Social leave days',
    SOCIAL_LEAVE_DAYS_IN_CURRENT_YEAR: 'Social leave days (current year)',
    SOCIAL_LINKS: 'Social links',
    STATUS_SETTINGS: 'Status settings',
    STATUS_TYPE: 'Status that other users see:',
    SYSTEM_LANGUAGE: 'Select system language',
    TIME_ZONE_SETTINGS: 'Time zone settings',
    VIEW_STATUS: 'Show your "Online" status to other users:',
    VK_LINK: 'Link on your VK profile',

    DROP_ZONE_TEXT: 'Drag and drop file here, or click to select one',

    INVALID_LINK: 'Invalid link',
    LINK_TO_FILE_LABEL: 'Link to the image',
    LINK_TO_FILE_PLACEHOLDER:
      'Add here a link or paste the image by pressing Ctrl + V',
    LINK_TO_FILE_FIREFOX_PLACEHOLDER:
      'Add here a link to the image by pressing Ctrl + V',
    PASTE_FROM_CLIPBOARD: 'Paste from clipboard',
    PASTE_TO_UPLOAD: 'Paste the image from the clipboard',
    PYRUS_FORM_DROP_ZONE_TEXT: {
      DRAG_AND_DROP: 'Drag and drop a file here',
      CLICK_TO_UPLOAD: 'or click to upload a file',
    },
    SELECT_FILES: 'Select files',

    //calendar
    CALENDAR_DIDNT_EXIST:
      'The calendar for the current year cannot be displayed because it has not yet been assigned.',
    CALENDAR_STATES: {
      APPROVED: 'Approved',
      CANCELLED: 'Cancelled',
      CREATED: 'Created',
      DAYOFF: 'Holiday',
      IN_PROGRESS: 'In progress',
      PAID_VACATION: 'Paid vacation',
      PAID_AND_UNPAID_VACATION: 'Paid and unpaid vacation',
      PAID_AND_UNPAID_SICK_LEAVE: 'Paid and unpaid sick leave',
      REMOTE_WORK: 'Remote work',
      SICK_LEAVE: 'Sick leave',
      TRANSFER_DAY: 'Transfer day',
      TRANSFER_TIME: 'Transfer time',
      UNPAID_VACATION: 'Unpaid vacation',
      USED: 'Used',
    },
    CALENDAR: 'Calendar',
    CALENDAR_CARD_TOOLTIP_TEXT: 'Highlight in calendar',
    CALENDAR_FILTER_NO_FILTERED_EVENTS:
      'There are no results \n for these filters.',
    CALENDAR_FILTER_NO_EVENTS: 'There are no time offs.',
    CALENDAR_FILTER_POPUP_CLEAR_ALL: 'Clear all',
    CALENDAR_FILTER_POPUP_TITLE: 'Vacation status',
    CALENDAR_NO_POLICY_LINKS: 'There are no links',
    CALENDAR_POLICY_LINKS_TITLE: 'Policy links',
    CALENDAR_STATISTICS_BAR: {
      USED: 'Used',
      PLANNED: 'Planned',
      PLANNED_EXPLAIN: 'Number of vacation days in the Approved status.',
      LEFT: 'Left',
      TOTAL: 'Total',
      TOTAL_EXPLAIN:
        'Number of the vacation days that user can use in the current year(Weekends and holidays are not included).',
      EARNED: 'Total earned',
      EARNED_EXPLAIN:
        'Number of total earned vacation days that can be taken at the current moment without advanced vacation days (Weekends and holidays are not included).',
      AVAILABLE_EXPLAIN:
        'Number of vacation days that user can use at the current moment(Available days = Earned days + Advanced days).',
    },
    CALENDAR_VIEW: 'Calendar view',
    FLOATING_HOLIDAY: 'Floating holiday',

    // timeportal
    ADD_ALLOCATION: 'Add allocation',
    ALLOCATION: 'Allocation',
    ALLOCATION_MODAL_ERROR: {
      ALLOCATION_TYPES_CAN_NOT_REPEAT: 'Allocation types can not repeat',
      EMPTY_EMPLOYEE: "Employee can't be empty",
      EMPTY_TASKS: "Tasks can't be empty",
      NO_ALLOCATION_TYPES: 'No allocation types created for this project',
      PERIOD_REQUIRED: 'Allocation Period is required',
      TIME_PER_DAY_GREATER_THAN: 'Time per day should be greater than 0h 0m',
      TIME_PER_DAY_LESS_THAN: 'Time per day should be less or equal than 12h',
      TOTAL_TIME_NOT_EQUAL_TIME_PER_DAY:
        'The total time allocated across all types should match the set daily allocation of {h} hours {m} minutes',
    },
    ALLOCATION_TYPE: 'Allocation type',
    ALLOCATION_START_DATE: 'Start date',
    ALLOCATION_END_DATE: 'End date',
    ALLOCATION_PERIOD: 'Allocation period',
    ALLOCATION_PERIOD_CHANGED:
      'Allocation periods were changed for all selected employees.',
    ALLOCATION_PERIOD_NOT_CHANGED:
      'Allocation periods were not changed for several selected employees.',
    ALLOCATION_START_DATE_CANNOT_BE_UPDATE:
      "Allocation can't be updated because employee already has allocation with the same task for the same period",
    ALLOCATIONS: 'Allocations',
    ALLOCATIONS_IN_DAYS: 'Allocations in days',
    AUTO_TRACKING_TEXT_PLACEHOLDER: 'Type description for auto tracking task',
    CAPACITY_GAP: 'Capacity gap',
    CANT_BE_SHORTENED: "Can't be shortened as there is a task with worklogs.",
    CANT_BE_SHORTENED_AS_ALLOCATION:
      'Can’t be shortened as allocation type is archived',
    COPY_ALLOCATION: 'Copy allocation',
    CREATE_ALLOCATION: 'Create allocation',
    DELETE_ALLOCATION: 'Delete allocation',
    DELETE_ALLOCATION_MESSAGE:
      'Are you sure you want to delete this allocation?',
    DELETE_TASK: 'Delete task',
    DELETE_TASK_MESSAGE: 'Are you sure you want to delete this task?',
    DM_PLANNED_TIME: 'DM planned time',
    EDIT_ALLOCATION_PERIOD: 'Edit allocations period',
    END_DATE_CANNOT_BE_ERLIER: 'End date cannot be earlier than start date.',
    HOURS_PER_DAY: 'Hours per day',
    LIST_VIEW: 'List view',
    LAST_EDITED_BY: 'Last edited by',
    NO_ALLOCATION_TYPES:
      'There are no Allocation types assigned to the project.\nPlease contact Administrator',
    NO_ALLOCATIONS: 'No Allocations',
    SEARCH_BY_POSITION: 'Search by position',
    TASK_CANT_BE_DELETED: "Task with worklogs can't be deleted",
    TASK_FOR_TRACKING_JIRA:
      'Task for tracking from Jira is created automatically',
    TIME_OFF: 'Time off',
    TIME_PER_DAY: 'Time per day',
    TIME_TRACKING: 'Time tracking',
    TIME_TRACKING_MANAGEMENT: 'Time Tracking Management',
    THE_CONTRACT_PERIOD_DOES_NOT_MATCH_PERIOD:
      'The contract period does not match the selected period.',
    OVERTIME: 'Overtime',
    UPDATE_TASK: 'Update task',
    UPDATE_ALLOCATION: 'Update allocation',
    VACATIONS_AND_SICK_LEAVES: 'Vacations and sick leaves',
    WARNING_NO_ALLOCATION_TYPES:
      'There are no Allocation types assigned to the project.\nPlease contact Administrator',
    WARNING_NO_EMPLOYEES:
      'There are no active employees assigned to the project',
    NO_POSITIONS_CREATED_FOR_PROJECT:
      'No positions were created for the project',
    WARNING_NO_TASKS: 'There are no tasks assigned to the project',
    WORKLOAD_ISSUES: 'Workload issues',
    ALLOCATION_DISCARDED_AT_WARNING_MESSAGE:
      'All linked allocations that have a finish date later than Archive date will be active till Archive date.',
    DISABLED_DELETE_TASK_BUTTON_MESSAGE:
      'This task cannot be deleted because there is at least 1 allocation that uses it',

    //timetracking
    ADD_WORKLOG: 'Add worklog',
    ENTER_JIRA_TASK: 'Enter Jira task.',
    REASON_OF_UNCHANGED: 'Reason for unchanged date',
    LOGGED_WORKLOGS: 'Logged worklogs',
    LOG_IN_JIRA: 'Log in Jira',
    PERIOD_SHOULD_CORRESPOND_CONTRACT:
      'Period should correspond Contract (if any) to which Position belongs',
    SEVERAL_DATES: 'Several dates',
    TO_ADD_WORKLOG_YOU_NEED_LOGIN_JIRA:
      'To add worklog you need to login in to Jira',
    THIS_TASK_UNAVAILABLE_FOR_TIME_TRACKING:
      'This task is unavailable for time tracking. Please check Jira or contact your project manager.',
    INVALID_JIRA_TASK_FORMAT: 'Invalid task format. Use ABC-123 or just 123.',
    IF_YOU_SELECT_MORE_THAN_ONE_DAY_WORKLOGS:
      'If you select more than 1 day, worklogs will be added only for working days',
    YOU_NOT_A_MEMBER_OF_JIRA_PROJECT:
      'You’re not a member of this Jira project. Contact your project manager for access.',

    //vacations_analytics
    AVAILABLE_VACATION_DAYS: 'Available vacation days (advance)',
    AVAILABLE_VACATION_DAYS_AT_THE_END_OF_YEAR: 'Vacation days on December 31',
    CHOOSE_PROJECT: 'Choose project',
    EARNED_VACATION_DAYS: 'Earned vacation days',
    PLANNED_VACATION_DAYS: 'Planned vacation days',
    VACATIONS_ANALYTICS: 'Analytics by unused vacations',

    //tools
    AGREEMENT: 'Approval',
    BAD: 'Bad',
    DIFFTIME: 'Total working time spent',
    ENDDATE: 'End date',
    GOOD: 'Good',
    HEAD_DEVELOPMENT: 'Employees with events',
    SOURSCERS: 'Sourcers SLA',
    STARTDATE: 'Start date',
    TOOLS: 'Tools',
    TYPE_VACATION: 'Vacation type',

    //people menagment
    PEOPLE_MANAGEMENT: 'People Management',
    SUPPORT_LINK: 'Send your feedback\nto our Support channel',

    //sla forms
    CHOOSE_FILE: 'Choose file',
    CHOOSE_FORM: 'Choose form',
    DOWNLOAD: 'Download',
    FILE: 'File',
    UPLOAD: 'Upload',

    GOOGLE_SIGN_IN: 'Sign in with Google',
    LEGEND: 'Legend',
    MESSAGE_SENT: 'The message has been sent',

    //user_limits_modal
    DATES_VALIDATION_MESSAGE:
      'Fill in the date of start work or the date of start internship',
    USER_MODAL_NAME: 'Edit limits of user',
    WORKING_WITH_THE_CALENDAR: 'Working with the calendar:',

    //profile
    BACK_TO_PROFILE: 'Back to profile',
    EDIT_PROFILE: 'Edit profile',
    REMOTE_WORKER: 'Remote worker',
    SHOW_ALL_STATUSES: 'Show all statuses',

    //created tasks
    EDITED_FIELDS: 'edited fields',
    TASK_STATE: {
      ACTIVE: 'active',
      CLOSED: 'closed',
      FINISHED: 'finished',
      REOPENED: 'reopened',
    },
    RECALCULATE_DATE: 'days from the task creation date',
    RECALCULATE_DATE_CHECKBOX: 'Calculate on creation',
    TIME_OFF_TOOLTIP: {
      TRANSFER_FROM_TO: 'Working on {to} instead of {from}',
      TRANSFER_FROM: 'Working on {to}',
      TRANSFER_TO: 'Working today instead of {from}',
      SICK_LEAVE: 'Sick leave',
      VACATION: 'Vacation',
    },
  },

  ru: {
    //common
    ACTIVE_ROLES: 'Активные роли',
    ACTUAL_LOCATION: 'Фактическая локация',
    ADD_CURRENT_PAGE_TO_FAVOURITES: 'Добавить текущую страницу в избранное',
    ADD_DOCUMENT: 'Добавить документ',
    ADD_EVENT: 'Добавить событие',
    ADD_ITEM: 'Добавить запись',
    ADD_LINK: 'Добавить ссылку',
    ADD_ROLE: 'Добавить роль',
    ADD_TO_FAVOURITES: 'Добавить в избранное',
    ADDITIONAL_INFO_HIDE: 'Скрыть дополнительную информацию',
    ADDITIONAL_INFO_SHOW: 'Показать дополнительную информацию',
    ADDITIONAL_VACATION_DAYS_FOR_HOLIDAYS:
      'Кол-во доп дней отпуска за работу в Праздничные дни (в прошлом году)',
    ADDITIONAL_VACATION_DAYS_IN_PREVIOUS_YEAR:
      'Количество дополнительных (социальных) дней отпуска в прошлом году',
    ADDING_A_WORKLOG_NOT_ALLOWED:
      'Добавление ворклога за этот день недоступно, так как логи за этот день уже подтверждены.',
    AFFECTED_EMPLOYEES: 'адействованные сотрудники:',
    AFTER: 'После',
    ALL_CATEGORIES_WERE_MAPPED_SUCCESSFULLY:
      'Все категории были успешно сопоставлены.',
    ALLOCATION_TYPE_WILL_BE_ARCHIVED_AT: 'тип аллокации будет архивирован',
    ALLOCATION_WITHOUT_ASSIGNED_EMPLOYEES:
      'Аллокации без назначенных сотрудников',
    APPLY: 'Применить',
    APPROVE: 'Подтвердить',
    ASK_QUESTION: 'Задать вопрос',
    ARCHIVE_DATE: 'Дата архивации',
    ARCHIVE_DOCS: 'Архивированные документы',
    ARCHIVED_PLURAL: 'Архивные',
    ARE_YOU_SURE: 'Вы уверены?',
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_LINK:
      'Вы уверены, что хотите удалить данную ссылку?',
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_WORKLOG:
      'Вы уверены, что хотите удалить данный ворклог?',
    AUTHOR: 'Автор',
    AUTO_TRACKING: 'Авто трекинг',
    AUTO_TRACKING_TEXT: 'Текст авто трекинга',
    AUTO_TRACKING_TIME: 'Время авто трекинга',
    BACK: 'Назад',
    GO_TO_MAIN_PAGE: 'Вернуться на главную',
    BEFORE: 'До',
    BROKEN_TASK: {
      HEADING: 'К сожалению, эта задача работает некорректно.',
      CONTENT: 'Приносим извинения за вынужденные неудобства.',
    },
    BUDGET_1: 'Финансовая',
    BUDGET_INFORMATION: 'Финансовые данные',
    CANCEL: 'Отмена',
    CALENDAR_WEEK: 'Календ. неделя',
    CHANGES: 'Изменения',
    CHANGE_ROLE: 'Изменить роль участника',
    CHOOSE: 'Выберите',
    CHOSEN_PERIOD_LATER:
      'Выбранный период выходит за дату архивации выбранного типа аллокации.',
    CLEAR_ALL: 'Очистить всё',
    CLICK_TO_ADD_WORKLOGS_FROM_GOOGLE_CALENDAR:
      'Нажмите, чтобы добавить ворклоги из Google Календаря',
    CLIENT_PROJECT_UTILIZATION:
      '% участия в клиентских проектах (за прошедший год)',
    COLOR: 'Цвет',
    COLUMN_VISIBILITY: 'Отображение колонок',
    COMMENT: 'Комментарий',
    COMMENT_ADD: 'Добавить комментарий',
    COMMENT_VALIDATION_MESSAGE: 'Комментарий должен быть не менее 3 символов',
    COMPANY_REGULATIONS: 'Политики компании',
    COMPENSATED_VACATION_DAYS: 'Компенсированных дней отпуска (в прошлом году)',
    COMPLETE: 'Завершить',
    COMPLETED: 'Завершенные',
    CONFIRM: 'Подтвердить',
    CONTINUE_WITH_SSO: 'Continue with SSO',
    CONTRACT_CANT_BE_DELETED:
      'Контракт нельзя удалить, так как он связан минимум с одной позицией',
    CONTRACT_IS_EXPIRED: 'Срок действия контракта закончился',
    CONTRACT_PERIOD_DOES_NOT_COVER:
      'Период контракта не покрывает эту аллокацию',
    CONTRACTS_WITH_OVERLAPPING_PERIODS_CANT_BE_ADDED:
      'Нельзя добавить контракты с пересекающимися периодами',
    COPY: 'Скопировать',
    COPY_LINK_TO_ERP: 'Копировать ссылку на задачу в ERP',
    COPY_LINK_TO_PYRUS: 'Копировать ссылку на задачу в Pyrus',
    CREATE_ANOTHER: 'Создать ещё один',
    CREATE_REQUEST: 'Создать запрос',
    CREATE_TASK: 'Создать задачу',
    CREATE_OUT_OF_ORDER_TASK: 'Создать задачу внеочереди',
    CREATED_AT: 'Создан',
    CREATED_BY_ME: 'Созданые мной',
    CREATED_BY_OTHERS: 'Созданые другими',
    CREATED_DATE: 'Дата создания',
    CREATION_DAY: 'День создания',
    CREATION_TIME: 'Время создания',
    CUSTOM: 'Выбрать вручную',
    CURRENT_STEP: 'Этап согласования',
    DATA_SUCCESFULLY_SYNCHRONIZED: 'Данные успешно синхронизированы.',
    DATA_FROM_PREVIOUS_STEPS: 'Данные из предыдущих шагов',
    DAY: 'День',
    DELETE: 'Удалить',
    DEPARTMENT: 'Департамент',
    DEPARTMENT_1: 'Департаменту',
    DESCRIPTION_SHOULD_BE_NO_LONGER_THAN:
      'Описание должно быть не длиннее 500 символов',
    DESCRIPTION_IS_MANDATORY: 'Поле описание обязательно',
    DESIGN: 'Дизайн',
    DEVELOPMENT_CONTRACT: 'Контракт на разработку',
    DO_NOT_FORGET_TO_GRANT_ACCESS_AND_EDITING_RIGHTS:
      'Не забудьте предварительно предоставить доступ и права на редактирование документа для',
    DOES_NOT_EXIST: 'Отсутствует',
    DOCUMENT_TYPE: 'Тип документа',
    DOCUMENT_TYPE_IS_MANDATORY: 'Поле Тип документа обязательно',
    DOCUMENTATION: 'Документация',
    DONE: 'Готово',
    DURATION: 'Длительность',
    DURATION_H: 'Длительность (ч)',
    EDIT: 'Редактировать',
    ENGINEERING_MANAGER: 'Engineering manager',
    EMPLOYEE_BECOMES_INACTIVE_WHEN_ALLOCATION_PERIOD_ENDS:
      "Сотрудник станет 'неактивным' по завершении периода аллокации",
    EMPLOYEES_HEATMAP: 'Хитмеп сотрудников',
    EMPLOYEE_STAY_ACTIVE_WITH_AN_ACTIVE_ALLOCATION:
      "Сотрудник 'активный' при наличии действующей аллокации или привязке к отделу.",
    ENGINEERING_MANAGERS: 'Engineering managers',
    ENTER: 'Введите',
    ENTER_DATE: 'Введите дату',
    ENTER_VALID_EMAIL_ADDRESS: 'Введите корректный email',
    ENTER_VALID_URL: 'Введите корректную ссылку',
    EDIT_PERIOD: 'Изменить период',
    EDIT_AVATAR: 'Смена фото профиля',
    EDIT_WORKLOG: 'Обновить ворклог',
    EDITABLE_UNTIL: 'Редактируемый до',
    EDITING_CLOSED: 'Редактирование закрыто',
    EMPLOYEE_TYPE_1: 'Типу сотрудника',
    EDUCATION: 'Образование',
    ERP_SUPPORT: 'ERP поддержка',
    ERROR_INCORRECT_TIME_VALUE: 'Неверное значение времени',
    ERROR_TASK_NAME_LENGTH:
      'Название задачи должно быть не длиннее 100 символов',
    ERROR_TASK_NAME_REQUIRED: 'Название задачи обязательно',
    ERROR_TIME_GREATER_THAN:
      'Auto tracking time should not be longer than 8 hours',
    ERROR_TIME_REQUIRED: 'Auto tracking time should be greater than 0 h 0 min',
    ERROR_TIMELOG_TEXT_LENGTH:
      'Auto tracking text should be no longer than 100 symbols',
    ERROR_TIMELOG_TEXT_REQUIRED:
      'Auto tracking text is mandatory for Auto tracking task',
    ERROR_TITLE_LENGTH: 'Название должно быть не длиннее 100 символов',
    ERROR_TRANSFER:
      'Перенос возможен в пределах одного месяца. Пожалуйста, укажите правильные даты.',
    ERROR_TRANSFER_DAY:
      'Перенос дня возможен в пределах одного месяца. Пожалуйста, укажите правильные даты.',
    ERROR_TRANSFER_TIME:
      'Перенос времени возможен в пределах одного месяца. Пожалуйста, укажите правильные даты.',
    EVENTS: 'События',
    EVENTS_ON: 'События за',
    EXIST: 'Есть',
    EXPORT: 'Скачать',
    EXPORT_ALLOCATION_PLAN: 'Экспорт плана аллокаций',
    EXPORT_TYPE: 'Тип выгрузки',
    FOR: 'для',
    FAILED_TO_ADD_WORKLOG:
      'Не удалось добавить ворклог в Jira. Пожалуйста, проверьте подключение к интернету и попробуйте снова.',
    FAILED_TO_DELETE_WORKLOG:
      'Не удалось удалить ворклог. Пожалуйста, попробуйте позже.',
    FIELD_DATE_IS_MANDATORY_FOR_DEVELOPMENT_CONTRACTS:
      'Поле Дата обязательна для контрактов на разработку',
    FILTER_BY: 'Фильтровать по',
    FILTER_BY_AUTHOR: 'Фильтр по автору',
    FILTER_BY_STATUS: 'Фильтр по статусу',
    FILTER_BY_TYPE: 'Фильтр по типу',
    FINANCE_SUPPORT: 'Финансовая поддержка',
    FISCAL_WEEK: 'Фин неделя',
    FLEXIBLE_HOLIDAYS: 'Плавающие выходные',
    FROM: 'c',
    GOOGLE_CALENDAR_EVENTS: 'События из Google Календаря',
    GOOGLE_CALENDAR_SYNC: 'Синхронизация с Google Календарём',
    GROUP_BY: 'Группировать по',
    GENERAL_1: 'Общая',
    GENERAL: 'Общее',
    GENERAL_BLOCK: 'Общий блок',
    GENERAL_INFORMATION: 'Общие данные',
    GENERAL_SUPPORT: 'Общая поддержка',
    GO_TO: 'Перейти',
    GOOGLE_MEETS_CATEGORIES_LINKING: 'Связывание категорий с Google Meet',
    HANG_TIGHT: 'Извините, скоро мы все починим!',
    HEALTH: 'Состояние',
    HELP_BLOCK: 'Блок поддержки',
    HIDE_THIS_ALLOCATION_FROM_CALENDAR_VIEW:
      'Не показывать аллокацию на календарном виде',
    IN_WORK: 'В работе',
    INTEGRATION: 'Интеграция',
    INVALID_HIERARCHY: 'Конфликт иерархии:',
    JIRA_RELATED_TASK_CANT_BE_UPDATED_OR_DELETED:
      'Задача для трекинга из Jira не может быть удалена или отредактирована',
    HOLIDAYS: 'Выходные',
    HOUR: 'ч',
    HOURS: 'Часов',
    INTERNAL: 'Внутренний',
    LAST_MONTH: 'Прошлый месяц',
    LAST_THREE_MONTHS: 'Прошедшие 3 месяца',
    LAST_SIX_MONTHS: 'Прошедшие 6 месяцев',
    LAST_WORKING_DAY: 'Дата окончания работы в компании',
    LEAVE: 'Выйти',
    LESS_THAN: '-',
    LEGAL: 'Юридические',
    LEGEND_PROJECT_TYPE_WITH_TENTATIVE: 'Тип проекта',
    LEGEND_TOTAL: '8 часов',
    LEGEND_TOTAL_LESS: 'Менее 8ч',
    LEGEND_TOTAL_MORE: 'Более 8ч',
    LIMIT_CHANGES: 'Изменение лимитов',
    LINK: 'Ссылка',
    LINK_CATEGORIES: 'Связать категории',
    LINK_IS_MANDATORY: 'Поле Ссылка обязательно',
    LINK_SHOULD_START: 'Ссылка должна начинатся с "/"',
    LINK_SUCCESSFULLY_ADDED: 'Ссылка успешно добавлена.',
    LINK_SUCCESSFULLY_UPDATED: 'Ссылка успешно обновлена.',
    LIST_IS_EMPTY: 'Список пуст',
    JIRA_SYNC: 'Синх период с JIRA',
    LOGGED_ON: 'Добавлен ',
    MANAGEMENT: 'Управление',
    MONTH_1: 'Месяц',
    MEETING_INDICATORS: {
      EMPLOYEE_PERFORMANCE: 'Эффективность сотрудника',
      HAPPINESS_INDEX: 'Индекс счастья',
      IMPACT_OF_LEAVING: 'Влияние ухода',
      RISK_OF_LEAVING: 'Риск ухода',
    },
    MEETING_INDICATOR_VALUES: {
      EXCEED_EXPECTATIONS: 'Превосходит ожидания',
      EXCITED: 'Счастливый',
      FRUSTRATED: 'Расстроенный',
      GOOD: 'Хорошо',
      GREAT: 'Довольный',
      HIGH: 'Высокий',
      LOW: 'Низкий',
      MEDIUM: 'Средний',
      MEET_EXPECTATIONS: 'Соответсвует ожиданиям',
      NEED_IMPROVEMENT: 'Нуждается в совершенствовании',
      NEUTRAL: 'Нейтральный',
      OUTSTANDING: 'Выдающийся',
      UNACCEPTABLE: 'Неприемлемый',
    },
    NAME: 'Название',
    NEW: 'Новое',
    STATISTICS: 'Статистика',
    NEXT: 'Дальше',
    NEXT_FISCAL_WEEK: 'Следующая финансовая неделя',
    NO: 'Нет',
    NO_ACTIVE_ALLOCATIONS: 'Нет активных аллокаций на эту позицию',
    NO_AVAILABLE_FORMS: 'У вас нет задач',
    NO_DESCRIPTION: 'Нет описания',
    NO_LINKS_YET: 'Пока нет ссылок',
    NO_TASKS: 'No tasks',
    NO_RESULTS_FOUND: 'Ничего не найдено',
    NO_WORKLOGS_FOUND: 'Нет ворклогов за выбранный период',
    NOT_COMPLETED: 'Не завершенные',
    NOT_FOUND: 'Не найдено',
    NOT_READ: 'Непрочитано:',
    NO_ROLES: 'Нет доступных ролей',
    NOTHING_FOUND: 'Ничего не найдено',
    NOT_FOUND_PROFILE: 'Профиль не найден, обратитесь к администратору',
    OF: 'У',
    OK: 'Ок',
    ONLY_LATIN: 'Допускаются только латинские символы, цифры и символ "-"',
    ONLY_ACTIVE_ALLOCATIONS: 'Только активные аллокации',
    ONLY_TENTATIVE_ALLOCATIONS: 'Только неподтвержденная загрузка',
    ONLY_PLACEHOLDER: 'Только плейсхолдеры',
    OPEN: 'Открыть',
    OPEN_IN_PYRUS: 'Открыть форму в Pyrus',
    OPEN_TASKS_IN_PYRUS: 'Открыть задачи в Pyrus',
    PAGE_NOT_EXIST: 'Страница, которую вы запрашиваете, не существует.',
    PAGE_REMOVED_OR_OUT_OF_DATE: 'Возможно, она была удалена или устарела.',
    PART_TIME: 'Неполная занятость',
    PARTIAL_CONTRACT_COVERAGE: 'Частичное покрытие контрактом',
    PASTE_LINK: 'Вставьте ссылку',
    PERIOD: 'Период',
    YOU_DONT_HAVE_PERMISSION: 'У вас нет разрешения на доступ к этой странице.',
    PLEASE_CONTACT_US_SUPPORT:
      'Если у вас возникнут какие-либо вопросы, свяжитесь с нами через форму поддержки.',
    PICK_A_DATE: 'Выберите дату',
    PICK_A_PERIOD: 'Выберите период',
    PLANNED_TIME: 'Запланировано',
    PLACEHOLDER: 'Плейсхолдер',
    PLEASE_CONTACT_US: {
      PART_ONE: 'Пожалуйста, свяжитесь с нами через ',
      PART_TWO: ', если у вас остались какие-либо вопросы.',
    },
    POSITION: 'Позиция',
    POSITION_CARD_CANT_BE_DELETED_ACTIVE_ALLOCATION:
      'Карточку позиции нельзя удалить, так как она связана минимум с одной активной аллокацией.',
    POSITION_CARD_CANT_BE_DELETED_INACTIVE_ALLOCATION:
      'Карточку позиции нельзя удалить, так как она связана минимум с одной неактивной аллокацией.',
    POSITION_NAME: 'Название позиции',
    POSITIONS: 'Позиции',
    PYRUS_ID: 'ID',
    PROJECT_INFORMATION: 'Информация о проекте',
    PROJECT_STATUSES_ARE_ABSENT: 'Отсутствуют статусы по проекту',
    PUBLICATIONS: 'Публикации',
    REASON: 'Причина',
    REASON_FOR_CREATING_EVENT: 'Причина создания события',
    REASON_FOR_CANCELING_EVENT: 'Причина отмены события',
    REASON_FOR_RESTORING_EVENT: 'Причина восстановления события',
    RESOURCE_MANAGEMENT: 'Управление ресурсами',
    RESOURCE_PLANNING: 'Ресурсное планирование',
    QUIT_FROM_FORM: 'Вы уверены, что хотите закрыть форму?',
    RECURRENT: 'Повторяющиеся',
    RECURRING_TASKS: 'Повторяющиеся задачи',
    REFERRAL: 'Реферрал',
    REGISTY: 'Реестр',
    REJECT: 'Отклонить',
    REMOTE: 'Удаленная работа',
    REMOVE: 'Удалить',
    REQUIRE_ACTION: 'Require action',
    RESOLVED_BY: 'Решено',
    REVOKE: 'Отозвать',
    IN_THIS_MONTH: 'в этом месяце',
    ISSUE_IS_NOT_RESOLVED: 'Вопрос не решен',
    RESET: 'Сбросить',
    REST_VACATION_DAY: 'ДОСТУПНЫХ дней отпуска на',
    REVIEW_DATE: 'Дата ревью',
    ROLES: 'Роли',
    RUN_MANUALLY: 'Запустить вручную',
    SAVE: 'Сохранить',
    SAVING: 'Сохранение...',
    SEARCH: 'Поиск',
    SEARCH_FORM: 'Поиск формы',
    SEARCH_BY_HR: 'Поиск по HR',
    SEARCH_BY_MENTOR: 'Поиск по ментору',
    SELECT: 'Выберите',
    SELECT_ALL: 'Выбрать всё',
    SELECT_DOCUMENT_TYPE: 'Выберите тип документа',
    SELECT_FLOAT_PROJECT: 'Выберите float проект',
    SELECT_FROM: 'C',
    SELECT_PROJECT_TYPE: 'Выберите тип проекта',
    SELECT_ROLE: 'Выберите роль',
    SELECT_TASK: 'Выберите задачу',
    SELECT_TASK_FOR_THIS_COLOR: 'Выберите задачу для этого цвета',
    SELECT_TO: 'По',
    SEND: 'Отправить',
    SENDING: 'Отправляетcя',
    SHARE_LINK: 'Поделиться ссылкой',
    SHARE_WITH: 'Поделиться с',
    SHARED_WITH: 'Поделился с',
    SHOW_DETAILS: 'Показать детали',
    SHOW_LEGEND: 'Показать легенду',
    SHOW_LESS: 'Показать меньше',
    SHOW_MORE: 'Показать больше',
    SHOW_MY_PROJECTS: 'Показать мои проекты',
    SICK_LEAVE_REQUEST: 'Запрос на больничный',
    SINCE: 'c',
    SKIP: 'Убрать',
    SPECIALITY: 'Специальность',
    SPECIALITY_1: 'Специальности',
    STATUS: 'Статус',
    STATUSES: 'Статусы',
    SYNCHRONIZATION_COMPLETED_SUCCESSFULLY: 'Синхронизация выполнена успешно.',
    SYNCHRONIZATION_COULD_NOT_BE_COMPLETED:
      'Не удалось выполнить синхронизацию. Пожалуйста, обратитесь в поддержку.',
    SUBMIT: 'Отправить',
    SUBSCRIBE: 'Подписаться',
    FAKE_THE: '',
    SUM_OF_HOURS: 'Сумма часов',
    IN_ALLOCATION_TYPES_IS_HIGHER_THAN_THE: 'в типах аллокации больше, чем',
    NUMBER_OF_HOURS: 'количество часов',
    NO_EVENTS_FOUND_FOR_TODAY: 'На сегодня событий не найдено',
    IF_NO_TASK_IS_SPECIFIED:
      'Если задача не указана, эта строка не будет сопоставлена.',
    IN: 'в',
    SUPERVISOR: 'Руководитель',
    SUPPORT_FORM: 'форму поддержки',
    TASK_FINISHED: 'Задача завершена',
    TASK_NAME: 'Название задачи',
    TASK_REOPENED: 'Задача вновь открыта',
    TASK: 'Задача',
    TASKS: 'Задачи',
    TEMPORARY_UNAVALIABLE: 'Страница временно недоступна.',
    TENTATIVE: 'Неподтвержденная загрузка',
    TENTATIVE_ALLOCATION: 'Неподтвержденная загрузка',
    TENTATIVE_TAG: 'Неподтв.',
    TEXT_SHOULD_NOT_BE_LONGER_THAN:
      'Длина текста не должна превышать 16 символов',
    THE_EVENT_WON_T_BE_ADDED_UNLESS_YOU_SELECT:
      'Это событие не будет добавлено, если не выбрать проект и задачу.\nВы можете назначить их позже.',
    THE_REASON_CANNOT_EXCEED: 'Причина не может содержать более 1000 символов.',
    THIS_FIELD_IS_MANDATORY: 'Это поле обязательно',
    THIS_IS_NOT_VALID_LINK: 'это недействительная ссылка',
    THIS_MONTH: 'Текущий месяц',
    THIS_PARAMETER_CANT_BE_CHANGED_FOR_INACTIVE_ALLOCATION:
      'Параметр нельзя изменить для неактивной аллокации',
    THREE_MONTH: 'Три месяца',
    TILL: 'до',
    TIME: 'Время',
    TIME_IS_TRACKED_DAILY:
      'Подключенная система будет отслеживать время ежедневно. Нажмите на дату, чтобы запустить синхронизацию вручную.',
    TIME_SHOLUD_BE_NO_GREATER_THAN: 'Время должно быть больше 0ч 0м',
    TIME_RANGE:
      'Количество вносимых часов должно быть больше 0 и не превышать 8',
    TITLE_IS_MANDATORY: 'Поле Название обязательно',
    TO: 'К',
    TO_EDIT_A_PERIOD:
      'Чтобы редактировать период, выберите один проект и хотя бы одну аллокацию.',
    TO_SAVE_WORKLOG: 'чтобы сохранить ворклог',
    TODAY: 'Сегодня',
    TOTAL_AVAILABLE_VACATION_DAYS_CURRENT_YEAR:
      'Всего доступных дней отпуска в текущем году',
    TOTAL_AVAILABLE_VACATION_DAYS_PREVIOUS_YEAR:
      'Всего доступных дней отпуска в прошлом году',
    TOTAL_LOGGED_TIME: 'Общее внесённое время',
    TOTAL_PROJECT: 'Итого (проект)',
    TRY_AGAIN: 'Попробовать снова',
    TYPE: 'Тип',
    TYPE_DOCUMENT_TITLE: 'Введите название документа',
    TYPE_HOURS: 'Часы',
    TYPE_REASON: 'Введите причину',
    TYPE_TASK_NAME: 'Введите название задачи',
    TYPE_OF_PARTNERSHIP: 'Типу сотрудничества',
    TWO_HRS_CANT_BE_EACH_OTHER_SUPERVISORS:
      'невозможно установить взаимное руководство между двумя HR.',
    TWO_MENTORS_CANT_BE_EACH_OTHER_SUPERVISORS:
      'невозможно установить взаимное руководство между двумя менторами.',
    UNABLE_TO_SEND_WORKLOG_TO_JIRA:
      'Не удалось отправить ворклог в Jira из-за системной ошибки. Пожалуйста, попробуйте снова позже или обратитесь в поддержку, если проблема сохраняется.',
    UNSELECT_ALL: 'Отменить весь выбор',
    UNSUBSCRIBE: 'Отписаться',
    UPDATE: 'Обновить',
    UPLOAD_FILE: 'Загрузить новый файл',
    VACATION_POLICY: 'Политика в отношении отпуска',
    VACATION_REQUEST: 'Запрос на отпуск',
    VIEW_PROFILE: 'Перейти в профиль',
    VIEW_RESOURCE_PLANNING: 'Посмотреть в Ресурсном планировании',
    USED_VACATION_DAYS: 'Использованных дней отпуска в прошлом году',
    USER_AVATAR: 'Фото профиля',
    YES: 'Да',
    WIKI: 'Вики',
    WEEK_1: 'Неделя',
    WORKED_DAYS_IN_PREVIOUS_YEAR: 'Отработанных дней за прошлый год',
    WORKLOG_DELETED_SUCCESSFULLY: 'Ворклог успешно удалён!',
    WORKLOG_SAVED_SUCCESSFULLY: 'Ворклог успешно сохранён!',
    WORKLOG_SUCCESSFULLY_ADDED_TO_JIRA: 'Ворклог успешно добавлен в Jira.',
    WORKLOG_UPDATED_SUCCESSFULLY: 'Ворклог успешно обновлён!',
    WORKLOGS: 'Ворклоги',
    WORKLOGS_IMPORTED_FROM_JIRA:
      'Ворклоги импортированные из Jira.\nДанные в этой строке нельзя редактировать или удалить.',
    WORKLOGS_WAS_SUCCESSFULLY_ADDED: 'Ворклог(и) был успешно добавлен',
    WORKLOGS_WASN_T_ADDED: 'Ворклог(и) не добавлены',
    WORKPLACE: 'Воркплейс',
    WRONG_FORM_FIELD: `Нельзя отправить форму. Присутствует неккоректное значение '{value}' в поле '{field}'`,
    SPECIALIZED_FORMS: 'Специализированные формы',

    BUDGET: {
      AVAILABLE: 'Доступный бюджет',
      BALANCE: 'Баланс',
      EDIT: 'Редактировать бюджет',
      EXPECTED_BALANCE: 'Ожидаемый баланс',
      EXPECTED_ESTIMATE: 'Ожидаемая оценка времени',
      HOURS_PER_MONTH: 'часов в месяц',
      HOURS_SPENT: 'Часов затрачено',
      MONTH: 'Месяц',
      MONTHLY_BUDGET: 'Месячный мюджет',
      ORIGINAL_BALANCE: 'Изначальный баланс',
      SELECT_ALL_DATA: 'Выберите все данные',
      SELECT_SOW: 'Выберите SOW',
      TASK: 'Задача',
      TOTAL_COSTS: 'Общая стоимость проекта:',
      WORKED_HOURS: 'Отработанные часы',
    },

    FILES: {
      ATTACHMENTS: 'Приложения проекта',
      LINKS: 'Ссылки проекта',
      PLACEHOLDER_LINK: 'Прикрепите внешнюю ссылку',
      PLACEHOLDER_LINK_NAME: 'Дайте ссылке имя',
      UPLOAD_DOCUMENT: 'Загрузка документа',
    },

    INFO: {
      CONTACTS: 'Контакты',
    },

    PROJECT_CARD: {
      NOT_ASSIGNED: 'Не назначен',
      NUMBER_OF_PARTICIPANTS: 'Количество участников',
      PM: 'Менеджер проекта',
      TL: 'Тимлид',
      TOOLTIPS: {
        PM: 'Менеджер проекта должен присутствовать на проекте',
        TL: 'Тимлид должен присутствовать в проекте и должен быть как минимум уровня middle',
      },
      UNKNOWN: 'Неизвестно',
    },

    SOW: {
      CREATE: 'Создать новый SOW',
      JIRA_SYNCH: 'Синхронизация с Jira',
      LAST_SYNC: 'Последняя синхронизация была:',
      RELEASED: 'Выпущенные',
      UNRELEASED: 'Невыпущенные',
    },

    NOTIFICATION: {
      ADDED_SKILL: 'Новый навык с рейтингом был успешно добавлен',
      ALLOCATION_CREATE_SUCCESS: 'Аллокация успешно создана.',
      ALLOCATION_UPDATE_SUCCESS: 'Аллокация успешно обновлена.',
      ALLOCATION_DELETE_SUCCESS: 'Аллокация успешно удалена.',
      ATTACH_SUCCESS: 'Файл по ссылке успешно прикреплён',
      BIG_SIZE_FILE_ERROR:
        'Вы пытаетесь загрузить файл превышающий допустимый размер в 100MB',
      BRANCH_UPDATE:
        'Поле "Отдел" успешно изменено. Список сотрудников будет обновлен. Это может занять некоторое время, пожалуйста, вернитесь к странице позже.',
      BUDGET_CREATE: 'Месячный бюджет успешно создан',
      BUDGET_UPDATE: 'Месячный бюджет успешно обновлён',
      CHANGES_SAVE: 'Изменения сохранены',
      CLIENT_DETAIL_UPDATE: 'Клиентские детали успешно обновлены',
      CODE_FROM_BACKEND: 'От бэкенда был получен статус кода:',
      CREATE_ACTION_ITEM: 'You have successfully created an Action item.',
      CREATE_OTO_MEETING:
        "Новая встреча 'один-на-один' была успешно создана! Вы можете редактировать или удалить её до",
      DATA_EXPORT_FAILED: 'Не удалось экспортировать данные',
      DATA_UPLOAD:
        'Пожалуйста, подождите. Формирование файла выгрузки может занять некоторое время.',
      DATA_WAS_SUCCESSFULLY_EXPORTED: 'Данные были успешно экспортированы',
      DELETED_ACTION_ITEM: 'Action item успешно удален',
      DELETED_FEEDBACK_REQUEST: 'Запрос фидбэка успешно удален',
      DELETED_HEATMAP_VIEW: 'Набор фильтров был успешно удалён!',
      DELETED_OTO_MEETING: "Встреча 'один-на-один' была успешно удалена!",
      DOCUMENT_UPLOAD: 'Документ успешно загружен!',
      DOC_UPLOAD: 'Документ успешно загружен',
      EMPTY_ACTION_NAME: 'Название действия не может быть пустым!',
      EMPTY_FEEDBACK: 'Сообщение фидбэка не может быть пустым!',
      EMPTY_MESSAGE: 'Ваше сообщение пустое',
      EMPTY_REPLY_FIELD: 'Поле овтета не может быть пустым',
      ENTER_SKILL_NAME: 'Пожалуйста, введите название навыка',
      ENTER_VALID_DATE: 'Пожалуйста, введите актуальную дату',
      ENTER_VALID_TIME: 'Пожалуйста, введите актуальное время',
      ERROR_UPLOAD_AVATAR: 'Произошла ошибка при загрузке аватара',
      ERROR_SET_COOPERATION_FINISHED:
        "Вы не можете установить 'Сотрудничество завершено' до тех пор, пока проект не будет иметь статус 'Закрыт'",
      ESTIMATE_UPDATE: 'Оценка была обновлена',
      FAILED_JIRA_SYNCH: 'Не удалось произвести синхронизацию с Jira!',
      FAILED_GET_TASKS:
        'Не удалось получить список задач. Пожалуйста, попробуйте позже.',
      FILE_RENAMED: 'Файл успешно переименован',
      FILL_CORRECT_DATE_AND_TIME:
        "Пожалуйста, заполните поля 'Дата' и 'Время' корректно",
      FILL_DATE_AND_BUDGET:
        "Пожалуйста, укажите заголовок и заполните поля 'Дата' и 'Бюджет'",
      FILL_DATE_AND_TIME:
        "Пожалуйста, укажите пользователя и заполните поля 'Дата' и 'Время'",
      FILL_FIELDS: 'Некоторые поля не заполнены',
      FILL_SICK_LEAVE_REQUEST_FORM: 'Заполните форму на больничный',
      FILL_VACATION_REQUEST_FORM: 'Заполните форму на отпуск',
      FILL_REMOTE_WORK_REQUEST_FORM: 'Заполните форму на удаленную работу',
      FINISH_OTO_CARD: "Карточка 'один-на-один' успешно завершена!",
      JIRA_SYNC: {
        SUCCESSFULLY:
          'Синхронизация c JIRA успешно запущена. Это займет некоторое время. После завершения вы получите уведомление в 🔔',
        FAILED_MESSAGE_BEGIN: 'Что-то пошло не так.',
        FAILED_MESSAGE_END:
          'не может быть синхронизирован. Пожалуйста, позже попробуйте еще раз.',
        ALREADY_IN_PROGRESS:
          'Синхронизация JIRA уже выполняется. Пожалуйста, подождите, пока она не завершится, прежде чем запускать новую. Вы получите уведомление на 🔔 , когда она будет завершена',
      },
      HTTP_STATUS_CODES: {
        500: 'Произошла ошибка сервера',
      },
      LINK_IS_COPIED: 'Ссылка скопирована в буфер обмена',
      LINK_UNABLE: 'Невозможно скопировать ссылку',
      NOT_CHANGED_ACTION: 'Произошла ошибка! Действие не было изменено!',
      NOT_COMPLETED_REQUEST: 'Пожалуйста, подождите пока запрос будет завершён',
      NOT_CREATED_ACTION: 'Произошла ошибка! Новое действие не было создано!',
      NOT_CREATED_COMMENT: 'Произошла ошибка! Новый комментарий не был создан!',
      NOT_CREATED_OTO_MEETING:
        "Произошла ошибка! Встреча 'один-на-один' не была создана!",
      NOT_DELETED_ACTION: 'Произошла ошибка! Действие не было удалено!',
      NOT_FINISHED_MEETING: 'Встреча не может быть завершена',
      NOT_LOADED_FEEDBACKS:
        'Произошла ошибка! Фидбэки сотрудника не были загружены!',
      NOT_LOADED_OTO_LIST:
        "Произошла ошибка! Список 'один-на-один' не был загружен!",
      NOT_LOAD_EMPLOYEES_LIST:
        'Произошла ошибка! Список работников не был загружен!',
      NOT_POSTED_FEEDBACK: 'Произошла ошибка! Ваш фидбэк не был отправлен!',
      NOT_SENT_REQUEST: 'Произошла ошибка! Ваш запрос не был отправлен!',
      NOT_SHARED_OTO:
        "Произошла ошибка! Карточка 'один-на-один' не была распространена!",
      NOT_UPDATED_ACTION_ITEM: 'Произошла ошибка! Action item не был обновлён!',
      NOT_UPLOAD_MULTIPLE_FILES: 'Вы не можете загрузить несколько файлов',
      NO_FILENAME: 'У файла должно быть имя',
      NO_LINK_PDP:
        'Карьерный менеджер, ответственный за этого сотрудника, еще не прикрепил ссылку PDP',
      NO_PERMISSIONS: 'У вас нет разрешений для просмотра этой страницы',
      NO_PRIVILEGES: 'Недостаточно прав для просмотра этой страницы',
      NO_TASKS: 'У вас нет задач',
      ONE_ROLE_IN_TEAM:
        'Эта роль может быть назначена только одному участнику в команде',
      OPTIMISTIC_BUDGET_GREATER_EXPEXTED_ERROR:
        'Оптимистичный бюджет не может быть больше, чем ожидаемый бюджет. Пожалуйста, введите действительные данные.',
      PAGE_NOT_FOUND: 'Страница не найдена',
      POSTED_FEEDBACK: 'Ваш фидбэк успешно отправлен',
      PROJECT_CREATE: 'Проект успешно создан',
      PROJECT_UPDATE: 'Проект успешно обновлён',
      PROVIDE_FIELDS_COMPLETED: 'Пожалуйста, укажите все заполненные поля',
      PROVIDE_REVIEW_DATE: 'Пожалуйста, установите дату ревью',
      PROVIDE_VALID_PDP_LINK: 'Вы должны указать действующую ссылку на PDP',
      RELEASE_BEFORE_START_ERROR:
        'Дата релиза не может быть раньше даты начала. Введите корректные даты',
      SCHEDULE_SAVED: 'Шаблон успешно сохранён',
      SHARED_FEEDBACK: 'Вы успешно поделились фидбэком!',
      SHARED_ONE_TO_ONE: 'Вы успешно поделились 1-1 встречей!',
      SERVER_ERROR: 'Произошла ошибка сервера',
      SENT_FORM: 'Форма была успешно отправлена',
      SENT_REQUEST: 'Ваш запрос был успешно отправлен',
      SKILL_ALREADY_ATTACHED: 'Этот навык уже прикреплён',
      SKILL_EMPTY: 'Введите название навыка',
      SKILL_EXIST: 'Навык с таким именем уже существует',
      SOW_CREATE: 'SOW успешно создан',
      SOW_UPDATE: 'SOW успешно обновлён',
      SPECIFIC_PERSON_EMPTY: "Поле 'Конкретный человек' не может быть пустым",
      SUBSCIBED_TO_ALL: 'Успешно подписались на всех!',
      SUCCESS_JIRA_SYNCH: 'Синхронизация с Jira завершилась успешно!',
      SUCCESSFULLY_SUBSCRIBED: 'Успешно подписались!',
      SUCCESSFULLY_UNSUBSCRIBED: 'Успешно отписались!',
      TIME_REPORT_UPDATE: 'Временной отчёт успешно обновлён',
      UNCONFIRMABLE_TIMELOGS:
        'Часть таймлогов невозможно перевести в статус «Подтвержденные». Для перевода в «Подтвержденные» таймлоги должны быть в статусе «Неподтвержденные» или «Отклоненные».',
      UNIT_CREATE: 'Юнит успешно создан',
      UNIT_DELETE: 'Юнит успешно удален!',
      UNIT_EXIST: 'Юнит с таким именем уже существует',
      UNIT_UPDATE: 'Юнит успешно обновлён',
      UNSHARED_FEEDBACK: 'Доступ к обратной связи закрыт',
      UNSHARED_ONE_TO_ONE: 'Доступ к 1-1 встрече закрыт',
      UNREVOKABLE_TIMELOGS:
        'Часть таймлогов невозможно перевести в статус «Неподтвержденные». Для перевода в «Неподтвержденные» таймлоги должны быть в статусе «Отклоненные» или «Подтвержденные».',
      UNSUBSCRIBED_FROM_ALL: 'Успешно отписались от всех!',
      UPDATED_AVATAR: 'Изображение профиля было успешно изменено',
      UPDATED_OTO_MEETING: "Встреча 'один-на-один' была успешно обновлена!",
      UPDATED_PERSONAL_INFO:
        'Ваша персональная информация была успешно обновлена',
      UPDATED_REVIEW: 'Ревью сотрудника было успешно обновлено!',
      WAIT: 'Подождите, пожалуйста',
    },

    //action items
    ACTION_ITEM_ACTIVE: 'Активные',
    ACTION_ITEM_TITLE: 'Задачи',
    COMING_SOON: 'В разработке',
    SUBJECT: 'Задача',

    //tables WT
    TABLES_WT: {
      ABSENT: 'П',
      ACTIVE_PROJECTS: 'Активные проекты',
      ADD_ADJUSTMENT: 'Добавить корректировку',
      ADD_SALES_FACT: 'Добавить факт продажи',
      ADJUSTMENT: 'Корректировка',
      ADJUSTMENTS: 'Корректировки',
      ADJUSTMENT_SUCCESSFULLY_ADDED: 'Корректировка успешно добавлена.',
      ADJUSTMENT_SUCCESSFULLY_DELETED: 'Корректировка успешно удалена.',
      ALL_LOGGED_TIME: 'Общее внесённое время этого сотрудника в этот день',
      ALL_PROJECTS: 'все проекты',
      ANOTHER_DELIVERY_UNIT: 'Другой Delivery Unit',
      APPROVE_MODE: 'Подтверждение часов',
      APPROVED: 'Утвержденные',
      APPROVED_HOURS: 'Подтвержденные часы',
      APPROVE_ALL_USERS: 'Подтвердить всех',
      APPROVE_ALL_USERS_WITH_RIGHT_TIME:
        'Подтвердить всех с корректным временем',
      APPROVED_STATUS: 'Статус утвержден',
      ARE_YOU_SURE_TIMELOGS_APPROVED:
        'Вы уверены, что хотите подтвердить таймлоги с ',
      ARE_YOU_SURE_TIMELOGS_CONFIRMED:
        'Вы уверены, что хотите подтвердить таймлоги с ',
      ARE_YOU_SURE_TIMELOGS_REJECTED:
        'Вы уверены, что хотите отклонить таймлоги с ',
      ARE_YOU_SURE_TIMELOGS_REVOKED:
        'Вы уверены, что хотите отозвать таймлоги с ',
      AWAITING_APPROVAL: 'Ожидают утверждения',
      CAPACITY: 'Загрузка',
      CLEAR_ALL_USERS: 'Очистить всех',
      CLOSE_PERIOD: 'Закрыть период',
      CLOSED: 'Закрытые',
      CLOSED_STATUS: 'Статус закрыт',
      COPY_DESCRIPTION_TO_ALL: 'Скопировать описание для всех',
      COMMENTS: 'Замечания',
      COMPARE_TABLE: 'Сравнение часов',
      CONFIRMED: 'Подтвержденные',
      CONFIRMED_STATUS: 'Статус подтвержден',
      DELIVERY_DIRECTOR_TOGGLE: 'Режим Delivery Director',
      DESCRIPTION_ERROR_LONGER_THAN:
        'Комментарий должен содержать не менее 3 символов',
      DIVIDE: 'Распределить',
      DURATION: 'Длительность',
      EDITED: 'ред.',
      EMPLOYEE: 'Сотрудник',
      EMPLOYEE_WILL_NOT_BE: 'Сотрудника не будет',
      ERRORS: 'Ошибки',
      EQUATE_TO_PLAN: 'Приравнять факт к плану',
      EVENT_TYPES: 'Типы событий',
      EXCLUDE_TIME_OFFS: 'Исключить отпуска и больничные из распределения',
      FOR: 'За',
      FORM_ERROR_LONGER_THAN: 'Описание должно содержать больше 3 символов',
      FORM_ERROR_MORE_THAN: 'Значение времени не может быть больше 12',
      FORM_ERROR_NEGATIVE: 'Значение времени не может быть отрицательным',
      FORM_ERROR_OVER_LIMIT:
        'Факт продажи за один день не может превышать 12 часов. Пожалуйста, проверьте Факт продажи.',
      FORM_ERROR_SALES_FACT_WRONG_PATTERN:
        'Введенное значение не соответсвует требуемому формату. Оно должно быть кратно 0.25 (Например: 3 или 3.25 или 3,75)',
      FORM_ERROR_SHORTER_THAN: 'Описание должно содержать меньше 25 символов',
      FORM_ERROR_TIME_OFFS:
        'Факт продажи не может быть распределен в данном периоде из-за отпусков и больничных',
      FORM_ERROR_WRONG_PATTERN:
        "Значение времени должно соответствовать шаблону 'число', или 'число.число', или 'число,число'. Например: 3, или 3.5, или 3,5",
      HIDDEN_LOGGED_TIME_H: 'Неотображаемое время (ч)',
      HIDE_APPROVED: 'Скрыть утвержденные',
      HIDE_CLOSED: 'Скрыть закрытые',
      HOLIDAY_OR_WEEKEND: 'Праздник или выходной',
      INVOICED: 'В бухгалтерии',
      INVOICED_STATUS: 'Статус в бухгалтерии',
      LAST_FISCAL_WEEK: 'Прошлая фин неделя',
      LEGEND_LOGGED_HOURS:
        'Сумма часов, залогированных в Jira или Тайм трекинге',
      LEGEND_PLANNED_HOURS:
        'Сумма часов, аллоцированных в Ресурсном планировании',
      LEGEND_SALES_FACT: 'Факт продажи',
      LEGEND_CAPACITY:
        'Доступность сотрудника в часах (исключая отпускные и больничные)',
      LEGEND_APPROVED_HOURS: 'Сумма логов в статусе Подтверждены',
      LEDEND_VARIANCE:
        'Разница значений столбцов Загрузка и Отработанное время',
      LOGGED: 'Внесено',
      LOGGED_HOURS: 'Отработанное время',
      LOGGED_NOT_EQUAL_PLANNED:
        'Внесенное время у следующих пользователей не соответствует запланированному времени и факту продаж или равно 0.',
      LOGGED_TIME_H: 'Внесённое время (ч)',
      LOGGED_TIME_ON_OTHER_PROJECT: 'Внесённое время в этот день на проекте ',
      LOGGED_TIME_ON_THIS_PROJECT:
        'Внесённое время на этом проекте в этот день',
      MANUAL_DIVISION: 'Распределить вручную',
      NO_DATA_WTC:
        'Мы не нашли деливери юнит или департамент, руководителем которого вы бы являлись.',
      NO_DATA_WTA:
        'Мы не нашли проект или подразделение, менеджером которого вы бы являлись.',
      NO_EVENTS: 'Событий нет',
      NO_LOGGED_TIME_ON_OTHER_PROJECTS:
        'Нет внесенного времени на других проектах в этот день',
      NO_LOGS_FOUND: 'Логов или корректировок не найдено',
      NO_MEMBERS: 'В проекте пока ещё нет участников',
      NO_PLANNED_TIME_ON_OTHER_PROJECTS:
        'Нет запланированного времени на других проектах в этот день',

      OPEN_MODAL_MESSAGE: 'Вы уверены, что хотите разблокировать период с',
      OPEN_PERIOD: 'Открыть период',
      PLANNED: 'Запланировано',
      PLANNED_HOURS: 'Запланированное время',
      PLANNED_TIME_H: 'Запланированное время (ч)',
      PLANNED_TIME_ON_OTHER_PROJECT:
        'Запланированное время в этот день на проекте',
      PLANNED_TIME_ON_THIS_PROJECT:
        'Запланированное время на этом проекте в этот день',
      NO_TIMELOGS: 'Нет таймлогов для подтверждения',
      NO_TIMELOGS_FOR_REVOKE: 'Нет таймлогов для отзыва',
      REASON: 'Причина',
      REJECTED: 'Отклоненные',
      REACHED_CHARACTER_LIMIT: 'Введено максимальное количество символов',
      REASON_FOR_OPEN_PERIOD: 'Причина открытия периода',
      REJECT_ALL_USERS: 'Отклонить всех',
      REJECT_TIMELOGS_MODAL_INPUT_PLACEHOLDER: 'Опишите',
      REJECT_TIMELOGS_MODAL_INVALID_INPUT_TEXT:
        'Описание должно содержать больше 3 символов',
      REJECTED_LOGS: 'Отклонённые логи',
      REMOVE_ADJUSTMENT: 'Удалить корректировку',
      REMOVE_ADJUSTMENT_MESSAGE: 'Данная операция не может быть отменена.',
      REMOVE_ADJUSTMENT_TITLE: 'Вы уверены, что хотите удалить корректировку?',
      REMOVE_ALL_SALES_FACTS: 'Удалить все',
      SALES_FACT: 'Факт продажи',
      SALES_FACTS: 'Факты продажи',
      SALES_FACT_FOR_PERIOD: 'Сумма распределенных фактических часов продаж:',
      SALES_FACT_SUCCESSFULLY_ADDED: 'Факт продажи успешно добавлен',
      SALES_FACT_SUCCESSFULLY_DELETED: 'Факт продажи успешно удален',
      SALES_FACTS_SUCCESSFULLY_DELETED: 'Факты продажи успешно удалены',
      SELECT_USER_FOR_APPROVE:
        'Выберите пользователя, рабочее время которого нужно подтвердить',
      SELECT_USER_FOR_CLOSE_PERIOD:
        'Выберите пользователя, для которого нужно закрыть период',
      SELECT_USER_FOR_CONFIRM:
        'Выберите пользователя, рабочее время которого нужно подтвердить',
      SELECT_USER_FOR_OPEN_PERIOD:
        'Выберите пользователя, для которого нужно открыть период',
      SELECT_USER_FOR_REJECT:
        'Выберите пользователя, рабочее время которого нужно отклонить',
      SELECT_USER_FOR_REVOKE:
        'Выберите пользователя, рабочее время которого нужно отозвать',
      SHOW_APPROVED: 'Показать утвержденные',
      SHOW_LEGEND: 'Показать легенду',
      SICK_LEAVE: 'Б',
      START: 'Начало',
      STATUSES: 'Статусы',
      JIRA_OR_TIMETRACKING: '(Jira или Тайм трекинг)',
      THIS_FISCAL_WEEK: 'Текущая фин неделя',
      THIS_MONTH: 'Текущий месяц',
      THIS_PROJECT: 'Этот проект:',
      TIME_DESCRIPTION: 'Детализация времени',
      TIME_MISMATCH: 'Расхождение в часах',
      TIMELOG: 'Таймлог',
      TIMELOGS: 'Таймлоги',
      TIMELOGS_MISSING: 'Таймлоги отсутствуют.',
      TIMELOGS_SUCCESSFULLY_APPROVED: 'Таймлоги успешно подтверждены.',
      TIMELOGS_SUCCESSFULLY_CLOSED: 'Таймлоги успешно закрыты.',
      TIMELOGS_SUCCESSFULLY_EQUATED: 'Таймлоги успешно приравнены.',
      TIMELOGS_SUCCESSFULLY_OPENED: 'Таймлоги успешно открыты.',
      TIMELOGS_SUCCESSFULLY_REJECTED: 'Таймлоги успешно отклонены.',
      TIMELOGS_SUCCESSFULLY_REVOKED: 'Таймлоги успешно отозваны.',
      TIMELOGS_SUCCESSFULLY_SUBMITTED: 'Таймлоги успешно отправлены.',
      TO: 'по',
      TOTAL_PROJECT_TIME: 'Общее время проекта',
      TOTAL_TIME: 'Итоговое время',
      TYPE_SALES_FACT_H: 'Введите факт продаж (ч)',
      UNAVAILABLE_PROJECT: 'Недоступный проект',
      UNCONFIRMED: 'Неподтвержденные',
      UNCONFIRMED_HOURS_FOR_PERIOD:
        'Неподтвержденные часы в этом периоде составляют:',
      VACATION: 'О',
      WARNING: 'Обратите внимание! Добавились новые ворклоги из Jira.',
      WEEKENDS: 'Выходные',
      WHY_REJECT_TIMELOGS: 'Почему таймлоги отклоняются?',
      WILL_WORK: 'Отработает',
      WORKING_HOURS: 'Отработанное время',
      YOU_HAVE_NO_TIMELOGS: 'Ни один ПМ не подтвердил ни одного таймлога',
      VARIANCE: 'Расхождение',
    },

    //project statuses
    PROJECT_STATUS: 'Статус проекта',
    CREATED_BY_SYSTEM: 'Создан системой',
    LAST_EDIT_BY: 'Отредактирован',
    MARK_AS_PREPARED: 'Отметить как подготовленный',
    MODAL_MESSAGE: {
      REJECT: 'Вы уверены, что хотите отклонить отчет?',
      PREPARED:
        'После того, как вы отметите статус как подготовленный, он станет нередактируемым.',
      PREPARED_BY_DM:
        'Вы уверены, что хотите отметить подготовленным этот отчёт?',
      APPROVED: 'После подтверждения статус станет нередактируемым.',
    },
    TO_THE_FIRST_PAGE: 'К первой странице',
    TO_THE_LAST_PAGE: 'К последней странице',
    TO_THE_NEXT_PAGE: 'К следующей странице',
    TO_THE_PREVIOUS_PAGE: 'К предыдущей странице',

    // HTTP errors
    ERROR_IMAGE: 'Не удалось загрузить изображение',
    FILE_LIMIT: 'Лимит файлов:',
    FORBIDDEN_ERROR: 'У вас недостаточно прав',
    UNPROCESSABLE_ENTITY: 'Пожалуйста, исправьте ошибки:',

    //header
    CONTACT_US: 'Связаться с нами',
    ENTER_SUBJECT: 'Введите тему',
    ENTER_DESCRIPTION: 'Введите описание',
    SELECT_LANGUAGE: 'Выберите язык',
    TELEPORT_TO_HUB: 'Телепорт на Hub!',
    USER_DOCUMENTATION: 'Пользовательская документация',
    YOU_ARE_HERE: 'Вы здесь!',
    YOU_ARE_CURRENTLY_IN_A: 'Вы находитесь в',
    ENVIRONMENT: 'окружении',

    //sidebar-tabs
    COMPANY_DIRECTORY: 'Компания',
    PROJECT_MANAGEMENT: 'Управление проектами',
    TIMELOG_MANAGEMENT: 'Управление рабочим временем',
    STAFF_MANAGEMENT: 'Управление персоналом',
    ADMINISTRATION: 'Администрация',
    MY: 'Мои',
    SYSTEM: 'Система',
    TABLE: 'Табель',

    //navigation
    MANAGERIAL_ACCOUNTING: 'Управленческий учет',
    ACTION_ITEM: 'Action item',
    ACTION_ITEMS: 'Задачи',
    AUDIT_LOGS: 'Аудит логи',
    CREATE_ONE_TO_ONE: 'Создать новый 1-1',
    EDIT_ONE_TO_ONE: 'Редактирование 1-1',
    EMPLOYEES: 'Сотрудники',
    FEEDBACKS: 'Фидбэки',
    FEEDBACK_REQUEST: 'Запрос фидбэка',
    FORM: 'Форма',
    FORMS: 'Формы',
    GUIDELINES: 'Документация',
    LOGOUT: 'Выйти',
    OFFICE_MANAGER: 'Офис менеджер',
    PAYROLL_TIMESHEET: 'Табель рабочего времени',
    PAYSLIPS: 'Расчетки',
    PEOPLE_MANAGEMENT_ACCESSES: 'Доступы ресурсного менеджера',
    PERSONNEL_ACCOUNTING: 'Кадровый учет',
    PROFILE: 'Профиль',
    PROJECTS: 'Проекты',
    PROJECT_MANAGER: 'Менеджер проектов',
    GO_TO_POSITION_CARD: 'Перейти к карточке позиции',
    ROLE_OVERVIEW: 'Обзор ролей',
    SALES_PLAN: 'CFO',
    SETTINGS: 'Настройки',
    VACATIONS: 'Отпуска',
    WORKING_TIME_ACCOUNTING: 'Учет рабочего времени',
    WORKING_TIME_UPLOADING: 'Загрузка рабочего времени',

    //TABLE OM
    ACTIVE: 'Активные',
    ALL: 'Все',
    ARE_YOU_SURE_DELETE: 'Вы точно хотите удалить это событие?',
    CLOSE_ADDING_EVENT: 'Закрыть добавление события',
    CREATE_EVENT: 'Создать событие',
    CUSTOM_EVENTS: 'Создать событие',
    DATE_OF_CREATE: 'Дата создания',
    DISMISSED: 'Уволенные',
    EDIT_HISTORY: 'История изменений',
    EDIT_LIMITS_IN: 'Изменить лимиты в ',
    EMPLOYMENT_HISTORY: 'История контракта',
    EMPLOYMENT_TYPES: {
      AN_AGREEMENT_WITH_AN_INDIVIDUAL: 'Договор с физическим лицом',
      APPRENTICESHIP_AGREEMENT: 'Ученический договор',
      CIVIL_LAW_CONTRACTS: 'ГПХ',
      CONTRACT_WITH_DFG: 'Контракт с DFG (Payoneer)',
      ENTREPRENEUR: 'ФОП',
      INDIVIDUAL_ENTREPRENEUR: 'ИП',
      LABOR_CODE: 'ТК',
    },
    ENTER_REASON: 'Пожалуйста, введите причину',
    EVENT: {
      CANCEL_ALL_EVENT: 'Отменить все дни события',
      CANCEL_CURRENT_EVENT: 'Отменить текущий день события',
      CANCEL_SUBSEQUENT_EVENT: 'Отменить событие и все последующие',
      CHANGE_OR_CANCEL_EVENT: 'Изменить/отменить отпуск через заявку',
      START_EVENT: 'Восстановить 1 день события',
      START_WHOLE_EVENT: 'Восстановить всё событие',
    },
    EVENT_ADD_FAILED: 'Событие не было добавлено',
    EVENT_ADD_SUCCESS: 'Событие успешно добавлено',
    EVENT_DELETED_FAILED: 'Событие не было удалено',
    EVENT_DELETED_SUCCESSFUL: 'Событие успешно удалено',
    EVENT_FIELDS: {
      CREATOR: 'Создатель',
      FORM: 'Форма',
      FROM: 'От',
      HOURS: 'Часы',
      REASON: 'Причина',
      STATE: 'Статус',
      TICKET_LINK: 'Ссылка',
      TO: 'До',
      TYPE: 'Тип',
    },
    EVENT_FORM_TYPES: {
      COMMENT: {
        ERROR: 'Пожалуйста, введите комментарий',
        PLACEHOLDER: 'Комментарий',
      },
      DATE_FROM: {
        ERROR: 'Пожалуйста, выберите дату',
        PLACEHOLDER: 'Начиная с',
      },
      DATE_FROM_TRANSFER: {
        ERROR: 'Пожалуйста, выберите дату',
        PLACEHOLDER: 'Дата c',
      },
      DATE_TO: {
        ERROR: 'Пожалуйста, выберите дату',
        PLACEHOLDER: 'Заканчивая до',
      },
      DATE_TO_TRANSFER: {
        ERROR: 'Пожалуйста, выберите дату',
        PLACEHOLDER: 'Дата на',
      },
      DEPARTMENT: {
        ERROR: 'Пожалуйста, выберите отдел',
        PLACEHOLDER: 'Отдел',
      },
      EXPECTED_TIME: {
        ERROR: 'Пожалуйста, введите ожидамое время',
        PLACEHOLDER: 'Планируемое время',
      },
      FINISHED_AT_HOURS_TO: {
        ERROR: 'Пожалуйста, введите часы',
        PLACEHOLDER: 'Перенос на (конец)',
      },
      MANAGER_OF_PROJECT: {
        ERROR: 'Пожалуйста, выберите управляющего проектом',
        PLACEHOLDER: 'Управляющий проектом',
      },
      OFFICE: {
        ERROR: 'Пожалуйста, выберите офис',
        PLACEHOLDER: 'Офис',
      },
      PROJECTS_NAME: {
        ERROR: 'Не выбран проект для переноса',
        PLACEHOLDER: 'Выберите проект для переноса',
      },
      REASON: {
        ERROR: 'Пожалуйста, введите причину',
        PLACEHOLDER: 'Причина',
      },
      SELECT_EVENT_TYPE: {
        LABEL: 'Выберите тип события',
      },
      STARTED_AT_HOURS_TO: {
        ERROR: 'Пожалуйста, введите часы',
        PLACEHOLDER: 'Перенос на (начало)',
      },
      TASK_LINK: {
        ERROR: 'Пожалуйста, введите ссылку на задачу',
        PLACEHOLDER: 'Ссылка на задачу',
      },
      TIME_START_DATE_FROM: {
        ERROR: 'Пожалуйста, введите часы',
        PLACEHOLDER: 'Время с',
      },
      TIME_START_DATE_TO: {
        ERROR: 'Пожалуйста, введите часы',
        PLACEHOLDER: 'Время на',
      },
      TOTAL_HOURS: {
        ERROR: 'Пожалуйста, введите ожидамое время',
        PLACEHOLDER: 'Введите количество часов',
      },
    },
    EVENT_NAMES: {
      ABSENT: 'Прогул',
      ALL_LABOR_COST_APPROVED: 'Все трудозатраты подтверждены',
      APPROVED_TIME: 'Утвержденные',
      CANCELLED: 'Отменённые',
      COMPENSATED_LEAVE: 'Компенсационный отпуск',
      EXTRA_LEAVE: 'Дополнительный отпуск',
      LEFT_COMPANY: 'Покинул компанию',
      LOGGED: 'Отработанные',
      NO_WORKLOGS: 'Нет ворклогов',
      NOT_WORKING_YET: 'Еще не работает',
      PAID_LEAVE: 'Оплачиваемый отпуск',
      PAID_VACATION: 'Оплачиваемый отпуск',
      PLAN_AND_FACT_DO_NOT_MATCH: 'План и факт не сходятся',
      PROJECT_OUT_OF_CONTROLLED_DU: 'Проект вне контролируемого DU',
      REMOTE: 'Удаленная работа',
      SICK_LEAVE: 'Больничный',
      SOCIAL_LEAVE: 'Социальный отпуск',
      TIME_SHIFT: 'Сдвиг времени',
      THE_NUMBER_OF_VD: 'Количество дней VD',
      TRANSFER_DAY: 'Перенос дня',
      TRANSFER_TIME: 'Перенос времени',
      UNPAID_LEAVE: 'Неоплачиваемый отпуск',
      UNPAID_SICK_LEAVE: 'Неоплачиваемый больничный',
      UNPAID_VACATION: 'Отпуск за свой счет',
      VACATION: 'Отпуск',
      HOLIDAY: 'Праздник',
    },
    EVENT_STATES: {
      CANCELLED: 'Отменённое',
      CANCELLED_EVENTS: 'Отменённые события',
      APPROVED: 'Подтверждённое',
      IN_PROGRESS: 'В прогрессе',
      NEW: 'Новое',
      SEVERAL: 'Множество',
      USED: 'Использованное',
    },
    EVENT_COLOR: 'Цвет события',
    EVENT_CONFLICTS_WARNING:
      'Обратите внимание, что на следующие даты имеются события <NamesFiller>',
    EMPLOYEE_STATUS: 'Статус сотрудника',
    FILTER: 'Фильтр',
    FILTERS: 'Фильтры',
    HIDE_FILTERS: 'Скрыть фильтры',
    INFORMATION_ABOUT: 'Информация о',
    LIMITS_UPDATE_SUCCESS: 'Лимиты успешно обновлены',
    MONTH: 'месяц',
    MONTHS: 'месяца(ев)',
    OM_TO: 'на',
    OM_TOTAL: 'Сумма',
    OTHER_EVENTS: 'Остальные события',
    REASON_REQUIRED: 'Причина должна быть не короче 3 символов',
    SEARCH_BY_CONTENT: 'Поиск по содержимому',
    SEARCH_BY_EMPLOYEE: 'Поиск по сотруднику',
    SEARCH_BY_NAME: 'Поиск по имени',
    SEARCH_BY_PROJECT: 'Поиск по проекту',
    SEARCH_BY_TASK: 'Поиск по задаче',
    SEARCH_BY_USERS: 'Поиск по пользователю',
    SELECT_OFFICE: 'Выберите офис',
    SELECT_PROJECT: 'Выберите проект',
    SET_CUSTOM_RANGE: 'Другой период',
    SHOW_FILTERS: 'Показать фильтры',
    SHOW_TIMELOGS: 'Показать таймлоги',
    SHOW_TRANSFER_TO: 'Показать, когда происходит перенос',
    SHOW_WEEKENDS: 'Показать выходные',
    STATE_OF_EVENTS: 'Состояние события:',
    OLD_STATISTICS: 'Статистика (Старая)',
    TYPE_OF_EVENTS: 'Типы событий',
    TYPE_DESCRIPTION: 'Введите описание',
    USERS_NOT_FOUND: 'Пользователи не найдены',
    VIEW_INFORMATION: 'Посмотреть информацию',
    WEEK: 'неделя',
    WEEKS: 'недель(и)',

    //OM statistic view
    PARTNERS: 'Партнеры',
    COUNT_OF_AVAILABLE_VACATION_DAYS_WITHOUT_PLANNED:
      'Количество ДОСТУПНЫХ дней отпуска на текущий момент (без учета запланированных)',
    COUNT_OF_AVAILABLE_VACATION_DAYS_WITHOUT_PLANNED_1:
      'Количество доступных дней отпуска на текущий момент (без учета запланированных)',
    COUNT_OF_AVAILABLE_VACATION_DAYS_WITH_PLANNED:
      'Количество ДОСТУПНЫХ дней отпуска на текущий момент (с учетом запланированных)',
    COUNT_OF_AVAILABLE_VACATION_DAYS_WITH_PLANNED_1:
      'Количество доступных дней отпуска на текущий момент (с учетом запланированных)',
    COUNT_OF_EARNED_VACTION_DAYS:
      'Количество заработанных дней отпуска в прошлом году',
    COUNT_OF_SCHEDULED_PAID_VACATION_DAYS: 'Запланированных дней отпуска',
    COUNT_OF_SCHEDULED_PAID_VACATION_DAYS_1: 'Запланированных дней отпуска',
    COUNT_OF_USED_SICK_LEAVE: 'Использованных больничных',
    COUNT_OF_USED_UNPAID_LEAVE: 'Использованных отпусков за свой счет',
    COUNT_OF_USED_VACATION_DAYS:
      'Использованных дней отпуска на текущий момент',
    COUNT_OF_WORKED_DAYS: 'Отработанных дней за все время',
    COUNT_OF_WORKED_DAYS_IN_CURRENT_YEAR: 'Отработанных дней в текущем году',
    COUNT_OF_WORKED_YEARS: 'Отработанных лет',
    CURRENT_DUE_PAID_VACATIONS:
      'Количество ПОЛОЖЕННЫХ дней отпуска в текущем году',
    CURRENT_DUE_PAID_VACATIONS_1: 'База положенных дней отпуска в текущем году',
    DATE_OF_START_WORK: 'Дата начала работы в компании',
    EARNED_VACATION_PAID_VACATIONS:
      'Количество ЗАРАБОТАННЫХ дней отпуска на текущий момент',
    OVERALL_EARNED_VACATION_DAYS:
      'Общее количество заработанных дней отпуска на текущий момент (отпуск авансом не учитывается)',
    EARNED_VACATION_PAID_VACATIONS_1:
      'Количество заработанных дней отпуска в текущем году',
    EMAIL: 'Корпоративная почта',
    EMPLOYMENT: 'Тип контракта',
    INTERNSHIP: 'Стажировка',
    LAST_DUE_PAID_VACATIONS:
      'Количество ПОЛОЖЕННЫХ дней отпуска с прошлого года',
    LAST_DUE_PAID_VACATIONS_1:
      'Количество перенесенных дней отпуска с прошлого года',
    PIECEWORKER: 'Сдельщик',
    PIECEWORKERS: 'Сдельщики',
    REMAINING_VACATIONS_FOR_31_DEC_INCLUDING_PLANNED:
      'Остаток дней отпуска на 31 декабря текущего года (с учетом запланированных)',
    REMAINING_VACATIONS_FOR_31_DEC_EXCLUDING_PLANNED:
      'Остаток дней отпуска на 31 декабря текущего года (без учета запланированных)',
    TOTAL_VACATION_DAYS_DUE: 'ВСЕГО количество ПОЛОЖЕННЫХ дней отпуска',
    TRAINEE: 'Стажёр',
    UNDEREMPLOYMENT: 'Частичная занятость',
    USERNAME: 'Пользователь',

    //validation
    ENTER_CORRECT_EMAIL:
      'Пожалуйста, введите корректный адрес электронной почты',
    ENTER_ONLY_NUMBERS: 'Пожалуйста, вводите только цифры',
    IS_REQUIRED: 'Поле обязательно для заполнения',
    TABLE_IS_REQUIRED: 'Таблица обязательна для заполнения',
    TABLE_ONLY_NUMBERS: 'Только цифры',

    //cfo table
    ACTIVE_PROJECTS: 'Активные проекты',
    CAPACITY: 'Ёмкость',
    COM: 'COM %',
    CONTRACT_HOURS: 'Контрактные часы',
    CONTRACT_TYPE: 'Тип контракта',
    NO_CONTENT: 'Без комментариев',
    PLAN_VS_SALES: 'План vs Продажи',
    RECALCULTATE_SALES_PLAN:
      'Хотите, чтобы все установленные еженедельные Sales Plan были рассчитаны заново?',
    SALES_FACT: 'Факт продажи',
    SALES_TOTAL: 'Итог продаж',
    TABLE_SALES_PLAN: 'План продаж',
    VARIANCE: 'Разница',

    //audit logs
    CONTENT: 'Описание',
    KIND: 'Тип лога',

    //role overview
    GLOBAl_ROLE: 'Глобальная роль',
    RESOURCE_ROLE: 'Ресурсная роль',

    //people management accesses
    BY_DM_ROLE: 'Роль DM',
    BY_HOD_ROLE: 'Роль HoD',
    BY_PM_ROLE: 'Роль PM',
    BY_RMO_TREE_POSITION: 'Позиция в дереве RMO',
    DIRECT: 'Прямые',
    INDIRECT: 'Непрямые',

    //working time uploading
    ADD_URL: 'Добавьте ссылку',
    GOOGLE_SHEET_URL: 'Адрес Google Sheet',
    LINK_ERROR: 'Эта ссылка не валидна',
    COMMENTING_NOT_ALLOWED:
      'У вас недостаточно прав для отправки комментариев в этой задаче',
    CREATED_TASKS_LABEL: 'Созданные задачи',
    DECISION_ON_TASK:
      'Заполните форму, чтобы мы могли вынести решение по вашей задаче',
    FORMS_LIST: 'Список форм',
    FIND_TASK: 'Найти задачу',
    INBOX: 'Входящие',
    INFORMATION: 'Информация',
    LINK_TO_PYRUS: 'Ссылка на Pyrus',
    LINK_COPIED: 'Ссылка скопирована',
    LINK_TO_PYRUS_COPIED: 'Ссылка в Pyrus скопирована',
    NEW_TASK_LABEL: 'Создать задачу',
    SHOW_FINISHED: 'Показать только завершённые',

    //table notifications
    DATE: 'Дата',
    MESSAGE: 'Сообщение',

    //notifications modal
    ALL_NOTIFICATIONS: 'Посмотреть все',
    MARK_ALL_NOTIFICATIONS_AS_READ: 'Отметить все как прочитанные',
    MARK_ALL_NOTIFICATIONS_AS_UNREAD: 'Отметить все как непрочитанные',
    MISSED_MEETING:
      'У {employeeName} прошло более 30 дней с момента последней 1-1 встречи',
    NOTIFICATIONS: 'Оповещения',
    NO_NOTIFICATIONS: 'Oповещений пока нет',
    MARK_ALL_AS_READ: 'Прочитать все',
    TABLE_WTC: 'Табель КРВ',
    TABLE_OM: 'Табель OМ',
    TABLE_WTA: 'Табель УРВ',

    //vacations
    APPROVED: 'Подтверждён',
    AVAILABLE: 'Дост.',
    CANCELLED: 'Отменён',
    CREATED: 'Не подтверждён',
    IN_PROGRESS: 'В процессе',
    PLANNED: 'Запланирован',
    TAKE_VACATION: 'Оформить отпуск',
    USED: 'Использован',
    VACATION_FROM: 'От',
    VACATION_STATE: 'Статус',
    VACATION_TO: 'До',
    VACATION_TYPE: 'Тип отпуска',

    //sick leaves
    REST_PAID_SICK_LEAVE: 'Осталось оплачиваемых больничных',
    USED_SICK_LEAVE: 'Использовано больничных',

    //one to ones
    ACTION_LIST: 'Список действий',
    ACTION_PLACEHOLDER: 'Введите действие здесь',
    ADD_ACTION: 'Добавить действие',
    ADD_COMMENT: 'Добавить комментарий',
    ADD_GOALS: 'Добавить цели',
    ADD_LOG: 'Необходимо добавить 1-1 с сотрудником {employeeName}',
    ADD_TODO: 'Добавить задачу',
    AT: 'В',
    AWESOME: 'Огонь',
    BUSINESS_IMPACT: 'Влияние на бизнес',
    BY: 'От',
    CHOOSE_FROM_THE_LIST: 'Выберите из списка',
    CHOOSE_THE_DATE: 'Выберите дату',
    CHOOSE_THE_EMPLOYEE: 'Выберите сотрудника',
    CHOOSE_TYPE: 'Выберите тип встречи один на один',
    CHOOSE_TYPE_TOOLTIP: 'Для HR используйте этот тип 1-1',
    CLOSE: 'Закрыть',
    CLOSED_IN_ONE_TO_ONE: 'Закрыт в 1-1',
    COMMENT_PLACEHOLDER: 'Введите свой комментарий здесь',
    CONDUCT_ONE_TO_ONE: 'Провести 1-1',
    CREATE: 'Создать',
    CREATE_NEW: 'Создать новую',
    CREATED_BY: 'Создал',
    CREATED_IN_ONE_TO_ONE: 'Создан в 1-1',
    DATE_OF_ONE_TO_ONE: 'Дата 1-1',
    DECREASED: 'Понизился',
    DELETE_BUTTON_TOOLTIP:
      'Вы можете удалить 1-1,\ncозданный не более 1 месяца назад',
    DELETE_MODAL_CHANGES:
      'Вы уверены, что хотите удалить данную 1-1 встречу?\nЗначения всех заполненных полей будут стерты,\nвсе статусы примут первоначальные значения.',
    DELETE_MODAL_CONFIRMATION: 'Это действие не может быть отменено',
    DELETE_LAST_ONE_TO_ONE: 'У {employeeName} нет встреч один на один',
    DESCRIPTION: 'Описание',
    DISCUSSION: 'Обсуждение',
    EMPLOYEE_PERFORMANCE: 'Эффективность сотрудника',
    ERROR_REASON_FIELD: 'Причина задержки не может быть больше 200 символов',
    EMPTY: 'Пусто',
    EMPTY_ACTION_LIST: 'Список действий пуст',
    EXIT_MODAL_CHANGES: "Your changes won't be saved",
    EXIT_MODAL_CONFIRMATION: 'Do you really want to leave?',
    EXIT_MODAL_CONFIRMATION_LEAVE: 'Leave',
    EXTRA_MILE: 'Сверхусилие',
    EXTRA_LEAVE_FOR_HOIDAYS: 'Работа в праздничный день',
    EXTRA_LEAVE_FOR_HOIDAYS_INCURRENT_YEAR:
      'Количество доп дней отпуска за работу в Праздничные дни в текущем году',
    FIELD_EMPLOYEE_PLACEHOLDER: 'Поиск сотрудника',
    FIELD_NOTES: 'Заметки',
    FIELD_EMPLOYEE: 'Employee',
    FIELD_NOTES_PLACEHOLDER: 'Добавьте ваши комментарии',
    FILTER_COMPLETED: 'Завершенные',
    FILTER_MINE: 'Мои',
    FILTER_PLACEHOLDER: 'Фильтр по имени пользователя',
    FILTER_RESOLVED: 'Согласованные',
    FILTER_SHARED: 'Общие',
    FILTER_UNRESOLVED: 'Несогласованные',
    FILTER_UPCOMING: 'Предстоящие',
    FINISH: 'Завершить',
    GOALS: 'Цели',
    HAPPINESS_INDEX: 'Индекс счастья',
    HIGH: 'Высокий',
    HR: 'HR',
    IMPACT_OF_LEAVING: 'Влияние ухода',
    IMPACT_OF_LEAVING_REASON: 'Причина изменения влияния ухода',
    INCREASED: 'Повысился',
    ISSUES: 'Есть вопросы',
    LOOKS_GOOD: 'Выглядит хорошо',
    LOG: 'Описание',
    LOW: 'Низкий',
    MANAGER: 'Менеджер',
    ME: 'Я',
    MEDIUM: 'Средний',
    MONTHLY: 'Ежемесячно',
    NEW_ONE_TO_ONE: 'Новый 1-1',
    ON: 'На',
    ONE_TO_ONE: 'Один на один',
    ONE_TO_ONE_FILTER_CATEGORIES: {
      SUBORDINATES: 'Подчиненные',
      TYPE: 'Виды',
      SUBSCRIPTION: 'Подписка',
    },
    ONE_TO_ONE_FILTER_ITEMS: {
      ONLY_DIRECT: 'Только прямые',
      INDIRECT: 'Непрямые',
      MANAGER: 'Менеджер',
      SHOW_ONLY_SUBSCRIBED: 'Только подписки',
    },
    ONE_TO_ONE_SHARE_MODAL: 'Поделиться этим 1-1 с',
    ONE_TO_ONE_SHARE_MODAL_HINT:
      'Вы можете поделиться 1-1 с сотрудником с ролью People Management',
    ONE_TO_ONE_SHARING: 'Обмен 1-1',
    OTO_WITH: 'Один на один с',
    OVERALL_STATE: 'Общая оценка',
    PERFORMANCE: 'Эффективность',
    POTENTIAL: 'Потенциал',
    RECURRING: 'Повторяющиеся',
    REASON_OF_DELAY: 'Причина задержки',
    REGISTER_ATTRITION_BUTTON: 'Сохранить и зарегистрировать риск ухода',
    RESPONSE_DAY: 'День ответа',
    RISK_OF_LEAVING: 'Риск ухода',
    RISK_OF_LEAVING_REASON: 'Причина изменения риска ухода',
    SAVE_BUTTON_TOOLTIP: 'Заполните все обязательные поля',
    SELECT_EMPLOYEE: 'Выбрать сотрудника',
    SELECT_DATE: 'Выберите дату',
    SELECT_TIME: 'Выберите время',
    SHARE: 'Поделиться',
    SHARE_BUTTON_TOOLTIP: 'Обмениваться можно\nтолько созданными 1-1',
    SHARE_FEEDBACK_REPLY_TOOLTIP:
      'Вы можете поделиться\nтолько той обратной связью,\nна которую был получен ответ',
    SHOW_ONLY_DIRECT: 'Только прямые',
    SHOW_ONLY_DIRECT_TOOLTIP_CHECKED:
      'Показать one to ones всех своих подчиненных',
    SHOW_ONLY_DIRECT_TOOLTIP_UNCHECKED: 'Показать one to ones своего юнита',
    SHOW_ONLY_SUBSCRIBED: 'Только подписки',
    SUBSCRIBE_MODAL: {
      SUBSCRIBE_TO_ALL: 'Вы уверены, что хотите подписаться на всех?',
      UNSUBSCRIBE_FROM_ALL: 'Вы уверены, что хотите отписаться от всех?',
    },
    SUBSCRIBE_TO_ALL: 'Подписаться на всех',
    TYPE_REASON_FOR_DELAY: 'Введите причину задержки создания 1-1',
    TAB_MY_ONE_TO_ONES: 'Мои one to one встречи',
    TAB_SHARED_WITH_ME: 'Поделились со мной',
    TECHNICAL: 'Технические',
    TODOS: 'Задания',
    TOOLTIP: {
      ACTIVE_ROLES: 'Активные роли в этом проекте',
      ARCHIVE: 'В архив',
      AWESOME:
        'Сотрудник превышает ожидания, каким-либо образом проявил себя в течении месяца. В стрессовые моменты помог организовать работу команды на проекте, поддерживал моральных дух команды и помогал с задачами, которыми не должен заниматься.',
      BAD: 'Сотрудник подвел команду своей неорганизованностью, обманывал или игнорировал просьбы менеджера. Мешал работе команды.',
      DEPENDS_OF_VALUE: 'Это значение зависит\nот выбранных задач выше',
      GOOD: 'Сотрудник качественно выполнял свою работу. Делал все, что от него ожидается на его уровне. Активно принимал участие в коммуникации с другими членами команды, чтобы решать возникающие вопросы.',
      ISSUES:
        'Сотрудник выполнял свою работу качественно, но не попадал в эстимейты или не предупреждал вовремя о задержках. К сотруднику есть вопросы, которые необходимо решить, для обеспечения его дальнейшего роста. Нарушал дисциплину на проекте.',
      PAST_ROLES: 'Прошлые роли в этом проекте',
      RESTORE: 'Восстановить',
      SWITCH_ACTIVE: 'Сделать активным',
      SWITCH_INACTIVE: 'Сделать неактивным',
    },
    TYPE_SELECTION_MODAL_DESCRIPTION:
      'Выберите тип 1-1 в соответствии с вашей ролью',
    UNSUBSCRIBE_FROM_ALL: 'Отписаться от всех',
    WEEKLY: 'Еженедельно',
    WITH: 'С',
    //HR and Mentor
    ACTIONS: 'Действия',
    ARE_YOU_SHURE_WANT_DELETE_MENTOR:
      'Вы действительно хотите удалить ментора для выбранных сотрудников?',
    ARE_YOU_SHURE_WANT_DELETE_HR:
      'Вы действительно хотите удалить HR для выбранных сотрудников?',
    ALL_MENTORS_ASSIGNED: 'Все менторы были успешно назначены',
    ALL_HR_ASSIGNED: 'Все HR были успешно назначены',
    ALL_HRS_MENTORS_ASSIGNED: 'Все менторы и HR были успешно назначены',
    ALL_MENTORS_DELETED: 'Все менторы были успешно удалены.',
    ALL_HR_DELETED: 'Все hr были успешно удалены.',
    DELETE_MENTOR: 'Удалить ментора',
    DELETE_HR: 'Удалить HR',
    DELETION_FAILED_DUE_TO_A_SYSTEM_ERROR:
      'Не удалось выполнить удаление из-за системной ошибки. Пожалуйста, повторите попытку позже.',
    DELETION_WAS_APPLIED:
      'Удаление выполнено для всех выбранных сотрудников, кроме:',
    DUE_SYSTEM_ERROR:
      'из-за системной ошибки. Пожалуйста, повторите попытку позже.',
    EDIT_ASSIGNMENT: 'Редактировать назначение',
    EDIT_ASSIGNMENTS: 'Редактирование назначений',
    EMPLOYEES_WITHOUT_HR: 'Сотрудники без HR',
    EMPLOYEES_WITHOUT_MENTOR: 'Сотрудники без Ментора',
    EDIT_FAILED_DUE_TO_A_SYSTEM_ERROR:
      'Не удалось выполнить редактирование из-за системной ошибки. Пожалуйста, повторите попытку позже.',
    EDIT_RELATIONS_MODAL_NOTES:
      'Если указать HR или ментора, будет применено только выбранное значение.',
    EDIT_WAS_APPLIED:
      'Редактирование выполнено для всех выбранных сотрудников, кроме:',
    LIST_OF_ASSIGNED_EMLOYEES: 'Список назначенных сотрудников',
    MENTOR: 'Ментор',
    SELECT_AT_LEAST_ONE_EMPLOYEE: 'Выберите как минимум 1 сотрудника',
    HR_AND_MENTORSHIP: 'HR и Менторы',
    //feedbacks
    ALL_REPLYING_EMPLOYEES: 'Все отвечающие сотрудники',
    ALL_REQUESTING_MANAGERS: 'Все запрашивающие менеджеры',
    ALL_STATUSES: 'Все статусы',
    BUTTON_FEEDBACK_REQUEST: 'Feedback request',
    CANCEL_MODAL_CHANGES: "Your changes won't be saved",
    CANCEL_MODAL_CONFIRMATION: 'Do you really want to leave?',
    COL_DATE_OF_CHANGE: 'Дата изменения',
    COL_DEADLINE: 'Дедлайн',
    COL_EMPLOYEE: 'Сотрудник',
    COL_EMPLOYEE_PERFOMANCE: 'Эффективность сотрудника',
    COL_REPLYING_EMPLOYEE: 'Отвечающий сотрудник',
    COL_REQUESTING_MANAGER: 'Запрашивающий менеджер',
    COL_STATUS: 'Статус',
    COPY_REQUEST: 'Копировать',
    COPY_REQUEST_DESCRIPTION:
      'Мы сделаем копию запроса:\nсотрудник, и вопросы будут продублированы.\nВы хотите продолжить?',
    DELETE_LAST_FEEDBACK: 'У {employeeName} нет запросов на фидбэк',
    FEEDBACK_COMMENTS: 'Additional comments',
    FEEDBACK_PERIOD: 'Период',
    FEEDBACK_PERFOMANCE: 'Employee performance',
    FEEDBACK_REPLY: 'Feedback reply',
    FEEDBACK_REQUEST_DELETE_MODAL:
      'Вы уверены, что хотите удалить этот запрос?',
    FEEDBACK_SHARE_MODAL: 'Поделиться этим фидбэком с',
    FEEDBACK_SHARE_MODAL_HINT:
      'Вы можете поделиться фидбэком с сотрудником с ролью People Management',
    FEEDBACK_SHARING: 'Обмен фидбэком',
    FILTER_CLEAR: 'Очистить',
    FILTER_PENDING: 'Рассматриваемые',
    FILTER_RECEIVED: 'Полученные',
    FILTER_REPLIED: 'С ответом',
    FILTER_SELECT_ALL: 'Выбрать всё',
    FILTER_UNANSWERED: 'Без ответа',
    LOAD_MORE: 'Загрузить еще',
    NO_ACTION_ITEMS: 'No Action Items',
    NO_FEEDBACK: 'Нет обратной связи',
    NOTHING_TO_LOAD: 'Больше нечего загружать',
    SHOW_ARCHIVED: 'Показать заархивированные',
    SHOW_INQUIRED: 'Показать Inquired',
    SHOW_ONLY_DIRECT_FEEDBACK_CHECKED_TOOLTIP:
      'Показать feedback всех своих подчиненных',
    SHOW_ONLY_DIRECT_FEEDBACK_UNCHECKED_TOOLTIP:
      'Показать feedback своего юнита',
    TAB_FEEDBACK_REQUEST: 'My feedback requests',
    TAB_FEEDBACK_REPLY: 'Feedback to reply',
    OPTIONS_COPY: 'Make a copy',
    OPTIONS_SHARE: 'Share',
    RESET_ALL: 'Сбросить',
    REQUESTED_MANAGER: 'Запрашивающий менеджер',
    REQUEST_WINDOW: {
      ADD_QUESTION_BUTTON: '+ Добавить вопрос',
      ADDITIONAL_COMMENTS: 'Дополнительные комментарии',
      ADDITIONAL_COMMENTS_HINT:
        'будут автоматически добавлены в запрос на обратную связь',
      AND: 'and',
      DEADLINE: 'Дедлайн',
      DISCUSSED_IN: 'Обсуждался на',
      DUE_DATE: 'Время выполнения',
      EMPLOYEE: 'Сотрудник',
      EMPLOYEE_PERFORMANCE: 'Эффективность сотрудника',
      EMPLOYEE_PERFORMANCE_HINT: 'Данный блок также будет добавлен к запросу',
      EXIT_MODAL_CHANGES: 'Все изменения не сохранятся',
      EXIT_MODAL_CONFIRMATION: 'Вы действительно хотите выйти?',
      FEEDBACK_ON: 'Обратная связь на',
      FEEDBACK_PERIOD: 'Период',
      FROM: 'От',
      GENERAL_INFORMATION: 'Главная информация',
      NO_ANSWER: 'Нет ответа',
      ONE_TO_ONE_MEETING: 'встрече 1-1',
      PERFOMANCE_ASWESOME: 'Великолепно',
      PERFOMANCE_BAD: 'Плохо',
      PERFOMANCE_GOOD: 'Хорошо',
      PERFOMANCE_ISSUES: 'Проблемы',
      QUESTION: 'Вопрос',
      QUESTIONS: 'Вопросы',
      QUESTIONS_HINT: 'Вы можете добавить до 10 вопросов',
      QUESTION_PLACEHOLDER: 'Введите вопрос',
      REPLIED_BY: 'Заполнен',
      REPLIED_ON: 'Заполнен',
      REPLYING_EMPLOYEE: 'Отвечающий сотрудник',
      SECTIONS: 'Секции',
      TITLE_PLACEHOLDER:
        'Заголовок будет заполнен автоматически. Вы можете отредактировать позже.',
      TO_REPLY_BY: 'Заполняет',
      WHAT_BAD: 'Что было плохо',
      WHAT_GOOD: 'Что было хорошо',
      WHAT_IMPROVE: 'Что мы можем улучшить',
      YOUR_REQUEST: 'Ваш запрос',
    },
    STATUS_ARCHIVED: 'Archived',
    STATUS_COMPLETED: 'Completed',
    STATUS_DRAFT: 'Draft',
    STATUS_INQUIRED: 'Inquired',
    STATUS_READY: 'Ready',
    SUBORDINATE: 'Подчиненные',

    //maintenance
    FORM_ON_UPDATE: 'Форма обновляется!',
    EXPLANATION_OF_UPDATE:
      'В данный момент твои коллеги обновляют эту форму, и скоро всё заработает. Благодарим за терпение!',

    //action items
    CREATE_ACTION_ITEM_MODAL: 'Создать Action item',
    DEADLINE: 'Дедлайн',
    DELETE_ACTION_ITEM_MODAL:
      'Вы уверены, что хотите удалить этот action item?',
    EDIT_ACTION_ITEM_MODAL: 'Редактировать Action Item',
    STATUS_DONE: 'Done',
    STATUS_TODO: 'To do',

    //heatmap
    APPLY_FILTERS: 'Применить фильтр',
    CHOOSE_PERIOD: 'Выберите период, за который необходимо выгрузить данные',
    CURRENT_MONTH: 'Текущий месяц',
    DELETE_VIEW: 'Удалить выбранный набор фильтров?',
    DELETE_VIEW_EXPLANATION:
      'После удаления этот набор фильтров будет недоступен',
    DOWNLOAD_DATA: 'Выгрузить данные',
    GRADE: 'Уровень',
    HEATMAP: 'Хитмеп',
    HEATMAP_HINT: 'Чтобы открыть 1-1, нажмите на раздел таблицы',
    HEATMAP_REPRESENTATIVE_OFFICE: 'Офис разработки',
    PLACEHOLDER_CHOOSE_GRADES: 'Выберите грейды',
    PLACEHOLDER_CHOOSE_OFFICES: 'Выберите офисы',
    PLACEHOLDER_CHOOSE_PROJECTS: 'Выберите проекты',
    PLACEHOLDER_CHOOSE_SPECIALITIES: 'Выберите специальности',
    PLACEHOLDER_CHOOSE_TEAMS: 'Выберите команды',
    PREVIOUS_MONTH: 'Предыдущий месяц',
    RESET_FILTER: 'Сбросить фильтр',
    SAVE_VIEW: 'Сохранить фильтры',
    SAVE_VIEW_BUTTON: 'Сохранить',
    SAVE_VIEW_EXPLANATION:
      'Вы можете сохранить этот набор фильтров, чтобы использовать его в дальнейшем',
    SAVED_VIEWS: 'Сохраненные фильтры',
    SHOW_DISMISSED_EMPLOYEES: 'Показать уволенных сотрудников',
    SHOW_LAST_NEGATIVE_VALUE: 'Показать последнее отрицательное значение',
    TEAM: 'Команда',
    TYPE_ANY_NAME: 'Введите любое название',
    TYPE_ANY_TEXT: 'Введите любой текст',
    VIEW_DESCRIPTION: 'Краткое описание',
    VIEW_NAME: 'Название набора',
    UNIT: 'Юнит',

    //indicator
    HAPPINESS_EXCITED: 'Счастливый',
    HAPPINESS_FRUSTRATED: 'Расстроенный',
    HAPPINESS_GOOD: 'Хорошо',
    HAPPINESS_GREAT: 'Довольный',
    HAPPINESS_NEUTRAL: 'Нейтральный',
    PERFOMANCE_ASWESOME: 'Awesome',
    PERFOMANCE_BAD: 'Bad',
    PERFOMANCE_EXCEED_EXPECTATIONS: 'Превосходит ожидания',
    PERFOMANCE_GOOD: 'Good',
    PERFOMANCE_ISSUES: 'Issues',
    PERFOMANCE_MEET_EXPECTATIONS: 'Соответсвует ожиданиям',
    PERFOMANCE_NEED_IMPROVEMENT: 'Нуждается в совершенствовании',
    PERFOMANCE_OUTSTANDING: 'Выдающийся',
    PERFOMANCE_UNACCEPTABLE: 'Неприемлемый',
    RISK_HIGH: 'Высокий',
    RISK_LOW: 'Низкий',
    RISK_MEDIUM: 'Средний',

    //happiness index legend
    HAPPINESS_EXCITED_LEGEND:
      'Полон энтузиазма и энергии, с радостью принимает любые вызовы и излучает оптимизм.',
    HAPPINESS_FRUSTRATED_LEGEND:
      'Ощущает недовольство, беспокойство из-за команды, проекта или своего собственного прогресса и часто переживает стресс и разочарование в работе.',
    HAPPINESS_GOOD_LEGEND:
      'Находится в равновесии, чувствует спокойствие и принимает текущую ситуацию и будущие планы с умиротворенным и спокойным умом.',
    HAPPINESS_GREAT_LEGEND:
      'Доволен жизнью, проектом и командой, находит радость в задачах и испытывает чувство удовлетворения и радости.',
    HAPPINESS_NEUTRAL_LEGEND:
      'Остается безразличным к событиям, лишен энтузиазма, не испытывает ни радости, ни разочарования, сохраняет спокойствие.',

    //impact legend
    IMPACT_LOW_LEGEND:
      'Сотрудник не участвовал в каких-либо видах непроектной деятельности. Его проектный опыт может быть передан без дополнительных усилий.',
    IMPACT_MEDIUM_LEGEND:
      'Сотрудник обладает важным опытом работы над проектами и/или участвует в дисциплинарной или общей деятельности. Однако риски, связанные с его уходом, можно было бы смягчить превентивными мерами без чрезмерных затрат.',
    IMPACT_HIGH_LEGEND:
      'Сотрудник играет решающую роль в своем проекте или участвует в важных бизнес-процессах. Поэтому его уход существенно повлияет на реализацию проекта или успех бизнеса.',

    //risk legend
    RISK_LOW_LEGEND:
      'Сотрудник полностью удовлетворен своим текущим проектом, перспективами, планами и договоренностями, достигнутыми с компанией. Лояльность высокая.',
    RISK_MEDIUM_LEGEND:
      'Сотрудник не удовлетворен своим текущим положением. Начинает искать на рынке труда дополнительные возможности. Или собирается это сделать.',
    RISK_HIGH_LEGEND:
      'Сотрудник рассматривает предложение о работе от другой компании. Уходящий.',

    //performance legend
    PERFORMANCE_OUTSTANDING:
      'Высокая эффективность. Результаты его работы постоянно превосходят ожидания. Множество достижений и положительных отзывов. Положительно влияет на реализацию проекта или бизнес компании. Коллегам и партнерам приятно работать с ним.',
    PERFORMANCE_EXCEED_EXPECTATIONS:
      'Высокая или средняя эффективность. Результаты его работы иногда превосходят ожидания. Имеет некоторые достижения и положительные отзывы. Положительно влияет на реализацию проекта или успех организации. Коллеги и партнеры рекомендуют его как будущего коллегу.',
    PERFORMANCE_MEET_EXPECTATIONS:
      'Средняя эффективность. Результаты его работы всегда соответствуют ожиданиям. Иммет некоторые достижения и положительные или нормальные отзывы. Следует планам роста.',
    PERFORMANCE_NEED_IMPROVEMENT:
      'Сотрудник получил отрицательный отзыв. Имеет некоторые трудности с выполнением планов, и такая ситуация уже началась или вот-вот начнется, что негативно повлияет на реализацию проекта или общий бизнес. План действий должен быть разработан немедленно.',
    PERFORMANCE_UNACCEPTABLE:
      'Низкая эффективность. Результаты его работы негативно сказываются на выполнении проекта или общем бизнесе. Получал отрицательные отзывы более одного раза. Коллеги и партнеры не хотят работать с ним/ней в одной команде. Токсичность.',

    //extra mile legend
    EXTRA_MILE_LOW:
      'Сотрудник с трудом справляется со своей работой и не может быть загружен дополнительно.',
    EXTRA_MILE_MEDIUM:
      'Сотрудник хорошо справляется со своей работой, но не стремится брать дополнительные задачи.',
    EXTRA_MILE_HIGH:
      'Сотрудник стремится достичь значимых результатов в своей работе и готов к более сложным задачам.',

    //potential legend
    POTENTIAL_LOW:
      "Cотрудник 'застрял' на своем уровне и не хочет развиваться.",
    POTENTIAL_MEDIUM:
      'У сотрудника есть потенциал к росту и желание изучать новую информацию, но нужна дополнительная мотивация.',
    POTENTIAL_HIGH:
      'Сотрудник стремится достичь значимых результатов в своей работе и готов к более сложным задачам.',

    // mood statistics
    HIDE_WEEKEND: 'Hide weekend',
    MOOD_STATISTICS: 'Показатели настроения',
    SHOW_ONLY_FILLED_MOODS: 'Показать только заполненное настроение',

    //employees
    ADDRESS: 'Адрес',
    AND: 'И',
    APPLY_FILTER: 'Применить фильтр',
    APPRENTICESHIP_END_DATE: {
      TITLE: 'Срок ученического договора',
      FILTER_OPTIONS: {},
    },
    ARCHIVE_MODE: 'Режим архива',
    BRANCH: 'Отдел',
    CONTACT_INFO: 'Дополнительные контакты',
    CORPORATE_EMAIL: 'Корпоративная почта',
    DATE_OF_DISMISSAL: 'Дата увольнения',
    DATE_OF_END_COOPERATION: 'Дата завершения сотрудничества',
    EMPLOYEE: 'Сотрудник',
    EMPLOYEE_DATE_OF_START_COOPERATION: 'Дата начала сотрудничества',
    EMPLOYEE_DATE_OF_START_WORK: 'Дата начала работы в компании',
    EMPLOYEE_EMAIL: 'Корпоративная почта',
    EMPLOYEE_NAME: 'Employee name',
    EXACT_MATCH: 'Точное совпадение',
    EXCLUDE: 'Исключить',
    FEEDBACK: 'Обратная связь',
    FORM_INTERACTION: 'Форма взаимодействия',
    FORM_INTERACTION_WITH_COMPANY: 'Форма взаимодействия с компанией',
    FROM_ONE_YEAR: '1-3 года',
    FROM_THREE_MONTHS: 'от 3 месяцев до 1 года',
    FULLNAME: 'ФИО',
    GROUP: 'Направление',
    INTERNSHIP_COMPLETION_DATE: 'Дата завершения стажировки',
    INTERNSHIP_START_DATE: 'Дата начала стажировки',
    LEAVE_FEEDBACK: 'Оставить фидбэк',
    LESS_THREE_MONTHS: 'менее 3-х месяцев',
    LOCATION: 'Локация',
    MORE_THREE_YEARS: 'более 3-х лет',
    OR: 'Или',
    ORGSTRUCTURE_LEVEL: 'Уровень на оргструктуре',
    OFFICE: 'Офис',
    PARTNER_COMPANY: 'Компания партнера',
    PERSONAL_EMAIL: 'Личная почта',
    PRIVATE_EMAIL: 'Личная почта',
    PROFESSIONAL_LEVEL: 'Уровень опыта',
    RATE_PERIOD: 'Период ставки',
    REPRESENTATIVE_OFFICE: 'Офис разработки',
    REQUEST: 'Запросить',
    SEARCH_EMPLOYEE: 'Поиск сотрудника',
    RESET_FILTERS: 'Сбросить',
    SHOW_COMPLETED_INTERNSHIP: 'Показать окончивших стажировку',
    SHOW_DISMISSED: 'Показать уволенных',
    SHOW_TERMINATED_PARTNERSHIP: 'Показать завершенные партнерства',
    SPECIALIZATION: 'Специализация',
    TEAM_POSITION: 'Должность в  команде',
    IN_TOTAL: 'Всего',
    TRAINEES: 'Стажеры',
    TRIAL_EXIST: 'Есть',
    TRIAL_NO_EXIST: 'Нет',
    TRIAL_PERIOD: 'Испытательный срок',
    WITHOUT_DATA: 'Отсутствует',
    WORK_EXPERIENCE_IN_COMPANY: 'Стаж работы в компании (мес.)',
    WORK_EXPERIENCE_BEFORE_THE_COMPANY: 'Общий стаж по трудовой книжке (год.)',

    //projects
    ACTIVE_POSITIONS: 'Активные позиции',
    ADD: 'Добавить',
    ADD_POSITION: 'Добавить позицию',
    ALLOCATED_EMPLOYEES: 'Назначено сотрудников',
    ALLOCATED_TIME: 'Выделенное время',
    BRANCH_MEMBER_CANNOT_BE_ADDED: "Нельзя назначить роль 'Branch member'",
    CREATE_NEW_PROJECT: 'Создать новый проект',
    EMPLOYEE_CANNOT_BE_INACTIVE:
      'Невозможно убрать сотрудника из активных членов команды проекта, так как он является членом соответсвующего отдела',
    ENTER_PROJECT_DESCRIPTION: 'Введите описание проекта',
    ENTER_PROJECT_NAME: 'Введите название проекта',
    ERROR_EMPTY_PROJECT: 'Название проекта не может быть пустым',
    FILTER_ACCEPTANCE: 'Согласован',
    FILTER_ALL: 'Все',
    FILTER_CLOSED: 'Закрыты',
    FILTER_HOLD: 'Приостановлен',
    FILTER_NA: 'Н/Д',
    FILTER_NONE: 'Нет',
    FILTER_OPERATIONAL: 'Скрыть операционные',
    FILTER_PROGRESS: 'В работе',
    FILTER_TROUBLESHOOTING: 'Проблемы',
    FIXED_PROJECT_CAPACITY: 'Фиксированная загрузка проекта (ч)',
    GITLAB_PROJECT: 'Gitlab проект',
    MAX_POSITION_NAME:
      'Максимальное допустимое количество символов в имени позиции: ',
    NEW_PROJECT: 'Новый проект',
    NO_ACTIVE_CONTRACT_FOR_CURRENT_DATE:
      'Нет активного контракта на текущую дату',
    NO_ACTIVE_CONTRACTS_AVAILABLE:
      'Для данного проекта отсутствуют активные контракты',
    NUMBER_OF_EMPLOYEES_COUNT: 'Количество сотрудников, назначенных на позицию',
    ONLY_ACTIVE_PROJECTS: 'Только активные проекты',
    OUTLINE_GROUP: 'Outline группа',
    PROJECT_BASED: 'Основанный на проекте',
    PROJECT_DESCRIPTION: 'Описание проекта',
    PROJECT_NAME: 'Название проекта',
    ROLE_CANNNOT_BE_DELETED:
      'Невозможно удалить роль, так как сотрудник находится в соответствующем отделе',
    SEARCH_POSITION: 'Найти позицию',
    SELECT_CONTRACT: 'Выберите контракт',
    SELECT_GRADE: 'Выберите грейд',
    SELECT_SPECIALISATION: 'Выберите специализацию',
    SHOW_CARDS: 'Плитка',
    SHOW_LIST: 'Список',
    SPECIAL_CONTROL: 'Специальный контроль',
    SUPPORT_SLA: 'Поддержка SLA',
    TECH_STACK: 'Технологический стек',
    TIME_SOURCE: 'Источник отслеживания времени',
    TYPE_IN_POSITION_NAME: 'Вбейте название позиции',
    TOOLTIPS: {
      PROJECT_IS_NOT_OPERATIONAL: 'Тип проекта не операционный',
      PROJECT_TYPE_CANNOT_BE_CHANGED:
        'Тип проекта не может быть изменен пока в поле "Отдел" установлено значение отдела',
    },
    WORK_ORDER: 'Рабочий заказ',

    HARD_SKILLS: 'Hard-навыки',
    INACTIVE_POSITIONS: 'Неактивные позиции',
    POSITION_SUCCESSFULLY_ADDED: 'Позиция успешно добавлена',
    POSITION_SUCCESSFULLY_DELETED: 'Позиция успешно удалена',
    POSITION_SUCCESSFULLY_UPDATED: 'Позиция успешно обновлена',
    POSITION_DELETE_CONFIRMATION:
      'Вы уверены, что хотите удалить данную позицию? Значения всех заполненных полей будут стерты.',
    SKILLS: 'Навыки',
    SOFT_SKILLS: 'Soft-навыки',

    //delivery units
    CREATE_DELIVERY_UNIT: 'Создать delivery unit',
    EDIT_DELIVERY_UNIT: 'Редактировать delivery unit',
    DELETE_MODAL_CONFIRM:
      'Вы уверены, что хотите удалить этот Delivery Unit?\nЭто действие не может быть отменено',
    DELETE_MODAL_PROJECTS_EXITS:
      'Чтобы удалить Delivery Unit, убедитесь\nчто он не содержит проектов',
    DELETE_UNIT: 'Удалить Юнит',
    WORKING_TIME_CONTROL: 'Контроль рабочего времени',
    DELIVERY_MANAGER: 'Delivery менеджер',
    DELIVERY_MANAGERS: 'Delivery менеджеры',
    DELIVERY_UNITS: 'Деливери юниты',
    NEW_UNIT: 'Новый юнит',
    PROJECTS_MANAGERS: 'Проектные менеджеры',

    KEY: 'Ключ',
    PROJECT: 'Проект',
    TOTAL: 'Итог',

    BALANCE: 'Баланс',
    CURRENT_WEEK: 'Текущая неделя',
    MONTHLY_BUDGET: 'Месячный бюджет',
    NEXT_WEEK: 'Следующая неделя',
    PREVIOUS_WEEK: 'Предыдущая неделя',
    SECOND_WEEK: 'Вторая неделя',
    TITLE: 'Заголовок',
    VALUE: 'Значение',
    WORKED_OUT_HOURS: 'Отработанные часы',

    //project
    ACCOUNT: 'Аккаунт',
    APPROVE_VACATION: 'Согласование отпусков с клиентом',
    BASIC_INFO: 'Базовая информация',
    BUDGET_TRACKING: 'Отслеживание бюджета',
    CONTRACT: 'Договор',
    CONTRACT_CANT_BE_ADDED:
      'Контракт не может быть добавлен, если у позиции есть активные аллокации',
    COMMERCIAL: 'Коммерческий',
    COPY_POSITION: 'Скопировать позицию',
    CLIENT_INFO: 'Информация о клиенте',
    DELIVERY_UNIT: 'Деливери юнит',
    DOCUMENTS: 'Документы',
    MAIN_GOAL: 'Основная цель проекта',
    NO_BRANCH: 'Нет отдела',
    NON_COMMERCIAL: 'Некоммерческий',
    NPS_STATUS: 'NPS статус',
    OPERATIONAL: 'Операционный',
    OVERALL_STATUS: 'Общий статус',
    OVERVIEW: 'Общий статус',
    PROJECT_BUDGET: 'Бюджет',
    PROJECT_CASES: 'Кейсы',
    PROJECT_HEALTH: 'Состояние здоровья проекта',
    PROJECT_NEEDS: 'Нужды',
    PROJECT_TEAM: 'Проектная команда',
    PROJECT_TYPE: 'Тип проекта',
    RISKS: 'Риски',
    SCHEDULE: 'Расписание',
    SOWS: 'Sows',
    TIME_REPORTING: 'Отчетность по времени',
    WHAT_ABOUT: 'Описание проекта',
    VALID_LINK: 'Введите валидную ссылку.',

    BUDGET_FILE: 'Бюджетный файл',
    CONTACT_COUNTRY: 'Страна',
    FLOAT_PROJECT: 'Float проект',
    GIT: 'GIT',
    GMAIL_GROUP: 'Gmail Group',
    GOOGLE_DRIVE: 'Google Drive',
    JIRA_KEY: 'Ключ Jira',
    JIRA_URL: 'Адрес Jira',
    MANAGEMENT_LEVEL: 'Уровень управления',
    MANAGEMENT_TYPE: 'Тип менджмента',
    NDA: 'NDA',
    NPS: 'NPS',
    PIVOTAL: 'Pivotal',
    PRODUCTION: 'Production',
    PROJECT_BRIEF: 'Краткое описание',
    SCHEDULE_URL: 'План проекта',
    SPIRA: 'Spira',
    STAGING: 'Staging',
    WRONG_URL: 'Введите валидную ссылку',
    FLOAT_REMOVED: 'Проект удален с Float.com',
    REFRESH_FLOAT: 'Синхронизировать с Float',
    SUBMIT_CHANGES: 'Сохранить изменения',
    ACTIVE_MEMBERS: 'Активные участники',
    ADDITIONAL_EMAILS: 'Дополнительная почта',
    ADDITIONAL_INFO: 'Доп. информация',
    ADD_CLIENT: 'Добавить клиента',
    ADD_NEW_MEMBER: 'Добавить нового участника',
    CLIENT: 'Клиент',
    COOPERATION_FINISHED: 'Завершение сотрудничества',
    COOPERATION_STARTED: 'Начало сотрудничества',
    COMPANY_NAME: 'Название компании',
    ENTER_CLIENT_PLACEHOLDER: 'Введите ',
    FIRST_NAME: 'Имя',
    INACTIVE_MEMBERS: 'Неактивные участники',
    LAST_NAME: 'Фамилия',
    PHONE: 'Телефон',
    SPECIFIC_PERSON: 'Конкретное лицо',
    TIME_ZONE: 'Временная зона',
    WEBSITE_URL: 'Адрес сайта',
    DEPLOYMENT_TOOLS: 'Технологии развертывания (деплоя)',
    TECH_USED: 'Использованы технологии',
    SELECT_SKILL: 'Выберите технологию',
    DETAILING: 'Детализация',
    GOOGLE_TABLE: 'Google Table',
    INVOICE_SENDER: 'Отправитель счета',
    REPORTER: 'Докладчик',
    REPORTER_NOT_SELECTED: 'Докладчик не выбран',
    REPORT_FREQ: 'Частота отчетности',
    REVIEWER: 'Рецензент',
    SEND_PDF: 'Отправить PDF клиенту',
    SAVE_TIME_REPORTING: 'Сохранить отчет',
    UPDATE_POSITION: 'Обновить позицию',
    VIEW_ALLOCATION: 'Посмотреть аллокацию',

    //lk settings
    ATTENTION_TITLE:
      'Чтобы настроить уведомления сначала сохраните настройки вашего часового пояса',
    CHOOSE_TIME_ZONE: 'Выберите свой часовой пояс',
    COMMENTS_CHOICE: {
      ACKNOWLEDGED: 'Прочитано',
      APPROVED: 'Утверждено',
      REJECTED: 'Отклонено',
    },
    CONTROLS: {
      APPROVED: 'Подтвердить',
      INPUT_TEXT: 'Отправить',
      REJECTED: 'Отклонить',
    },
    FORM_SETTINGS: 'Настройки форм',
    INST_LINK: 'Ссылка на ваш профиль Instagram',
    LANGUAGE_SETTINGS: 'Настройка языка',
    LINKEDIN_LINK: 'Ссылка на ваш профиль LinkedIn',
    LINK_ALERT: 'Пожалуйста, укажите корректную ссылку',
    ENGLSIH: 'Английский',
    LK_SETTINGS: {
      ALWAYS: 'Всегда',
      ENGLISH: 'English',
      NEITHER: 'Никакой',
      NEVER: 'Никогда',
      NO: 'Нет',
      ONLY_IN_WORK_TIME: 'Только в рабочее время',
      RUSSIAN: 'Русский',
      VACATION: 'В отпуске',
      YES: 'Да',
    },
    NOTIFICATION_SETTINGS: 'Настройки уведомлений',
    PROFILE_SETTINGS: 'Настройки профиля',
    RECEIVE_NOTIFICATIONS: 'Получать уведомления:',
    RECEIVE_SLACK_NOTIFICATIONS: 'Получать уведомления в Slack:',
    SAVE_SETTINGS: 'Сохранить настройки',
    SOCIAL_LEAVE_DAYS: 'Дополнительные отпуска (социальные)',
    SOCIAL_LEAVE_DAYS_IN_CURRENT_YEAR:
      'Количество дополнительных (социальных) дней отпуска в текущем году',
    SOCIAL_LINKS: 'Ссылки на социальные сети',
    STATUS_SETTINGS: 'Настройки статуса',
    STATUS_TYPE: 'Статус, который видят другие пользователи:',
    SYSTEM_LANGUAGE: 'Выберите язык системы',
    TIME_ZONE_SETTINGS: 'Настройки часового пояса',
    VIEW_STATUS: 'Показывать ваш статус "Онлайн" другим пользователям:',
    VK_LINK: 'Ссылка на ваш профиль VK',

    DROP_ZONE_TEXT: 'Перетащите сюда файл или щелкните, чтобы выбрать его',

    INVALID_LINK: 'Неправильная ссылка',
    LINK_TO_FILE_LABEL: 'Ссылка на картинку',
    LINK_TO_FILE_PLACEHOLDER:
      'Добавьте ссылку или вставьте изображение, нажав Ctrl+V',
    LINK_TO_FILE_FIREFOX_PLACEHOLDER:
      'Добавьте ссылку на изображение, нажав Ctrl+V',
    PASTE_FROM_CLIPBOARD: 'Вставьте из буфера',
    PASTE_TO_UPLOAD: 'Вставьте изображение из буфера обмена',
    PYRUS_FORM_DROP_ZONE_TEXT: {
      DRAG_AND_DROP: 'Перетащите сюда файлы',
      CLICK_TO_UPLOAD: 'щелкните, чтобы выбрать их',
    },
    SELECT_FILES: 'Выберите файл',

    //calendar
    CALENDAR_DIDNT_EXIST:
      'Невозможно отобразить календарь на текущий год, так как он еще не назначен.',
    CALENDAR_STATES: {
      APPROVED: 'Одобрен',
      CANCELLED: 'Отменён',
      CREATED: 'Создан',
      DAYOFF: 'Праздник',
      IN_PROGRESS: 'В процессе',
      PAID_VACATION: 'Оплачиваемый отпуск',
      PAID_AND_UNPAID_VACATION: 'Оплачиваемый отпуск и отпуск за свой счет',
      PAID_AND_UNPAID_SICK_LEAVE: 'Больничный и неоплачиваемый больничный',
      REMOTE_WORK: 'Удалённая работа',
      SICK_LEAVE: 'Больничный',
      TRANSFER_DAY: 'Перенос дня',
      TRANSFER_TIME: 'Перенос времени',
      UNPAID_VACATION: 'Неоплачиваемый отпуск',
      USED: 'Использован',
    },
    CALENDAR: 'Календарь',
    CALENDAR_CARD_TOOLTIP_TEXT: 'Показать в календаре',
    CALENDAR_FILTER_NO_FILTERED_EVENTS:
      'Нет результатов \n по выбранным фильтрам.',
    CALENDAR_FILTER_NO_EVENTS: 'Нет ООО событий.',
    CALENDAR_FILTER_POPUP_CLEAR_ALL: 'Очистить все',
    CALENDAR_FILTER_POPUP_TITLE: 'Статусы событий',
    CALENDAR_NO_POLICY_LINKS: 'Нет ссылок',
    CALENDAR_POLICY_LINKS_TITLE: 'Ссылки на политики',
    CALENDAR_STATISTICS_BAR: {
      USED: 'Исп.',
      PLANNED: 'План.',
      PLANNED_EXPLAIN:
        'Количество дней отпуска, которые были подтверждены сотруднику.',
      LEFT: 'Ост.',
      TOTAL: 'Всего',
      TOTAL_EXPLAIN:
        'Количество дней отпуска, которые могут быть использованы в текущем году (без учета выходных и праздничных дней).',
      EARNED: 'Всего зараб.',
      EARNED_EXPLAIN:
        'Количество всего заработанных дней отпуска, которые можно использовать на текущий момент без учета авансовых дней.(Выходные и праздничные дни - не включены).',
      AVAILABLE_EXPLAIN:
        'Количество дней отпуска, которые можно использовать на текущий момент (доступные дни = накопленные дни + авансовые дни).',
    },
    CALENDAR_VIEW: 'Календарь',
    FLOATING_HOLIDAY: 'Плавающий выходной',

    // timeportal
    ADD_ALLOCATION: 'Добавить аллокацию',
    ALLOCATION: 'Аллокация',
    ALLOCATION_MODAL_ERROR: {
      ALLOCATION_TYPES_CAN_NOT_REPEAT: 'Типы аллокаций не могут повторяться',
      EMPTY_EMPLOYEE: 'Сотрудник должен быть выбран',
      EMPTY_TASKS: 'Должна быть выбрана хотя бы одна задача',
      NO_ALLOCATION_TYPES: 'Проекту еще не назначены типы аллокаций',
      PERIOD_REQUIRED: 'Allocation Period is required',
      TIME_PER_DAY_GREATER_THAN: 'время в день должно быть больше чем 0h 0m',
      TIME_PER_DAY_LESS_THAN:
        'Время в день должно быть меньше или равно 12 часам',
      TOTAL_TIME_NOT_EQUAL_TIME_PER_DAY:
        'Общее время, распределенное по всем типам, должно соответствовать установленному дневному лимиту в {h} часов {m} минут',
    },
    ALLOCATION_TYPE: 'Тип аллокации',
    ALLOCATION_START_DATE: 'Дата начала',
    ALLOCATION_END_DATE: 'Дата окончания',
    ALLOCATIONS: 'Аллокации',
    ALLOCATIONS_IN_DAYS: 'Аллокации в днях',
    COPY_ALLOCATION: 'Скопировать аллокацию',
    CREATE_ALLOCATION: 'Создать аллокацию',
    DELETE_ALLOCATION: 'Удалить аллокацию',
    DELETE_ALLOCATION_MESSAGE: 'Вы уверены, что хотите удалить эту аллокацию?',
    DELETE_TASK: 'Удалить задачу',
    DELETE_TASK_MESSAGE: 'Вы уверены, что хотите удалить эту задачу?',
    ALLOCATION_PERIOD: 'Период аллокации',
    ALLOCATION_PERIOD_CHANGED:
      'Периоды аллокаций были изменены для всех выбранных сотрудников.',
    ALLOCATION_PERIOD_NOT_CHANGED:
      'Периоды аллокаций для нескольких выбранных сотрудников не были изменены.',
    ALLOCATION_START_DATE_CANNOT_BE_UPDATE:
      'Невозможно обновить аллокацию, так как у сотрудника уже есть аллокация с той же задачей на тот же период',
    AUTO_TRACKING_TEXT_PLACEHOLDER: 'Введите описание для задачи авто трекинга',
    CAPACITY_GAP: 'Ниже нормы',
    CANT_BE_SHORTENED: 'Невозможно сократить, так как в задаче есть ворклоги.',
    CANT_BE_SHORTENED_AS_ALLOCATION:
      'Невозможно сократить, так как тип аллокации заархивирован.',
    DM_PLANNED_TIME: 'DM planned time',
    EDIT_ALLOCATION_PERIOD: 'Изменить период аллокаций',
    END_DATE_CANNOT_BE_ERLIER:
      'Дата окончания не может быть раньше даты начала.',
    HOURS_PER_DAY: 'Часов в день',
    LIST_VIEW: 'Список',
    LAST_EDITED_BY: 'Последнее изменение',
    NO_ALLOCATION_TYPES:
      'There are no Allocation types assigned to the project.\nPlease contact Administrator',
    NO_ALLOCATIONS: 'No Allocations',
    SEARCH_BY_POSITION: 'Поиск по позиции',
    TASK_CANT_BE_DELETED:
      'Задача, в которой есть ворклоги, не может быть удалена',
    TASK_FOR_TRACKING_JIRA:
      'Задача для отслеживания из Jira создается автоматически',
    TIME_OFF: 'События',
    TIME_PER_DAY: 'Время в день',
    TIME_TRACKING: 'Трекинг времени',
    TIME_TRACKING_MANAGEMENT: 'Time Tracking Management',
    THE_CONTRACT_PERIOD_DOES_NOT_MATCH_PERIOD:
      'Период контракта не соответствует выбранному периоду.',
    OVERTIME: 'Выше нормы',
    UPDATE_TASK: 'Обновить задачу',
    UPDATE_ALLOCATION: 'Обновить аллокацию',
    VACATIONS_AND_SICK_LEAVES: 'Отпуска и больничные',
    WARNING_NO_ALLOCATION_TYPES:
      'There are no Allocation types assigned to the project.\nPlease contact Administrator',
    WARNING_NO_EMPLOYEES:
      'There are no active employees assigned to the project',
    NO_POSITIONS_CREATED_FOR_PROJECT:
      'There are no positions assigned to the project',
    WARNING_NO_TASKS: 'There are no tasks assigned to the project',
    WORKLOAD_ISSUES: 'Проблемы с загрузкой',
    ALLOCATION_DISCARDED_AT_WARNING_MESSAGE:
      'Дата окончания всех связанных аллокаций будет изменена на указанную дату архивации, если дата архивации наступит раньше.',
    DISABLED_DELETE_TASK_BUTTON_MESSAGE:
      'Эту задачу нельзя удалить: у нее есть связанные аллокации',

    //timetracking
    ADD_WORKLOG: 'Добавить ворклог',
    ENTER_JIRA_TASK: 'Укажите задачу Jira.',
    REASON_OF_UNCHANGED: 'Причина, по которой даты не были изменены',
    LOGGED_WORKLOGS: 'Внесенное время',
    LOG_IN_JIRA: 'Войти в Jira',
    PERIOD_SHOULD_CORRESPOND_CONTRACT:
      'Период должен соответствовать контракту (при наличии), связанному с Позицией',
    SEVERAL_DATES: 'Период',
    TO_ADD_WORKLOG_YOU_NEED_LOGIN_JIRA:
      'Чтобы добавить рабочий лог, вам нужно войти в Jira.',
    THIS_TASK_UNAVAILABLE_FOR_TIME_TRACKING:
      'Задача недоступна для трекинга. Проверьте Jira или свяжитесь с менеджером.',
    INVALID_JIRA_TASK_FORMAT:
      'Недопустимый формат задачи. Введите в формате ABC-123 или 123.',
    IF_YOU_SELECT_MORE_THAN_ONE_DAY_WORKLOGS:
      'При выборе более 1 дня, ворклоги добавятся только на рабочие дни',
    YOU_NOT_A_MEMBER_OF_JIRA_PROJECT:
      'Вы не участник данного проекта в Jira. Обратитесь к менеджеру проекта для получения доступа.',

    //vacations_analytics
    AVAILABLE_VACATION_DAYS: 'Доступно отпусков (включая авансовые)',
    AVAILABLE_VACATION_DAYS_AT_THE_END_OF_YEAR:
      'Доступно отпусков на 31 декабря текущего года',
    CHOOSE_PROJECT: 'Выберите проект',
    EARNED_VACATION_DAYS: 'Заработано дней отпуска',
    PLANNED_VACATION_DAYS: 'Запланировано дней отпуска',
    VACATIONS_ANALYTICS: 'Аналитика по остаткам отпусков',

    //tools
    AGREEMENT: 'Согласование',
    BAD: 'Плохо',
    DIFFTIME: 'Всего затрачено рабочего времени',
    ENDDATE: 'Дата окончания',
    GOOD: 'Хорошо',
    HEAD_DEVELOPMENT: 'Сотрудники с событиями',
    SOURSCERS: 'Источники SLA',
    STARTDATE: 'Дата начала',
    TOOLS: 'Инструменты',
    TYPE_VACATION: 'Тип отпуска',

    //People management
    PEOPLE_MANAGEMENT: 'Управление людьми',
    SUPPORT_LINK: 'Send your feedback\nto our Support channel',

    //sla forms
    CHOOSE_FILE: 'Выберите файл',
    CHOOSE_FORM: 'Выберите форму',
    DOWNLOAD: 'Скачать',
    FILE: 'Файл',
    UPLOAD: 'Загрузить',

    GOOGLE_SIGN_IN: 'Войти через Google',
    LEGEND: 'Легенда',
    MESSAGE_SENT: 'Сообщение отправлено',

    //user_limits_modal
    DATES_VALIDATION_MESSAGE:
      'Необходимо заполнить дату начала работы либо дату начала стажировки',
    USER_MODAL_NAME: 'Редактирование лимитов сотрудника',
    WORKING_WITH_THE_CALENDAR: 'Работает по календарю:',

    //profile
    BACK_TO_PROFILE: 'Назад к профилю',
    EDIT_PROFILE: 'Редактировать профиль',
    REMOTE_WORKER: 'Удалённый работник',
    SHOW_ALL_STATUSES: 'Показать все статусы',

    //created tasks
    EDITED_FIELDS: 'изменил(а) поля',
    TASK_STATE: {
      ACTIVE: 'активна',
      CLOSED: 'закрыта',
      FINISHED: 'завершена',
      REOPENED: 'переоткрыта',
    },
    RECALCULATE_DATE: 'дней от даты создания задачи',
    RECALCULATE_DATE_CHECKBOX: 'Расчитать при создани',
    TIME_OFF_TOOLTIP: {
      TRANSFER_FROM_TO: 'Работает {to} вместо {from}',
      TRANSFER_FROM: 'Перенос дня на {to}',
      TRANSFER_TO: 'Отработка за {from}',
      SICK_LEAVE: 'Больничный',
      VACATION: 'Отпуск',
    },
  },
})
